




// import React, { useState } from "react";
// import {
//   Grid,
//   Typography,
//   Box,
//   Button,
//   Container,
//   Card,
//   CardContent,
//   useTheme,
//   Fade,
//   Chip,
//   Stack,
//   alpha,
//   IconButton,
// } from "@mui/material";
// import { keyframes } from "@emotion/react";
// import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
// import ScheduleIcon from "@mui/icons-material/Schedule";
// import PaymentIcon from "@mui/icons-material/Payment";
// import SupportAgentIcon from "@mui/icons-material/SupportAgent";
// import StarIcon from "@mui/icons-material/Star";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import ApartmentIcon from "@mui/icons-material/Apartment";
// import BathtubIcon from "@mui/icons-material/Bathtub";
// import KitchenIcon from "@mui/icons-material/Kitchen";
// import WeekendIcon from "@mui/icons-material/Weekend";
// import YardIcon from "@mui/icons-material/Yard";
// import QrCode2Icon from "@mui/icons-material/QrCode2";
// import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
// import AppleIcon from "@mui/icons-material/Apple";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import MobileIcon from "@mui/icons-material/MobileFriendly";

// // Animations
// const floatAnimation = keyframes`
//   0%, 100% { transform: translateY(0px) rotate(0deg); }
//   50% { transform: translateY(-10px) rotate(2deg); }
// `;

// const floatBackgroundAnimation = keyframes`
//   0%, 100% { transform: translateY(0px) scale(1); }
//   50% { transform: translateY(-8px) scale(1.02); }
// `;

// const fadeInUp = keyframes`
//   from {
//     opacity: 0;
//     transform: translateY(30px);
//   }
//   to {
//     opacity: 1;
//     transform: translateY(0);
//   }
// `;

// const Home = () => {
//   const theme = useTheme();
//   const [testimonialIndex, setTestimonialIndex] = useState(0);

//   // Hero section data (single static content, no slider)
//   const heroContent = {
//     title: "Airbnb Cleaning",
//     highlight: "Made Simple",
//     description: "The mobile app that automatically schedules cleanings based on your property size. Perfect pricing for bedrooms, bathrooms, and extra services.",
//     chip: "🏠 Made for Airbnb Hosts",
//     mainImage: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=400&h=400&fit=crop", // Clean room image
//     backgroundImage: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=500&h=500&fit=crop", // Backyard/outdoor image
//     cta1: "Scan to Download App",
//     cta2: "View Pricing",
//     stats: [
//       { number: "5,000+", label: "Airbnb Listings" },
//       { number: "4.9★", label: "Host Rating" },
//       { number: "15min", label: "Avg. Booking Time" },
//       { number: "98%", label: "On-Time Rate" }
//     ]
//   };

//   // Property size based pricing
//   const propertySizes = [
//     {
//       type: "Studio",
//       price: "$79",
//       description: "Perfect for studio apartments",
//       features: ["1 Bathroom", "Kitchen", "Living Area", "Basic Cleaning"],
//       popular: false
//     },
//     {
//       type: "1-Bedroom",
//       price: "$99",
//       description: "Ideal for 1-bedroom listings",
//       features: ["1 Bedroom", "1 Bathroom", "Kitchen", "Living Room", "Standard Cleaning"],
//       popular: true
//     },
//     {
//       type: "2-Bedroom",
//       price: "$149",
//       description: "Great for 2-bedroom properties",
//       features: ["2 Bedrooms", "2 Bathrooms", "Kitchen", "Living Room", "Thorough Cleaning"],
//       popular: false
//     },
//     {
//       type: "3+ Bedroom",
//       price: "$199+",
//       description: "For larger properties",
//       features: ["3+ Bedrooms", "2+ Bathrooms", "Large Kitchen", "Living Areas", "Premium Cleaning"],
//       popular: false
//     }
//   ];

//   // Extra services
//   const extraServices = [
//     { icon: <YardIcon />, name: "Lawn & Garden", price: "+$45", description: "Lawn mowing and garden maintenance" },
//     { icon: <ApartmentIcon />, name: "Balcony/Patio", price: "+$35", description: "Outdoor area cleaning" },
//     { icon: <KitchenIcon />, name: "Deep Kitchen", price: "+$25", description: "Oven, fridge, and cabinet cleaning" },
//     { icon: <BathtubIcon />, name: "Bathroom Sanitizing", price: "+$20", description: "Extra bathroom deep clean" }
//   ];

//   // Steps
//   const steps = [
//     { number: "1", icon: "📱", title: "Download Our App", description: "Get our mobile app from App Store or Google Play" },
//     { number: "2", icon: "🏠", title: "Set Up Your Property", description: "Enter bedrooms, bathrooms, and extra services needed" },
//     { number: "3", icon: "📅", title: "Sync Calendar", description: "Connect your Airbnb calendar for automatic cleaning requests" },
//     { number: "4", icon: "✨", title: "Enjoy Clean Stays", description: "We handle cleaning after every guest checkout" }
//   ];

//   // App features
//   const appFeatures = [
//     { icon: "📱", title: "Instant Booking", description: "Schedule cleanings in under 60 seconds" },
//     { icon: "📅", title: "Calendar Sync", description: "Automatically syncs with your Airbnb calendar" },
//     { icon: "💰", title: "Transparent Pricing", description: "See exactly what you'll pay before booking" },
//     { icon: "⭐", title: "Cleaner Ratings", description: "Choose from our top-rated cleaning professionals" }
//   ];

//   // Testimonials
//   const testimonials = [
//     {
//       name: "Sarah Johnson",
//       role: "Airbnb Superhost",
//       location: "Miami, FL",
//       rating: 5,
//       comment: "FreshSweeper has completely transformed my hosting business. The app makes scheduling so easy!",
//       avatar: "SJ",
//       properties: "3 Properties"
//     },
//     {
//       name: "Michael Chen",
//       role: "Property Manager",
//       location: "Austin, TX",
//       rating: 5,
//       comment: "Managing 12 Airbnb properties used to be a nightmare. With FreshSweeper, I can coordinate cleanings seamlessly.",
//       avatar: "MC",
//       properties: "12 Properties"
//     },
//     {
//       name: "Emily Rodriguez",
//       role: "Airbnb Host",
//       location: "San Diego, CA",
//       rating: 5,
//       comment: "The mobile app is a game-changer! I get notified immediately after guests check out.",
//       avatar: "ER",
//       properties: "2 Properties"
//     }
//   ];

//   const handleNextTestimonial = () => {
//     setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
//   };

//   const handlePrevTestimonial = () => {
//     setTestimonialIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
//   };

//   return (
//     <Box sx={{ overflow: "hidden", bgcolor: theme.palette.background.default }}>
      
//       {/* ========== HERO SECTION - DOUBLE CIRCLE WITH GRAYSCALE SLIGHTLY LEFT ========== */}
//       <Box
//         sx={{
//           position: "relative",
//           backgroundColor: "transparent",
//           color: theme.palette.text.primary,
//           overflow: "hidden",
//           pt: { xs: 6, md: 8 },
//           pb: { xs: 6, md: 10 },
//         }}
//       >
//         <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
//           <Grid container spacing={6} alignItems="center">
//             {/* Left Content - Text */}
//             <Grid item xs={12} md={6}>
//               <Fade in timeout={800}>
//                 <Box sx={{ animation: `${fadeInUp} 0.6s ease-out` }}>
//                   <Chip
//                     label={heroContent.chip}
//                     sx={{
//                       mb: 3,
//                       background: alpha(theme.palette.primary.main, 0.1),
//                       color: theme.palette.primary.main,
//                       fontWeight: 600,
//                       fontSize: "0.85rem",
//                     }}
//                   />

//                   <Typography
//                     variant="h1"
//                     sx={{
//                       fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4rem" },
//                       fontWeight: 700,
//                       lineHeight: 1.1,
//                       mb: 2,
//                       color: theme.palette.text.primary,
//                     }}
//                   >
//                     {heroContent.title}
//                     <Box component="span" sx={{ display: "block", color: theme.palette.primary.main }}>
//                       {heroContent.highlight}
//                     </Box>
//                   </Typography>

//                   <Typography
//                     variant="h6"
//                     sx={{
//                       mb: 4,
//                       fontSize: "1.1rem",
//                       lineHeight: 1.6,
//                       color: theme.palette.text.secondary,
//                     }}
//                   >
//                     {heroContent.description}
//                   </Typography>

//                   <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 6 }}>
//                     <Button
//                       variant="contained"
//                       size="large"
//                       startIcon={<QrCode2Icon />}
//                       sx={{
//                         px: 4,
//                         py: 1.5,
//                         fontSize: "1rem",
//                         borderRadius: "8px",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       {heroContent.cta1}
//                     </Button>
//                     <Button
//                       variant="outlined"
//                       size="large"
//                       sx={{
//                         px: 4,
//                         py: 1.5,
//                         fontSize: "1rem",
//                         borderRadius: "8px",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       {heroContent.cta2}
//                     </Button>
//                   </Stack>

//                   <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
//                     {heroContent.stats.map((stat, index) => (
//                       <Box key={index}>
//                         <Typography variant="h5" fontWeight="700" color={theme.palette.primary.main}>
//                           {stat.number}
//                         </Typography>
//                         <Typography variant="body2" color={theme.palette.text.secondary}>
//                           {stat.label}
//                         </Typography>
//                       </Box>
//                     ))}
//                   </Box>
//                 </Box>
//               </Fade>
//             </Grid>

//             {/* Right Content - Double Circle Images */}
//             <Grid item xs={12} md={6}>
//               <Fade in timeout={1000}>
//                 <Box
//                   sx={{
//                     position: "relative",
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     minHeight: { xs: 350, sm: 450, md: 500 },
//                   }}
//                 >
//                   {/* Background Circle - Grayscale Backyard Image (Shifted Slightly Left) */}
//                   <Box
//                     sx={{
//                       position: "absolute",
//                       width: { xs: 280, sm: 380, md: 450 },
//                       height: { xs: 280, sm: 380, md: 450 },
//                       borderRadius: "50%",
//                       overflow: "hidden",
//                       filter: "grayscale(100%)",
//                       opacity: 0.3,
//                       animation: `${floatBackgroundAnimation} 8s ease-in-out infinite`,
//                       left: { xs: "-30px", sm: "-40px", md: "100px" },
//                     }}
//                   >
//                     <img
//                       src={heroContent.backgroundImage}
//                       alt="Background"
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                     />
//                   </Box>

//                   {/* Foreground Circle - Main Colorful Image (Centered) */}
//                   <Box
//                     sx={{
//                       position: "relative",
//                       width: { xs: 220, sm: 300, md: 360 },
//                       height: { xs: 220, sm: 300, md: 360 },
//                       borderRadius: "50%",
//                       overflow: "hidden",
//                       boxShadow: `0 20px 40px ${alpha(theme.palette.primary.main, 0.15)}`,
//                       animation: `${floatAnimation} 6s ease-in-out infinite`,
//                       zIndex: 2,
//                     }}
//                   >
//                     <img
//                       src={heroContent.mainImage}
//                       alt={heroContent.title}
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                     />
//                   </Box>
//                 </Box>
//               </Fade>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== REST OF THE CONTENT (same as before) ========== */}
      
//       {/* Property Size Pricing */}
//       <Box sx={{ py: 10 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Typography variant="h2" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>
//               Property-Based Pricing
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               Fair pricing based on your actual property size. Pay only for what you need.
//             </Typography>
//           </Box>

//           <Grid container spacing={3}>
//             {propertySizes.map((property, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Card sx={{ height: "100%", borderRadius: "12px", position: "relative", "&:hover": { transform: "translateY(-4px)", transition: "transform 0.3s" } }}>
//                   {property.popular && (
//                     <Box sx={{ position: "absolute", top: -12, left: "50%", transform: "translateX(-50%)", bgcolor: theme.palette.primary.main, color: "white", px: 3, py: 0.5, borderRadius: "16px", fontSize: "0.8rem", fontWeight: 600 }}>
//                       Most Popular
//                     </Box>
//                   )}
//                   <CardContent sx={{ p: 3, pt: property.popular ? 4 : 3, textAlign: "center" }}>
//                     <Typography variant="h5" fontWeight="600" gutterBottom>{property.type}</Typography>
//                     <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{property.description}</Typography>
//                     <Typography variant="h3" fontWeight="700" color="primary.main" sx={{ mb: 3 }}>{property.price}<Typography variant="body2" component="span" color="text.secondary">/cleaning</Typography></Typography>
//                     <Box sx={{ mb: 3, textAlign: "left" }}>
//                       {property.features.map((feature, idx) => (
//                         <Box key={idx} sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
//                           <CheckCircleIcon sx={{ color: theme.palette.primary.main, fontSize: 18 }} />
//                           <Typography variant="body2">{feature}</Typography>
//                         </Box>
//                       ))}
//                     </Box>
//                     <Button variant={property.popular ? "contained" : "outlined"} fullWidth>Select Plan</Button>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* Extra Services */}
//       <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Typography variant="h2" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>Add Extra Services</Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary" }}>Customize your cleaning with additional services</Typography>
//           </Box>
//           <Grid container spacing={3}>
//             {extraServices.map((service, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Card sx={{ textAlign: "center", p: 3, "&:hover": { transform: "translateY(-4px)", transition: "transform 0.3s" } }}>
//                   <Box sx={{ width: 60, height: 60, borderRadius: "12px", bgcolor: alpha(theme.palette.primary.main, 0.1), display: "flex", alignItems: "center", justifyContent: "center", color: theme.palette.primary.main, margin: "0 auto 16px" }}>{service.icon}</Box>
//                   <Typography variant="h6" fontWeight="600" gutterBottom>{service.name}</Typography>
//                   <Typography variant="h5" fontWeight="700" color="primary.main" gutterBottom>{service.price}</Typography>
//                   <Typography variant="body2" color="text.secondary">{service.description}</Typography>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* How It Works */}
//       <Box sx={{ py: 10 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Typography variant="h2" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>How It Works</Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary" }}>Everything happens right from your phone</Typography>
//           </Box>
//           <Grid container spacing={4}>
//             {steps.map((step, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Box sx={{ textAlign: "center" }}>
//                   <Box sx={{ width: 80, height: 80, borderRadius: "20px", bgcolor: alpha(theme.palette.primary.main, 0.1), display: "flex", alignItems: "center", justifyContent: "center", fontSize: "2rem", mx: "auto", mb: 3 }}>{step.icon}</Box>
//                   <Typography variant="h5" fontWeight="600" gutterBottom>{step.title}</Typography>
//                   <Typography variant="body2" color="text.secondary">{step.description}</Typography>
//                 </Box>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* Mobile App Showcase */}
//       <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Grid container spacing={6} alignItems="center">
//             <Grid item xs={12} md={6}>
//               <Chip label="📱 Mobile App" sx={{ mb: 3, bgcolor: alpha(theme.palette.primary.main, 0.1), color: theme.palette.primary.dark, fontWeight: 600 }} />
//               <Typography variant="h2" sx={{ fontWeight: 700, mb: 3, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>Everything You Need in One App</Typography>
//               <Typography variant="h6" sx={{ color: "text.secondary", mb: 4 }}>Manage all your Airbnb cleanings from the palm of your hand.</Typography>
//               <Grid container spacing={3} sx={{ mb: 4 }}>
//                 {appFeatures.map((feature, index) => (
//                   <Grid item xs={12} sm={6} key={index}>
//                     <Box sx={{ display: "flex", gap: 2 }}>
//                       <Box sx={{ width: 50, height: 50, borderRadius: "12px", bgcolor: alpha(theme.palette.primary.main, 0.1), display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.5rem" }}>{feature.icon}</Box>
//                       <Box>
//                         <Typography variant="h6" fontWeight="600" gutterBottom>{feature.title}</Typography>
//                         <Typography variant="body2" color="text.secondary">{feature.description}</Typography>
//                       </Box>
//                     </Box>
//                   </Grid>
//                 ))}
//               </Grid>
//               <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
//                 <Button variant="contained" startIcon={<AppleIcon />} sx={{ px: 3, py: 1.5 }}>Download on App Store</Button>
//                 <Button variant="outlined" sx={{ px: 3, py: 1.5 }}>Get on Google Play</Button>
//               </Stack>
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <Box sx={{ animation: `${floatAnimation} 6s ease-in-out infinite` }}>
//                 <Card sx={{ borderRadius: "20px", p: 3, maxWidth: 300, mx: "auto" }}>
//                   <Box sx={{ bgcolor: theme.palette.primary.main, borderRadius: "12px", p: 3, color: "white", textAlign: "center" }}>
//                     <Typography variant="h6" fontWeight="700" gutterBottom>FreshSweeper</Typography>
//                     <Typography variant="body2" sx={{ opacity: 0.9, mb: 2 }}>Airbnb Cleaning Made Simple</Typography>
//                     <Box sx={{ bgcolor: "rgba(255,255,255,0.2)", borderRadius: "8px", p: 2, mb: 2 }}>
//                       <Typography variant="body2" fontWeight="600">Next Cleaning: Today 2:00 PM</Typography>
//                       <Typography variant="caption">2 Bedroom • 2 Bathroom</Typography>
//                     </Box>
//                     <Stack spacing={1}>
//                       {["Schedule Cleaning", "View Calendar", "Manage Properties", "Settings"].map((item, idx) => (
//                         <Box key={idx} sx={{ bgcolor: "rgba(255,255,255,0.1)", borderRadius: "6px", p: 1 }}>
//                           <Typography variant="body2">{item}</Typography>
//                         </Box>
//                       ))}
//                     </Stack>
//                   </Box>
//                 </Card>
//               </Box>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* Testimonials */}
//       <Box sx={{ py: 10 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip label="❤️ Loved by Hosts" sx={{ mb: 3, bgcolor: alpha(theme.palette.secondary.main, 0.1), color: theme.palette.secondary.dark, fontWeight: 600 }} />
//             <Typography variant="h2" sx={{ fontWeight: 700, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>What Our Hosts Say</Typography>
//           </Box>
//           <Box sx={{ position: "relative" }}>
//             <IconButton onClick={handlePrevTestimonial} sx={{ position: "absolute", left: { xs: -10, md: -40 }, top: "50%", transform: "translateY(-50%)", zIndex: 2, bgcolor: "background.paper", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
//               <ChevronLeftIcon />
//             </IconButton>
//             <Box sx={{ maxWidth: 800, mx: "auto" }}>
//               <Card sx={{ p: 4, textAlign: "center" }}>
//                 <FormatQuoteIcon sx={{ fontSize: 40, color: alpha(theme.palette.primary.main, 0.2), mb: 2 }} />
//                 <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
//                   {[...Array(5)].map((_, i) => (<StarIcon key={i} sx={{ color: theme.palette.secondary.main }} />))}
//                 </Box>
//                 <Typography variant="h6" sx={{ mb: 3, fontStyle: "italic" }}>"{testimonials[testimonialIndex].comment}"</Typography>
//                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 2 }}>
//                   <Box sx={{ width: 60, height: 60, borderRadius: "12px", bgcolor: alpha(theme.palette.primary.main, 0.1), display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold" }}>{testimonials[testimonialIndex].avatar}</Box>
//                   <Box>
//                     <Typography variant="h6" fontWeight="600">{testimonials[testimonialIndex].name}</Typography>
//                     <Typography variant="body2" color="text.secondary">{testimonials[testimonialIndex].role} • {testimonials[testimonialIndex].properties}</Typography>
//                   </Box>
//                 </Box>
//               </Card>
//             </Box>
//             <IconButton onClick={handleNextTestimonial} sx={{ position: "absolute", right: { xs: -10, md: -40 }, top: "50%", transform: "translateY(-50%)", zIndex: 2, bgcolor: "background.paper", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
//               <ChevronRightIcon />
//             </IconButton>
//           </Box>
//         </Container>
//       </Box>

//       {/* Final CTA */}
//       <Box sx={{ py: 10, background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)` }}>
//         <Container maxWidth="md">
//           <Box sx={{ textAlign: "center", color: "white" }}>
//             <MobileIcon sx={{ fontSize: 60, mb: 3, opacity: 0.9 }} />
//             <Typography variant="h2" sx={{ fontWeight: 700, mb: 3, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>Ready to Simplify Your Airbnb Cleaning?</Typography>
//             <Typography variant="h6" sx={{ mb: 4, opacity: 0.9 }}>Download our mobile app and get your first cleaning at 20% off.</Typography>
//             <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
//               <Button variant="contained" size="large" startIcon={<QrCode2Icon />} sx={{ px: 4, py: 2, bgcolor: alpha(theme.palette.common.white, 0.2), backdropFilter: "blur(10px)", color: "white", "&:hover": { bgcolor: alpha(theme.palette.common.white, 0.3) } }}>Scan QR Code</Button>
//               <Button variant="outlined" size="large" sx={{ px: 4, py: 2, borderColor: "white", color: "white", "&:hover": { bgcolor: alpha(theme.palette.common.white, 0.1) } }}>Send Download Link</Button>
//             </Stack>
//             <Typography variant="body2" sx={{ mt: 3, opacity: 0.8 }}>Available on iOS and Android</Typography>
//           </Box>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default Home;



// import React, { useState } from "react";
// import {
//   Grid,
//   Typography,
//   Box,
//   Button,
//   Container,
//   Card,
//   CardContent,
//   useTheme,
//   Fade,
//   Chip,
//   Stack,
//   alpha,
//   IconButton,
// } from "@mui/material";
// import { keyframes } from "@emotion/react";
// import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
// import ScheduleIcon from "@mui/icons-material/Schedule";
// import PaymentIcon from "@mui/icons-material/Payment";
// import SupportAgentIcon from "@mui/icons-material/SupportAgent";
// import StarIcon from "@mui/icons-material/Star";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import ApartmentIcon from "@mui/icons-material/Apartment";
// import BathtubIcon from "@mui/icons-material/Bathtub";
// import KitchenIcon from "@mui/icons-material/Kitchen";
// import WeekendIcon from "@mui/icons-material/Weekend";
// import YardIcon from "@mui/icons-material/Yard";
// import QrCode2Icon from "@mui/icons-material/QrCode2";
// import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
// import AppleIcon from "@mui/icons-material/Apple";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import MobileIcon from "@mui/icons-material/MobileFriendly";
// import mainImage from "../images/hero_image.jpg"

// // Animations
// const floatAnimation = keyframes`
//   0%, 100% { transform: translateY(0px) rotate(0deg); }
//   50% { transform: translateY(-10px) rotate(2deg); }
// `;

// const floatBackgroundAnimation = keyframes`
//   0%, 100% { transform: translateY(0px) scale(1); }
//   50% { transform: translateY(-8px) scale(1.02); }
// `;

// const fadeInUp = keyframes`
//   from {
//     opacity: 0;
//     transform: translateY(30px);
//   }
//   to {
//     opacity: 1;
//     transform: translateY(0);
//   }
// `;

// const Home = () => {
//   const theme = useTheme();
//   const [testimonialIndex, setTestimonialIndex] = useState(0);

//   // Hero section data
//   const heroContent = {
//     title: "Airbnb Cleaning",
//     highlight: "Made Simple",
//     description: "The mobile app that automatically schedules cleanings based on your property size. Perfect pricing for bedrooms, bathrooms, and extra services.",
//     chip: "🏠 Made for Airbnb Hosts",
//     mainImage: mainImage,
//     backgroundImage: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=500&h=500&fit=crop",
//     cta1: "Scan to Download App",
//     cta2: "View Pricing",
//     stats: [
//       { number: "5,000+", label: "Airbnb Listings" },
//       { number: "4.9★", label: "Host Rating" },
//       { number: "15min", label: "Avg. Booking Time" },
//       { number: "98%", label: "On-Time Rate" }
//     ]
//   };

//   // Property size based pricing
//   const propertySizes = [
//     {
//       type: "Studio",
//       price: "$79",
//       description: "Perfect for studio apartments",
//       features: ["1 Bathroom", "Kitchen", "Living Area", "Basic Cleaning"],
//       popular: false
//     },
//     {
//       type: "1-Bedroom",
//       price: "$99",
//       description: "Ideal for 1-bedroom listings",
//       features: ["1 Bedroom", "1 Bathroom", "Kitchen", "Living Room", "Standard Cleaning"],
//       popular: true
//     },
//     {
//       type: "2-Bedroom",
//       price: "$149",
//       description: "Great for 2-bedroom properties",
//       features: ["2 Bedrooms", "2 Bathrooms", "Kitchen", "Living Room", "Thorough Cleaning"],
//       popular: false
//     },
//     {
//       type: "3+ Bedroom",
//       price: "$199+",
//       description: "For larger properties",
//       features: ["3+ Bedrooms", "2+ Bathrooms", "Large Kitchen", "Living Areas", "Premium Cleaning"],
//       popular: false
//     }
//   ];

//   // Extra services
//   const extraServices = [
//     { icon: <YardIcon />, name: "Lawn & Garden", price: "+$45", description: "Lawn mowing and garden maintenance" },
//     { icon: <ApartmentIcon />, name: "Balcony/Patio", price: "+$35", description: "Outdoor area cleaning" },
//     { icon: <KitchenIcon />, name: "Deep Kitchen", price: "+$25", description: "Oven, fridge, and cabinet cleaning" },
//     { icon: <BathtubIcon />, name: "Bathroom Sanitizing", price: "+$20", description: "Extra bathroom deep clean" }
//   ];

//   // Steps
//   const steps = [
//     { number: "1", icon: "📱", title: "Download Our App", description: "Get our mobile app from App Store or Google Play" },
//     { number: "2", icon: "🏠", title: "Set Up Your Property", description: "Enter bedrooms, bathrooms, and extra services needed" },
//     { number: "3", icon: "📅", title: "Sync Calendar", description: "Connect your Airbnb calendar for automatic cleaning requests" },
//     { number: "4", icon: "✨", title: "Enjoy Clean Stays", description: "We handle cleaning after every guest checkout" }
//   ];

//   // App features
//   const appFeatures = [
//     { icon: "📱", title: "Instant Booking", description: "Schedule cleanings in under 60 seconds" },
//     { icon: "📅", title: "Calendar Sync", description: "Automatically syncs with your Airbnb calendar" },
//     { icon: "💰", title: "Transparent Pricing", description: "See exactly what you'll pay before booking" },
//     { icon: "⭐", title: "Cleaner Ratings", description: "Choose from our top-rated cleaning professionals" }
//   ];

//   // Testimonials
//   const testimonials = [
//     {
//       name: "Sarah Johnson",
//       role: "Airbnb Superhost",
//       location: "Miami, FL",
//       rating: 5,
//       comment: "FreshSweeper has completely transformed my hosting business. The app makes scheduling so easy!",
//       avatar: "SJ",
//       properties: "3 Properties"
//     },
//     {
//       name: "Michael Chen",
//       role: "Property Manager",
//       location: "Austin, TX",
//       rating: 5,
//       comment: "Managing 12 Airbnb properties used to be a nightmare. With FreshSweeper, I can coordinate cleanings seamlessly.",
//       avatar: "MC",
//       properties: "12 Properties"
//     },
//     {
//       name: "Emily Rodriguez",
//       role: "Airbnb Host",
//       location: "San Diego, CA",
//       rating: 5,
//       comment: "The mobile app is a game-changer! I get notified immediately after guests check out.",
//       avatar: "ER",
//       properties: "2 Properties"
//     }
//   ];

//   const handleNextTestimonial = () => {
//     setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
//   };

//   const handlePrevTestimonial = () => {
//     setTestimonialIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
//   };

//   return (
//     <Box sx={{ overflow: "hidden", bgcolor: theme.palette.background.default }}>
      
//       {/* ========== HERO SECTION ========== */}
//       <Box
//         sx={{
//           position: "relative",
//           backgroundColor: "transparent",
//           color: theme.palette.text.primary,
//           overflow: "hidden",
//           pt: { xs: 6, md: 8 },
//           pb: { xs: 6, md: 10 },
//         }}
//       >
//         <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
//           <Grid container spacing={6} alignItems="center">
//             {/* Left Content - Text */}
//             <Grid item xs={12} md={6}>
//               <Fade in timeout={800}>
//                 <Box sx={{ animation: `${fadeInUp} 0.6s ease-out` }}>
//                   <Chip
//                     label={heroContent.chip}
//                     sx={{
//                       mb: 3,
//                       background: alpha(theme.palette.primary.main, 0.1),
//                       color: theme.palette.primary.main,
//                       fontWeight: 600,
//                       fontSize: "0.85rem",
//                     }}
//                   />

//                   <Typography
//                     variant="h1"
//                     sx={{
//                       fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4rem" },
//                       fontWeight: 700,
//                       lineHeight: 1.1,
//                       mb: 2,
//                       color: theme.palette.text.primary,
//                     }}
//                   >
//                     {heroContent.title}
//                     <Box component="span" sx={{ display: "block", color: theme.palette.primary.main }}>
//                       {heroContent.highlight}
//                     </Box>
//                   </Typography>

//                   <Typography
//                     variant="h6"
//                     sx={{
//                       mb: 4,
//                       fontSize: "1.1rem",
//                       lineHeight: 1.6,
//                       color: theme.palette.text.secondary,
//                     }}
//                   >
//                     {heroContent.description}
//                   </Typography>

//                   <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 6 }}>
//                     <Button
//                       variant="contained"
//                       size="large"
//                       startIcon={<QrCode2Icon />}
//                       sx={{
//                         px: 4,
//                         py: 1.5,
//                         fontSize: "1rem",
//                         borderRadius: "8px",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       {heroContent.cta1}
//                     </Button>
//                     <Button
//                       variant="outlined"
//                       size="large"
//                       sx={{
//                         px: 4,
//                         py: 1.5,
//                         fontSize: "1rem",
//                         borderRadius: "8px",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       {heroContent.cta2}
//                     </Button>
//                   </Stack>

//                   <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
//                     {heroContent.stats.map((stat, index) => (
//                       <Box key={index}>
//                         <Typography variant="h5" fontWeight="700" color={theme.palette.primary.main}>
//                           {stat.number}
//                         </Typography>
//                         <Typography variant="body2" color={theme.palette.text.secondary}>
//                           {stat.label}
//                         </Typography>
//                       </Box>
//                     ))}
//                   </Box>
//                 </Box>
//               </Fade>
//             </Grid>

//             {/* Right Content - Double Circle Images */}
//             <Grid item xs={12} md={6}>
//               <Fade in timeout={1000}>
//                 <Box
//                   sx={{
//                     position: "relative",
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     minHeight: { xs: 350, sm: 450, md: 500 },
//                   }}
//                 >
//                   {/* Background Circle - Grayscale Image (Positioned with your values) */}
//                   <Box
//                     sx={{
//                       position: "absolute",
//                       width: { xs: 280, sm: 380, md: 450 },
//                       height: { xs: 280, sm: 380, md: 450 },
//                       borderRadius: "50%",
//                       overflow: "hidden",
//                       filter: "grayscale(100%)",
//                       opacity: 0.3,
//                       animation: `${floatBackgroundAnimation} 8s ease-in-out infinite`,
//                       left: { xs: "30px", sm: "40px", md: "100px" },
//                     }}
//                   >
//                     <img
//                       src={heroContent.backgroundImage}
//                       alt="Background"
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                     />
//                   </Box>

//                   {/* Foreground Circle - Main Colorful Image (Centered) */}
//                   <Box
//                     sx={{
//                       position: "relative",
//                       width: { xs: 220, sm: 300, md: 360 },
//                       height: { xs: 220, sm: 300, md: 360 },
//                       borderRadius: "50%",
//                       overflow: "hidden",
//                       boxShadow: `0 20px 40px ${alpha(theme.palette.primary.main, 0.15)}`,
//                       animation: `${floatAnimation} 6s ease-in-out infinite`,
//                       zIndex: 2,
//                     }}
//                   >
//                     <img
//                       src={heroContent.mainImage}
//                       alt={heroContent.title}
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                     />
//                   </Box>
//                 </Box>
//               </Fade>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== REST OF THE CONTENT ========== */}
      
//       {/* Property Size Pricing */}
//       <Box sx={{ py: 10 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Typography variant="h2" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>
//               Property-Based Pricing
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               Fair pricing based on your actual property size. Pay only for what you need.
//             </Typography>
//           </Box>

//           <Grid container spacing={3}>
//             {propertySizes.map((property, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Card sx={{ height: "100%", borderRadius: "12px", position: "relative", "&:hover": { transform: "translateY(-4px)", transition: "transform 0.3s" } }}>
//                   {property.popular && (
//                     <Box sx={{ position: "absolute", top: -12, left: "50%", transform: "translateX(-50%)", bgcolor: theme.palette.primary.main, color: "white", px: 3, py: 0.5, borderRadius: "16px", fontSize: "0.8rem", fontWeight: 600 }}>
//                       Most Popular
//                     </Box>
//                   )}
//                   <CardContent sx={{ p: 3, pt: property.popular ? 4 : 3, textAlign: "center" }}>
//                     <Typography variant="h5" fontWeight="600" gutterBottom>{property.type}</Typography>
//                     <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>{property.description}</Typography>
//                     <Typography variant="h3" fontWeight="700" color="primary.main" sx={{ mb: 3 }}>{property.price}<Typography variant="body2" component="span" color="text.secondary">/cleaning</Typography></Typography>
//                     <Box sx={{ mb: 3, textAlign: "left" }}>
//                       {property.features.map((feature, idx) => (
//                         <Box key={idx} sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
//                           <CheckCircleIcon sx={{ color: theme.palette.primary.main, fontSize: 18 }} />
//                           <Typography variant="body2">{feature}</Typography>
//                         </Box>
//                       ))}
//                     </Box>
//                     <Button variant={property.popular ? "contained" : "outlined"} fullWidth>Select Plan</Button>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* Extra Services */}
//       <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Typography variant="h2" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>Add Extra Services</Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary" }}>Customize your cleaning with additional services</Typography>
//           </Box>
//           <Grid container spacing={3}>
//             {extraServices.map((service, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Card sx={{ textAlign: "center", p: 3, "&:hover": { transform: "translateY(-4px)", transition: "transform 0.3s" } }}>
//                   <Box sx={{ width: 60, height: 60, borderRadius: "12px", bgcolor: alpha(theme.palette.primary.main, 0.1), display: "flex", alignItems: "center", justifyContent: "center", color: theme.palette.primary.main, margin: "0 auto 16px" }}>{service.icon}</Box>
//                   <Typography variant="h6" fontWeight="600" gutterBottom>{service.name}</Typography>
//                   <Typography variant="h5" fontWeight="700" color="primary.main" gutterBottom>{service.price}</Typography>
//                   <Typography variant="body2" color="text.secondary">{service.description}</Typography>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* How It Works */}
//       <Box sx={{ py: 10 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Typography variant="h2" sx={{ fontWeight: 700, mb: 2, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>How It Works</Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary" }}>Everything happens right from your phone</Typography>
//           </Box>
//           <Grid container spacing={4}>
//             {steps.map((step, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Box sx={{ textAlign: "center" }}>
//                   <Box sx={{ width: 80, height: 80, borderRadius: "20px", bgcolor: alpha(theme.palette.primary.main, 0.1), display: "flex", alignItems: "center", justifyContent: "center", fontSize: "2rem", mx: "auto", mb: 3 }}>{step.icon}</Box>
//                   <Typography variant="h5" fontWeight="600" gutterBottom>{step.title}</Typography>
//                   <Typography variant="body2" color="text.secondary">{step.description}</Typography>
//                 </Box>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* Mobile App Showcase */}
//       <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Grid container spacing={6} alignItems="center">
//             <Grid item xs={12} md={6}>
//               <Chip label="📱 Mobile App" sx={{ mb: 3, bgcolor: alpha(theme.palette.primary.main, 0.1), color: theme.palette.primary.dark, fontWeight: 600 }} />
//               <Typography variant="h2" sx={{ fontWeight: 700, mb: 3, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>Everything You Need in One App</Typography>
//               <Typography variant="h6" sx={{ color: "text.secondary", mb: 4 }}>Manage all your Airbnb cleanings from the palm of your hand.</Typography>
//               <Grid container spacing={3} sx={{ mb: 4 }}>
//                 {appFeatures.map((feature, index) => (
//                   <Grid item xs={12} sm={6} key={index}>
//                     <Box sx={{ display: "flex", gap: 2 }}>
//                       <Box sx={{ width: 50, height: 50, borderRadius: "12px", bgcolor: alpha(theme.palette.primary.main, 0.1), display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.5rem" }}>{feature.icon}</Box>
//                       <Box>
//                         <Typography variant="h6" fontWeight="600" gutterBottom>{feature.title}</Typography>
//                         <Typography variant="body2" color="text.secondary">{feature.description}</Typography>
//                       </Box>
//                     </Box>
//                   </Grid>
//                 ))}
//               </Grid>
//               <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
//                 <Button variant="contained" startIcon={<AppleIcon />} sx={{ px: 3, py: 1.5 }}>Download on App Store</Button>
//                 <Button variant="outlined" sx={{ px: 3, py: 1.5 }}>Get on Google Play</Button>
//               </Stack>
//             </Grid>
//             <Grid item xs={12} md={6}>
//               <Box sx={{ animation: `${floatAnimation} 6s ease-in-out infinite` }}>
//                 <Card sx={{ borderRadius: "20px", p: 3, maxWidth: 300, mx: "auto" }}>
//                   <Box sx={{ bgcolor: theme.palette.primary.main, borderRadius: "12px", p: 3, color: "white", textAlign: "center" }}>
//                     <Typography variant="h6" fontWeight="700" gutterBottom>FreshSweeper</Typography>
//                     <Typography variant="body2" sx={{ opacity: 0.9, mb: 2 }}>Airbnb Cleaning Made Simple</Typography>
//                     <Box sx={{ bgcolor: "rgba(255,255,255,0.2)", borderRadius: "8px", p: 2, mb: 2 }}>
//                       <Typography variant="body2" fontWeight="600">Next Cleaning: Today 2:00 PM</Typography>
//                       <Typography variant="caption">2 Bedroom • 2 Bathroom</Typography>
//                     </Box>
//                     <Stack spacing={1}>
//                       {["Schedule Cleaning", "View Calendar", "Manage Properties", "Settings"].map((item, idx) => (
//                         <Box key={idx} sx={{ bgcolor: "rgba(255,255,255,0.1)", borderRadius: "6px", p: 1 }}>
//                           <Typography variant="body2">{item}</Typography>
//                         </Box>
//                       ))}
//                     </Stack>
//                   </Box>
//                 </Card>
//               </Box>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* Testimonials */}
//       <Box sx={{ py: 10 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip label="❤️ Loved by Hosts" sx={{ mb: 3, bgcolor: alpha(theme.palette.secondary.main, 0.1), color: theme.palette.secondary.dark, fontWeight: 600 }} />
//             <Typography variant="h2" sx={{ fontWeight: 700, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>What Our Hosts Say</Typography>
//           </Box>
//           <Box sx={{ position: "relative" }}>
//             <IconButton onClick={handlePrevTestimonial} sx={{ position: "absolute", left: { xs: -10, md: -40 }, top: "50%", transform: "translateY(-50%)", zIndex: 2, bgcolor: "background.paper", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
//               <ChevronLeftIcon />
//             </IconButton>
//             <Box sx={{ maxWidth: 800, mx: "auto" }}>
//               <Card sx={{ p: 4, textAlign: "center" }}>
//                 <FormatQuoteIcon sx={{ fontSize: 40, color: alpha(theme.palette.primary.main, 0.2), mb: 2 }} />
//                 <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
//                   {[...Array(5)].map((_, i) => (<StarIcon key={i} sx={{ color: theme.palette.secondary.main }} />))}
//                 </Box>
//                 <Typography variant="h6" sx={{ mb: 3, fontStyle: "italic" }}>"{testimonials[testimonialIndex].comment}"</Typography>
//                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 2 }}>
//                   <Box sx={{ width: 60, height: 60, borderRadius: "12px", bgcolor: alpha(theme.palette.primary.main, 0.1), display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold" }}>{testimonials[testimonialIndex].avatar}</Box>
//                   <Box>
//                     <Typography variant="h6" fontWeight="600">{testimonials[testimonialIndex].name}</Typography>
//                     <Typography variant="body2" color="text.secondary">{testimonials[testimonialIndex].role} • {testimonials[testimonialIndex].properties}</Typography>
//                   </Box>
//                 </Box>
//               </Card>
//             </Box>
//             <IconButton onClick={handleNextTestimonial} sx={{ position: "absolute", right: { xs: -10, md: -40 }, top: "50%", transform: "translateY(-50%)", zIndex: 2, bgcolor: "background.paper", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
//               <ChevronRightIcon />
//             </IconButton>
//           </Box>
//         </Container>
//       </Box>

//       {/* Final CTA */}
//       <Box sx={{ py: 10, background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)` }}>
//         <Container maxWidth="md">
//           <Box sx={{ textAlign: "center", color: "white" }}>
//             <MobileIcon sx={{ fontSize: 60, mb: 3, opacity: 0.9 }} />
//             <Typography variant="h2" sx={{ fontWeight: 700, mb: 3, fontSize: { xs: "2.25rem", md: "2.75rem" } }}>Ready to Simplify Your Airbnb Cleaning?</Typography>
//             <Typography variant="h6" sx={{ mb: 4, opacity: 0.9 }}>Download our mobile app and get your first cleaning at 20% off.</Typography>
//             <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
//               <Button variant="contained" size="large" startIcon={<QrCode2Icon />} sx={{ px: 4, py: 2, bgcolor: alpha(theme.palette.common.white, 0.2), backdropFilter: "blur(10px)", color: "white", "&:hover": { bgcolor: alpha(theme.palette.common.white, 0.3) } }}>Scan QR Code</Button>
//               <Button variant="outlined" size="large" sx={{ px: 4, py: 2, borderColor: "white", color: "white", "&:hover": { bgcolor: alpha(theme.palette.common.white, 0.1) } }}>Send Download Link</Button>
//             </Stack>
//             <Typography variant="body2" sx={{ mt: 3, opacity: 0.8 }}>Available on iOS and Android</Typography>
//           </Box>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default Home;




// import React, { useState } from "react";
// import {
//   Grid,
//   Typography,
//   Box,
//   Button,
//   Container,
//   Card,
//   CardContent,
//   useTheme,
//   Fade,
//   Chip,
//   Stack,
//   alpha,
//   IconButton,
//   Avatar,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Paper,
//   Divider,
// } from "@mui/material";
// import { keyframes } from "@emotion/react";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import StarIcon from "@mui/icons-material/Star";
// import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import SmartphoneIcon from "@mui/icons-material/Smartphone";
// import ScheduleIcon from "@mui/icons-material/Schedule";
// import MessageIcon from "@mui/icons-material/Message";
// import DashboardIcon from "@mui/icons-material/Dashboard";
// import PaymentIcon from "@mui/icons-material/Payment";
// import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
// import WarningIcon from "@mui/icons-material/Warning";
// import PersonAddIcon from "@mui/icons-material/PersonAdd";
// import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
// import SecurityIcon from "@mui/icons-material/Security";
// import SpeedIcon from "@mui/icons-material/Speed";
// import GroupsIcon from "@mui/icons-material/Groups";

// // Import local images

// import newMainImage from "../images/hero_image.jpg"
// // import backgroundImage from "../images/backyard-bg.jpg"; // Replace with your actual background image

// // Animations
// const floatAnimation = keyframes`
//   0%, 100% { transform: translateY(0px) rotate(0deg); }
//   50% { transform: translateY(-10px) rotate(2deg); }
// `;

// const floatBackgroundAnimation = keyframes`
//   0%, 100% { transform: translateY(0px) scale(1); }
//   50% { transform: translateY(-8px) scale(1.02); }
// `;

// const fadeInUp = keyframes`
//   from {
//     opacity: 0;
//     transform: translateY(30px);
//   }
//   to {
//     opacity: 1;
//     transform: translateY(0);
//   }
// `;

// const staggerContainer = keyframes`
//   from {
//     opacity: 0;
//   }
//   to {
//     opacity: 1;
//   }
// `;

// const Home = () => {
//   const theme = useTheme();
//   const [testimonialIndex, setTestimonialIndex] = useState(0);

//   // Hero section data
//   const heroContent = {
//     title: "Already Have a Cleaner?",
//     highlight: "Perfect.",
//     description: "Manage trusted cleaners, automate turnovers, and keep every property guest-ready.",
//     chip: "🏠 For Airbnb Hosts",
//     mainImage: newMainImage,
//     backgroundImage: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=500&h=500&fit=crop",
//     // backgroundImage: backgroundImage,
//     cta1: "Start Free",
//     cta2: "Bring My Cleaner",
//   };

//   // Pain points
//   const painPoints = [
//     { icon: <MessageIcon />, text: "Texting cleaners every booking" },
//     { icon: <ScheduleIcon />, text: "Chasing confirmations" },
//     { icon: <WarningIcon />, text: "No backup when someone cancels" },
//     { icon: <PhotoCameraIcon />, text: "Missed cleanings and rushed check-ins" },
//   ];

//   // Features
//   const features = [
//     { icon: <ScheduleIcon />, title: "Smart Scheduling", description: "Automatically schedule cleanings based on your booking calendar" },
//     { icon: <PhotoCameraIcon />, title: "Completion Proof", description: "Before/after photos with timestamps for peace of mind" },
//     { icon: <MessageIcon />, title: "Cleaner Messaging", description: "In-app chat with your cleaning team" },
//     { icon: <DashboardIcon />, title: "Multi-Property Dashboard", description: "Manage all your listings from one place" },
//     { icon: <PaymentIcon />, title: "Reliable Payouts", description: "Pay cleaners instantly and securely" },
//     { icon: <SecurityIcon />, title: "Insured & Bonded", description: "Every booking is protected" },
//   ];

//   // How it works steps
//   const steps = [
//     { number: "01", icon: "🏠", title: "Add Property", description: "List your property details and preferences" },
//     { number: "02", icon: "👤", title: "Invite Cleaner or Find One", description: "Bring your existing team or find vetted pros" },
//     { number: "03", icon: "⚡", title: "Automate Turnovers", description: "Sync with your calendar for automatic scheduling" },
//     { number: "04", icon: "✨", title: "Guests Arrive", description: "To spotless properties, every time" },
//   ];

//   // Stats
//   const stats = [
//     { number: "10,000+", label: "Properties Managed" },
//     { number: "98%", label: "On-Time Rate" },
//     { number: "50K+", label: "Cleanings Completed" },
//     { number: "4.9★", label: "Host Rating" },
//   ];

//   // Testimonials
//   const testimonials = [
//     {
//       name: "Sarah Johnson",
//       role: "Airbnb Superhost",
//       location: "Miami, FL",
//       rating: 5,
//       comment: "I already had a great cleaner, but scheduling was a nightmare. FreshSweeper let me keep my team while automating everything. Game changer!",
//       avatar: "SJ",
//       properties: "8 Properties"
//     },
//     {
//       name: "Michael Chen",
//       role: "Property Manager",
//       location: "Austin, TX",
//       rating: 5,
//       comment: "Managing 15 properties with different cleaners was chaos. Now I have one dashboard, automated scheduling, and backup cleaners when needed.",
//       avatar: "MC",
//       properties: "15 Properties"
//     },
//     {
//       name: "Emily Rodriguez",
//       role: "Airbnb Host",
//       location: "San Diego, CA",
//       rating: 5,
//       comment: "The 'Bring My Cleaner' feature is genius. I kept my trusted cleaner and just upgraded the management system. She loves it too!",
//       avatar: "ER",
//       properties: "4 Properties"
//     }
//   ];

//   const handleNextTestimonial = () => {
//     setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
//   };

//   const handlePrevTestimonial = () => {
//     setTestimonialIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
//   };

//   return (
//     <Box sx={{ overflow: "hidden", bgcolor: theme.palette.background.default }}>
      
//       {/* ========== HERO SECTION ========== */}
//       <Box
//         sx={{
//           position: "relative",
//           backgroundColor: "transparent",
//           color: theme.palette.text.primary,
//           overflow: "hidden",
//           pt: { xs: 6, md: 8 },
//           pb: { xs: 6, md: 10 },
//         }}
//       >
//         <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
//           <Grid container spacing={6} alignItems="center">
//             {/* Left Content - Text */}
//             <Grid item xs={12} md={6}>
//               <Fade in timeout={800}>
//                 <Box sx={{ animation: `${fadeInUp} 0.6s ease-out` }}>
//                   <Chip
//                     label={heroContent.chip}
//                     sx={{
//                       mb: 3,
//                       background: alpha(theme.palette.primary.main, 0.1),
//                       color: theme.palette.primary.main,
//                       fontWeight: 600,
//                       fontSize: "0.85rem",
//                     }}
//                   />

//                   <Typography
//                     variant="h1"
//                     sx={{
//                       fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4rem" },
//                       fontWeight: 700,
//                       lineHeight: 1.1,
//                       mb: 2,
//                       color: theme.palette.text.primary,
//                     }}
//                   >
//                     {heroContent.title}
//                     <Box component="span" sx={{ display: "block", color: theme.palette.primary.main }}>
//                       {heroContent.highlight}
//                     </Box>
//                   </Typography>

//                   <Typography
//                     variant="h6"
//                     sx={{
//                       mb: 4,
//                       fontSize: "1.1rem",
//                       lineHeight: 1.6,
//                       color: theme.palette.text.secondary,
//                     }}
//                   >
//                     {heroContent.description}
//                   </Typography>

//                   <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 4 }}>
//                     <Button
//                       variant="contained"
//                       size="large"
//                       sx={{
//                         px: 4,
//                         py: 1.5,
//                         fontSize: "1rem",
//                         borderRadius: "8px",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       {heroContent.cta1}
//                     </Button>
//                     <Button
//                       variant="outlined"
//                       size="large"
//                       startIcon={<PersonAddIcon />}
//                       sx={{
//                         px: 4,
//                         py: 1.5,
//                         fontSize: "1rem",
//                         borderRadius: "8px",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       {heroContent.cta2}
//                     </Button>
//                   </Stack>

//                   {/* Stats */}
//                   <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
//                     {stats.map((stat, index) => (
//                       <Box key={index}>
//                         <Typography variant="h5" fontWeight="700" color={theme.palette.primary.main}>
//                           {stat.number}
//                         </Typography>
//                         <Typography variant="body2" color={theme.palette.text.secondary}>
//                           {stat.label}
//                         </Typography>
//                       </Box>
//                     ))}
//                   </Box>
//                 </Box>
//               </Fade>
//             </Grid>

//             {/* Right Content - Double Circle Images */}
//             <Grid item xs={12} md={6}>
//               <Fade in timeout={1000}>
//                 <Box
//                   sx={{
//                     position: "relative",
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     minHeight: { xs: 350, sm: 450, md: 500 },
//                   }}
//                 >
//                   {/* Background Circle - Grayscale Image */}
//                   <Box
//                     sx={{
//                       position: "absolute",
//                       width: { xs: 280, sm: 380, md: 450 },
//                       height: { xs: 280, sm: 380, md: 450 },
//                       borderRadius: "50%",
//                       overflow: "hidden",
//                       filter: "grayscale(100%)",
//                       opacity: 0.3,
//                       animation: `${floatBackgroundAnimation} 8s ease-in-out infinite`,
//                       left: { xs: "-30px", sm: "-40px", md: "100px" },
//                     }}
//                   >
//                     <img
//                       src={heroContent.backgroundImage}
//                       alt="Background"
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                     />
//                   </Box>

//                   {/* Foreground Circle - Main Image */}
//                   <Box
//                     sx={{
//                       position: "relative",
//                       width: { xs: 220, sm: 300, md: 360 },
//                       height: { xs: 220, sm: 300, md: 360 },
//                       borderRadius: "50%",
//                       overflow: "hidden",
//                       boxShadow: `0 20px 40px ${alpha(theme.palette.primary.main, 0.15)}`,
//                       animation: `${floatAnimation} 6s ease-in-out infinite`,
//                       zIndex: 2,
//                     }}
//                   >
//                     <img
//                       src={heroContent.mainImage}
//                       alt="Cleaner"
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                     />
//                   </Box>
//                 </Box>
//               </Fade>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== PAIN POINTS SECTION ========== */}
//       <Box sx={{ py: 8, bgcolor: alpha(theme.palette.error.main, 0.03) }}>
//         <Container maxWidth="lg">
//           <Typography
//             variant="h2"
//             sx={{
//               textAlign: "center",
//               fontWeight: 700,
//               mb: 3,
//               fontSize: { xs: "2rem", md: "2.5rem" },
//             }}
//           >
//             Frustrated with...
//           </Typography>
//           <Grid container spacing={3} sx={{ mt: 2 }}>
//             {painPoints.map((point, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     p: 3,
//                     textAlign: "center",
//                     borderRadius: 3,
//                     bgcolor: "background.paper",
//                     border: `1px solid ${alpha(theme.palette.error.main, 0.1)}`,
//                     transition: "transform 0.2s",
//                     "&:hover": {
//                       transform: "translateY(-4px)",
//                       boxShadow: theme.shadows[4],
//                     },
//                   }}
//                 >
//                   <Box sx={{ color: theme.palette.error.main, mb: 2 }}>
//                     {React.cloneElement(point.icon, { sx: { fontSize: 40 } })}
//                   </Box>
//                   <Typography variant="h6" sx={{ fontWeight: 600 }}>
//                     {point.text}
//                   </Typography>
//                 </Paper>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== SOLUTION SECTION ========== */}
//       <Box sx={{ py: 10 }}>
//         <Container maxWidth="lg">
//           <Grid container spacing={6} alignItems="center">
//             <Grid item xs={12} md={6}>
//               <Box sx={{ animation: `${fadeInUp} 0.6s ease-out` }}>
//                 <Chip
//                   label="The Solution"
//                   sx={{
//                     mb: 3,
//                     background: alpha(theme.palette.success.main, 0.1),
//                     color: theme.palette.success.main,
//                     fontWeight: 600,
//                   }}
//                 />
//                 <Typography
//                   variant="h2"
//                   sx={{
//                     fontWeight: 700,
//                     mb: 3,
//                     fontSize: { xs: "2rem", md: "2.5rem" },
//                   }}
//                 >
//                   Keep your cleaner.
//                   <Box component="span" sx={{ color: theme.palette.primary.main }}>
//                     Upgrade everything else.
//                   </Box>
//                 </Typography>
                
//                 <List sx={{ mb: 4 }}>
//                   {[
//                     "Invite existing cleaners by phone or email",
//                     "Find backup cleaners instantly",
//                     "Automate every turnover",
//                   ].map((text, index) => (
//                     <ListItem key={index} sx={{ px: 0 }}>
//                       <ListItemIcon>
//                         <CheckCircleIcon sx={{ color: theme.palette.success.main }} />
//                       </ListItemIcon>
//                       <ListItemText primary={text} primaryTypographyProps={{ variant: "h6", fontWeight: 500 }} />
//                     </ListItem>
//                   ))}
//                 </List>
//               </Box>
//             </Grid>
            
//             <Grid item xs={12} md={6}>
//               <Box
//                 sx={{
//                   background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.secondary.main, 0.02)} 100%)`,
//                   borderRadius: 4,
//                   p: 4,
//                   border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//                 }}
//               >
//                 <Stack spacing={2}>
//                   {["✓ Keep your trusted cleaner", "✓ Automated scheduling", "✓ Backup coverage", "✓ 24/7 support"].map((text, i) => (
//                     <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                       <AutoAwesomeIcon sx={{ color: theme.palette.warning.main }} />
//                       <Typography variant="body1" fontWeight={500}>{text}</Typography>
//                     </Box>
//                   ))}
//                 </Stack>
//               </Box>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== FEATURES SECTION ========== */}
//       <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 700,
//                 mb: 2,
//                 fontSize: { xs: "2rem", md: "2.5rem" },
//               }}
//             >
//               Everything You Need
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               Powerful tools to manage your cleaning operations
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {features.map((feature, index) => (
//               <Grid item xs={12} sm={6} md={4} key={index}>
//                 <Card
//                   sx={{
//                     height: "100%",
//                     p: 3,
//                     borderRadius: 3,
//                     transition: "transform 0.2s",
//                     "&:hover": {
//                       transform: "translateY(-4px)",
//                       boxShadow: theme.shadows[4],
//                     },
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       width: 56,
//                       height: 56,
//                       borderRadius: 2,
//                       bgcolor: alpha(theme.palette.primary.main, 0.1),
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       color: theme.palette.primary.main,
//                       mb: 2,
//                     }}
//                   >
//                     {React.cloneElement(feature.icon, { sx: { fontSize: 28 } })}
//                   </Box>
//                   <Typography variant="h6" fontWeight="600" gutterBottom>
//                     {feature.title}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     {feature.description}
//                   </Typography>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== HOW IT WORKS SECTION ========== */}
//       <Box sx={{ py: 10 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 700,
//                 mb: 2,
//                 fontSize: { xs: "2rem", md: "2.5rem" },
//               }}
//             >
//               How It Works
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               Get started in minutes, not days
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {steps.map((step, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Box sx={{ textAlign: "center" }}>
//                   <Box
//                     sx={{
//                       width: 80,
//                       height: 80,
//                       borderRadius: "20px",
//                       bgcolor: alpha(theme.palette.primary.main, 0.1),
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       fontSize: "2rem",
//                       mx: "auto",
//                       mb: 3,
//                       position: "relative",
//                     }}
//                   >
//                     <Typography
//                       variant="h4"
//                       sx={{
//                         position: "absolute",
//                         top: -10,
//                         right: -10,
//                         bgcolor: theme.palette.primary.main,
//                         color: "white",
//                         width: 28,
//                         height: 28,
//                         borderRadius: "50%",
//                         fontSize: "0.8rem",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                       }}
//                     >
//                       {step.number}
//                     </Typography>
//                     {step.icon}
//                   </Box>
//                   <Typography variant="h6" fontWeight="600" gutterBottom>
//                     {step.title}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     {step.description}
//                   </Typography>
//                 </Box>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== TESTIMONIALS SECTION ========== */}
//       <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip
//               label="❤️ Trusted by Top Hosts"
//               sx={{
//                 mb: 3,
//                 bgcolor: alpha(theme.palette.secondary.main, 0.1),
//                 color: theme.palette.secondary.dark,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 700,
//                 fontSize: { xs: "2rem", md: "2.5rem" },
//               }}
//             >
//               What Hosts Are Saying
//             </Typography>
//           </Box>

//           <Box sx={{ position: "relative" }}>
//             <IconButton
//               onClick={handlePrevTestimonial}
//               sx={{
//                 position: "absolute",
//                 left: { xs: -10, md: -40 },
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 zIndex: 2,
//                 bgcolor: "background.paper",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//                 "&:hover": { bgcolor: theme.palette.primary.main, color: "white" },
//               }}
//             >
//               <ChevronLeftIcon />
//             </IconButton>

//             <Box sx={{ maxWidth: 800, mx: "auto" }}>
//               <Card sx={{ p: 4, textAlign: "center", borderRadius: 3 }}>
//                 <FormatQuoteIcon sx={{ fontSize: 48, color: alpha(theme.palette.primary.main, 0.2), mb: 2 }} />
//                 <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
//                   {[...Array(testimonials[testimonialIndex].rating)].map((_, i) => (
//                     <StarIcon key={i} sx={{ color: theme.palette.secondary.main }} />
//                   ))}
//                 </Box>
//                 <Typography variant="h6" sx={{ mb: 3, fontStyle: "italic", lineHeight: 1.6 }}>
//                   "{testimonials[testimonialIndex].comment}"
//                 </Typography>
//                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 2 }}>
//                   <Avatar
//                     sx={{
//                       width: 56,
//                       height: 56,
//                       bgcolor: theme.palette.primary.main,
//                       fontWeight: "bold",
//                     }}
//                   >
//                     {testimonials[testimonialIndex].avatar}
//                   </Avatar>
//                   <Box sx={{ textAlign: "left" }}>
//                     <Typography variant="h6" fontWeight="600">
//                       {testimonials[testimonialIndex].name}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {testimonials[testimonialIndex].role} • {testimonials[testimonialIndex].properties}
//                     </Typography>
//                     <Typography variant="caption" color="text.secondary">
//                       {testimonials[testimonialIndex].location}
//                     </Typography>
//                   </Box>
//                 </Box>
//               </Card>
//             </Box>

//             <IconButton
//               onClick={handleNextTestimonial}
//               sx={{
//                 position: "absolute",
//                 right: { xs: -10, md: -40 },
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 zIndex: 2,
//                 bgcolor: "background.paper",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//                 "&:hover": { bgcolor: theme.palette.primary.main, color: "white" },
//               }}
//             >
//               <ChevronRightIcon />
//             </IconButton>
//           </Box>

//           <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 4 }}>
//             {testimonials.map((_, index) => (
//               <Box
//                 key={index}
//                 onClick={() => setTestimonialIndex(index)}
//                 sx={{
//                   width: 10,
//                   height: 10,
//                   borderRadius: "50%",
//                   cursor: "pointer",
//                   bgcolor: index === testimonialIndex ? theme.palette.primary.main : alpha(theme.palette.primary.main, 0.3),
//                   transition: "all 0.3s ease",
//                 }}
//               />
//             ))}
//           </Box>
//         </Container>
//       </Box>

//       {/* ========== FINAL CTA SECTION ========== */}
//       <Box
//         sx={{
//           py: 12,
//           background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
//           textAlign: "center",
//         }}
//       >
//         <Container maxWidth="md">
//           <Typography
//             variant="h2"
//             sx={{
//               fontWeight: 700,
//               mb: 3,
//               fontSize: { xs: "2rem", md: "2.5rem" },
//               color: "white",
//             }}
//           >
//             Stop stressing over turnovers.
//           </Typography>
//           <Typography
//             variant="h6"
//             sx={{
//               mb: 4,
//               opacity: 0.9,
//               color: "white",
//               maxWidth: "500px",
//               mx: "auto",
//             }}
//           >
//             Join thousands of hosts who've automated their cleaning operations
//           </Typography>
//           <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
//             <Button
//               variant="contained"
//               size="large"
//               sx={{
//                 px: 5,
//                 py: 1.8,
//                 fontSize: "1.1rem",
//                 bgcolor: "white",
//                 color: theme.palette.primary.main,
//                 borderRadius: "12px",
//                 fontWeight: 700,
//                 "&:hover": {
//                   bgcolor: alpha(theme.palette.common.white, 0.9),
//                   transform: "translateY(-2px)",
//                 },
//                 transition: "all 0.3s ease",
//               }}
//             >
//               Start Free
//             </Button>
//             <Button
//               variant="outlined"
//               size="large"
//               sx={{
//                 px: 5,
//                 py: 1.8,
//                 fontSize: "1.1rem",
//                 borderColor: "white",
//                 color: "white",
//                 borderRadius: "12px",
//                 fontWeight: 700,
//                 "&:hover": {
//                   bgcolor: alpha(theme.palette.common.white, 0.1),
//                   transform: "translateY(-2px)",
//                 },
//                 transition: "all 0.3s ease",
//               }}
//             >
//               Book a Demo
//             </Button>
//           </Stack>
//           <Typography variant="body2" sx={{ mt: 4, opacity: 0.7, color: "white" }}>
//             No credit card required • Cancel anytime
//           </Typography>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default Home;










// import React, { useState, useRef, useEffect } from "react";
// import {
//   Grid,
//   Typography,
//   Box,
//   Button,
//   Container,
//   Card,
//   CardContent,
//   useTheme,
//   Fade,
//   Chip,
//   Stack,
//   alpha,
//   IconButton,
//   Avatar,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Paper,
//   Divider,
//   Rating,
//   useMediaQuery,
//   CardMedia,
//   CardActionArea,
// } from "@mui/material";
// import { keyframes } from "@emotion/react";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import StarIcon from "@mui/icons-material/Star";
// import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import SmartphoneIcon from "@mui/icons-material/Smartphone";
// import ScheduleIcon from "@mui/icons-material/Schedule";
// import MessageIcon from "@mui/icons-material/Message";
// import DashboardIcon from "@mui/icons-material/Dashboard";
// import PaymentIcon from "@mui/icons-material/Payment";
// import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
// import WarningIcon from "@mui/icons-material/Warning";
// import PersonAddIcon from "@mui/icons-material/PersonAdd";
// import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
// import SecurityIcon from "@mui/icons-material/Security";
// import SpeedIcon from "@mui/icons-material/Speed";
// import GroupsIcon from "@mui/icons-material/Groups";
// import VerifiedIcon from "@mui/icons-material/Verified";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import SupportAgentIcon from "@mui/icons-material/SupportAgent";
// import PlayCircleIcon from "@mui/icons-material/PlayCircle";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

// // Import local images
// import heroMainImage from "../images/hero_image.jpg";
// import heroBgImage from "../images/hero_image.jpg";
// import featureImg1 from "../images/hero_image.jpg";
// import featureImg2 from "../images/hero_image.jpg";
// import featureImg3 from "../images/hero_image.jpg";

// // Animations
// const floatAnimation = keyframes`
//   0%, 100% { transform: translateY(0px) scale(1); }
//   50% { transform: translateY(-15px) scale(1.02); }
// `;

// const slideInLeft = keyframes`
//   from {
//     opacity: 0;
//     transform: translateX(-60px);
//   }
//   to {
//     opacity: 1;
//     transform: translateX(0);
//   }
// `;

// const slideInRight = keyframes`
//   from {
//     opacity: 0;
//     transform: translateX(60px);
//   }
//   to {
//     opacity: 1;
//     transform: translateX(0);
//   }
// `;

// const scaleIn = keyframes`
//   from {
//     opacity: 0;
//     transform: scale(0.9);
//   }
//   to {
//     opacity: 1;
//     transform: scale(1);
//   }
// `;

// const gradientShift = keyframes`
//   0% {
//     background-position: 0% 50%;
//   }
//   50% {
//     background-position: 100% 50%;
//   }
//   100% {
//     background-position: 0% 50%;
//   }
// `;

// const Home = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const [testimonialIndex, setTestimonialIndex] = useState(0);
//   const [activeFeature, setActiveFeature] = useState(0);

//   // Hero section
//   const heroContent = {
//     title: "Already Have a Cleaner?",
//     highlight: "Perfect.",
//     description: "Keep your trusted team, automate everything else. The only platform that lets you bring your own cleaners while providing backup, automation, and peace of mind.",
//     chip: "🏆 For Professional Hosts",
//     mainImage: heroMainImage,
//     backgroundImage: heroBgImage,
//   };

//   // Pain points with images
//   const painPoints = [
//     { icon: <MessageIcon />, text: "Endless texting", color: "#FF6B6B", image: "https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=100&h=100&fit=crop" },
//     { icon: <ScheduleIcon />, text: "No-show nightmares", color: "#4ECDC4", image: "https://images.unsplash.com/photo-1556742393-d75f468bfcb0?w=100&h=100&fit=crop" },
//     { icon: <WarningIcon />, text: "No backup plan", color: "#FFE66D", image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=100&h=100&fit=crop" },
//     { icon: <PhotoCameraIcon />, text: "Quality inconsistency", color: "#FF6B6B", image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=100&h=100&fit=crop" },
//   ];

//   // Features with images
//   const features = [
//     { 
//       icon: <ScheduleIcon />, 
//       title: "Smart Scheduling", 
//       description: "Syncs with Airbnb, Vrbo, and Booking.com. Auto-schedule cleanings after every checkout.",
//       gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=600&h=400&fit=crop"
//     },
//     { 
//       icon: <PhotoCameraIcon />, 
//       title: "Photo Verification", 
//       description: "Time-stamped before/after photos. Know exactly when your property is ready.",
//       gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
//       image: "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?w=600&h=400&fit=crop"
//     },
//     { 
//       icon: <MessageIcon />, 
//       title: "In-App Messaging", 
//       description: "Chat with cleaners, share instructions, and resolve issues instantly.",
//       gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
//       image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop"
//     },
//     { 
//       icon: <DashboardIcon />, 
//       title: "Unified Dashboard", 
//       description: "Manage all properties from one beautiful interface. Real-time updates.",
//       gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
//       image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop"
//     },
//     { 
//       icon: <PaymentIcon />, 
//       title: "Instant Payouts", 
//       description: "Pay cleaners automatically. No more Venmo or cash headaches.",
//       gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
//       image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop"
//     },
//     { 
//       icon: <SecurityIcon />, 
//       title: "Insured & Bonded", 
//       description: "$1M coverage on every booking. Backup cleaners always available.",
//       gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
//       image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&h=400&fit=crop"
//     },
//   ];

//   // Stats with icons
//   const stats = [
//     { number: "10,000+", label: "Properties Managed", icon: <GroupsIcon />, gradient: "linear-gradient(135deg, #667eea, #764ba2)" },
//     { number: "99.9%", label: "On-Time Rate", icon: <VerifiedIcon />, gradient: "linear-gradient(135deg, #43e97b, #38f9d7)" },
//     { number: "50K+", label: "Cleanings Completed", icon: <TrendingUpIcon />, gradient: "linear-gradient(135deg, #fa709a, #fee140)" },
//     { number: "24/7", label: "Support Available", icon: <SupportAgentIcon />, gradient: "linear-gradient(135deg, #4facfe, #00f2fe)" },
//   ];

//   // How it works steps
//   const steps = [
//     { 
//       number: "01", 
//       icon: "🏠", 
//       title: "Add Your Properties", 
//       description: "List your Airbnb properties in seconds. Add details, access codes, and special instructions.",
//       image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=400&h=300&fit=crop"
//     },
//     { 
//       number: "02", 
//       icon: "👥", 
//       title: "Invite Your Cleaner", 
//       description: "Bring your existing team with a simple email or text. They'll love the automation.",
//       image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=400&h=300&fit=crop"
//     },
//     { 
//       number: "03", 
//       icon: "⚡", 
//       title: "Automate Turnovers", 
//       description: "Connect your booking calendar. We'll automatically schedule cleanings after each checkout.",
//       image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop"
//     },
//     { 
//       number: "04", 
//       icon: "✨", 
//       title: "Perfect Check-ins", 
//       description: "Guests arrive to spotless properties. You get photo proof and peace of mind.",
//       image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=400&h=300&fit=crop"
//     },
//   ];

//   // Testimonials with images
//   const testimonials = [
//     {
//       name: "Sarah Johnson",
//       role: "Airbnb Superhost",
//       location: "Miami, FL",
//       rating: 5,
//       comment: "I already had an amazing cleaner, but scheduling was a nightmare. FreshSweeper let me keep her while automating everything. Now I sleep better knowing every turnover is handled.",
//       avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop",
//       properties: "12 Properties",
//       image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=600&h=400&fit=crop"
//     },
//     {
//       name: "Michael Chen",
//       role: "Property Manager",
//       location: "Austin, TX",
//       rating: 5,
//       comment: "Managing 25 properties across 3 cities was chaos. FreshSweeper unified everything. My existing cleaners love the app, and I love having backup when someone's sick.",
//       avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
//       properties: "25 Properties",
//       image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=600&h=400&fit=crop"
//     },
//     {
//       name: "Emily Rodriguez",
//       role: "Vacation Rental Investor",
//       location: "San Diego, CA",
//       rating: 5,
//       comment: "The photo verification feature is brilliant. I can see exactly when cleanings are done, and my cleaner appreciates the streamlined communication. Win-win.",
//       avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop",
//       properties: "8 Properties",
//       image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop"
//     }
//   ];

//   // Featured partners
//   const partners = [
//     "https://upload.wikimedia.org/wikipedia/commons/6/6f/Airbnb_Logo_B%C3%A9lo.svg",
//     "https://upload.wikimedia.org/wikipedia/commons/9/98/Booking.com_Logo_2011.svg",
//     "https://upload.wikimedia.org/wikipedia/commons/5/5e/VRBO_logo.svg",
//   ];

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setActiveFeature((prev) => (prev + 1) % features.length);
//     }, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   const handleNextTestimonial = () => {
//     setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
//   };

//   const handlePrevTestimonial = () => {
//     setTestimonialIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
//   };

//   return (
//     <Box sx={{ overflow: "hidden", bgcolor: theme.palette.background.default }}>
      
//       {/* ========== HERO SECTION WITH ANIMATED BACKGROUND ========== */}
//       <Box
//         sx={{
//           position: "relative",
//           minHeight: "90vh",
//           display: "flex",
//           alignItems: "center",
//           overflow: "hidden",
//           background: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0.95)} 0%, ${alpha(theme.palette.primary.main, 0.9)} 100%)`,
//         }}
//       >
//         {/* Animated gradient overlay */}
//         <Box
//           sx={{
//             position: "absolute",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             background: "linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)",
//             backgroundSize: "200% 200%",
//             animation: `${gradientShift} 3s ease infinite`,
//           }}
//         />

//         <Container maxWidth="xl" sx={{ position: "relative", zIndex: 2, py: { xs: 8, md: 0 } }}>
//           <Grid container spacing={6} alignItems="center">
//             <Grid item xs={12} md={6}>
//               <Fade in timeout={800}>
//                 <Box sx={{ animation: `${slideInLeft} 0.8s ease-out` }}>
//                   <Chip
//                     label="✨ Trusted by 10,000+ Hosts"
//                     sx={{
//                       mb: 3,
//                       background: alpha(theme.palette.common.white, 0.2),
//                       color: "white",
//                       fontWeight: 600,
//                       fontSize: "0.9rem",
//                       backdropFilter: "blur(10px)",
//                     }}
//                   />

//                   <Typography
//                     variant="h1"
//                     sx={{
//                       fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4.5rem" },
//                       fontWeight: 800,
//                       lineHeight: 1.1,
//                       mb: 2,
//                       color: "white",
//                     }}
//                   >
//                     {heroContent.title}
//                     <Box component="span" sx={{ display: "block", color: "#FFE66D" }}>
//                       {heroContent.highlight}
//                     </Box>
//                   </Typography>

//                   <Typography
//                     variant="h6"
//                     sx={{
//                       mb: 4,
//                       fontSize: "1.2rem",
//                       lineHeight: 1.6,
//                       color: alpha(theme.palette.common.white, 0.9),
//                       maxWidth: "90%",
//                     }}
//                   >
//                     {heroContent.description}
//                   </Typography>

//                   <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 5 }}>
//                     <Button
//                       variant="contained"
//                       size="large"
//                       startIcon={<AutoAwesomeIcon />}
//                       sx={{
//                         px: 5,
//                         py: 1.8,
//                         fontSize: "1.1rem",
//                         bgcolor: "white",
//                         color: theme.palette.primary.main,
//                         borderRadius: "50px",
//                         fontWeight: 700,
//                         "&:hover": {
//                           bgcolor: alpha(theme.palette.common.white, 0.9),
//                           transform: "translateY(-2px) scale(1.02)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       Start Free
//                     </Button>
//                     <Button
//                       variant="outlined"
//                       size="large"
//                       startIcon={<PlayCircleIcon />}
//                       sx={{
//                         px: 5,
//                         py: 1.8,
//                         fontSize: "1.1rem",
//                         borderColor: "white",
//                         color: "white",
//                         borderRadius: "50px",
//                         fontWeight: 600,
//                         "&:hover": {
//                           bgcolor: alpha(theme.palette.common.white, 0.1),
//                           transform: "translateY(-2px)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       Watch Demo
//                     </Button>
//                   </Stack>

//                   {/* Stats Row */}
//                   <Grid container spacing={2}>
//                     {stats.map((stat, index) => (
//                       <Grid item xs={6} sm={3} key={index}>
//                         <Box sx={{ textAlign: "center" }}>
//                           <Box
//                             sx={{
//                               width: 48,
//                               height: 48,
//                               borderRadius: "16px",
//                               background: stat.gradient,
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               margin: "0 auto 8px",
//                               color: "white",
//                             }}
//                           >
//                             {stat.icon}
//                           </Box>
//                           <Typography variant="h5" fontWeight="800" color="white">
//                             {stat.number}
//                           </Typography>
//                           <Typography variant="caption" sx={{ color: alpha(theme.palette.common.white, 0.8) }}>
//                             {stat.label}
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Box>
//               </Fade>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <Fade in timeout={1000}>
//                 <Box sx={{ animation: `${slideInRight} 0.8s ease-out`, position: "relative" }}>
//                   {/* Floating decorative elements */}
//                   <Box
//                     sx={{
//                       position: "absolute",
//                       top: -20,
//                       right: -20,
//                       width: 100,
//                       height: 100,
//                       borderRadius: "50%",
//                       background: "linear-gradient(135deg, #FFE66D, #FF6B6B)",
//                       opacity: 0.3,
//                       filter: "blur(40px)",
//                     }}
//                   />
                  
//                   {/* Main Hero Image */}
//                   <Box
//                     component="img"
//                     src={heroContent.mainImage}
//                     alt="Professional cleaner"
//                     sx={{
//                       width: "100%",
//                       maxWidth: 500,
//                       height: "auto",
//                       borderRadius: "40px",
//                       boxShadow: "0 40px 80px rgba(0,0,0,0.3)",
//                       animation: `${floatAnimation} 4s ease-in-out infinite`,
//                       display: "block",
//                       margin: "0 auto",
//                     }}
//                   />

//                   {/* Floating badge */}
//                   <Paper
//                     elevation={0}
//                     sx={{
//                       position: "absolute",
//                       bottom: 30,
//                       left: -20,
//                       p: 1.5,
//                       borderRadius: 3,
//                       background: "white",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 1,
//                       boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
//                     }}
//                   >
//                     <VerifiedIcon sx={{ color: "#10b981" }} />
//                     <Typography variant="body2" fontWeight="600">100% Satisfaction</Typography>
//                   </Paper>
//                 </Box>
//               </Fade>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== PAIN POINTS SECTION WITH IMAGES ========== */}
//       <Box sx={{ py: 10, bgcolor: theme.palette.background.default }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 6 }}>
//             <Chip
//               label="😤 Common Frustrations"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.error.main, 0.1),
//                 color: theme.palette.error.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 fontSize: { xs: "2rem", md: "2.8rem" },
//                 mb: 2,
//               }}
//             >
//               Does This Sound Familiar?
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               The daily struggles of managing short-term rental cleanings
//             </Typography>
//           </Box>

//           <Grid container spacing={3}>
//             {painPoints.map((point, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     p: 3,
//                     height: "100%",
//                     borderRadius: 4,
//                     background: "white",
//                     border: `1px solid ${alpha(theme.palette.error.main, 0.1)}`,
//                     transition: "all 0.3s ease",
//                     "&:hover": {
//                       transform: "translateY(-8px)",
//                       boxShadow: `0 20px 40px ${alpha(point.color, 0.15)}`,
//                       borderColor: point.color,
//                     },
//                     cursor: "pointer",
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       width: 60,
//                       height: 60,
//                       borderRadius: "20px",
//                       background: alpha(point.color, 0.1),
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       mb: 2,
//                     }}
//                   >
//                     {React.cloneElement(point.icon, { sx: { fontSize: 32, color: point.color } })}
//                   </Box>
//                   <Typography variant="h6" fontWeight="700" gutterBottom>
//                     {point.text}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     Wasting hours coordinating and following up
//                   </Typography>
//                 </Paper>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== SOLUTION SECTION WITH SPLIT LAYOUT ========== */}
//       <Box sx={{ py: 12, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Grid container spacing={6} alignItems="center">
//             <Grid item xs={12} md={6}>
//               <Box sx={{ animation: `${scaleIn} 0.6s ease-out` }}>
//                 <Chip
//                   label="💡 The Better Way"
//                   sx={{
//                     mb: 3,
//                     bgcolor: alpha(theme.palette.success.main, 0.1),
//                     color: theme.palette.success.main,
//                     fontWeight: 600,
//                   }}
//                 />
//                 <Typography
//                   variant="h2"
//                   sx={{
//                     fontWeight: 800,
//                     mb: 3,
//                     fontSize: { xs: "2rem", md: "2.5rem" },
//                   }}
//                 >
//                   Keep Your Cleaner.
//                   <Box component="span" sx={{ color: theme.palette.primary.main, display: "block" }}>
//                     Upgrade Everything Else.
//                   </Box>
//                 </Typography>
                
//                 <Stack spacing={2} sx={{ mb: 4 }}>
//                   {[
//                     "Invite your existing cleaners via text or email",
//                     "Find vetted backup cleaners instantly when needed",
//                     "Automate every turnover with calendar sync",
//                     "Get photo proof after every cleaning",
//                   ].map((text, index) => (
//                     <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                       <Box
//                         sx={{
//                           width: 32,
//                           height: 32,
//                           borderRadius: "10px",
//                           background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <CheckCircleIcon sx={{ fontSize: 18, color: "white" }} />
//                       </Box>
//                       <Typography variant="body1" fontWeight="500">{text}</Typography>
//                     </Box>
//                   ))}
//                 </Stack>

//                 <Button
//                   variant="contained"
//                   size="large"
//                   endIcon={<ArrowForwardIcon />}
//                   sx={{
//                     borderRadius: "50px",
//                     px: 4,
//                     py: 1.5,
//                     fontSize: "1rem",
//                     fontWeight: 600,
//                   }}
//                 >
//                   See How It Works
//                 </Button>
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <Box
//                 sx={{
//                   position: "relative",
//                   borderRadius: 4,
//                   overflow: "hidden",
//                   boxShadow: "0 30px 60px rgba(0,0,0,0.1)",
//                 }}
//               >
//                 <img
//                   src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=600&h=500&fit=crop"
//                   alt="Cleaner working"
//                   style={{
//                     width: "100%",
//                     height: "auto",
//                     display: "block",
//                   }}
//                 />
//                 <Box
//                   sx={{
//                     position: "absolute",
//                     bottom: 0,
//                     left: 0,
//                     right: 0,
//                     background: "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
//                     p: 3,
//                   }}
//                 >
//                   <Typography variant="body1" color="white" fontWeight="600">
//                     "I kept my cleaner AND saved 15 hours/week"
//                   </Typography>
//                   <Typography variant="caption" color="rgba(255,255,255,0.8)">
//                     — Sarah, Superhost
//                   </Typography>
//                 </Box>
//               </Box>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== FEATURES SECTION WITH SPLIT IMAGES ========== */}
//       <Box sx={{ py: 12 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip
//               label="🎯 Powerful Features"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.primary.main, 0.1),
//                 color: theme.palette.primary.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 mb: 2,
//                 fontSize: { xs: "2rem", md: "2.8rem" },
//               }}
//             >
//               Everything You Need to Scale
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               Purpose-built for short-term rental hosts who mean business
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {features.map((feature, index) => (
//               <Grid item xs={12} sm={6} md={4} key={index}>
//                 <Card
//                   sx={{
//                     height: "100%",
//                     borderRadius: 4,
//                     overflow: "hidden",
//                     transition: "all 0.3s ease",
//                     "&:hover": {
//                       transform: "translateY(-8px)",
//                       boxShadow: theme.shadows[8],
//                     },
//                   }}
//                 >
//                   <CardMedia
//                     component="img"
//                     height="200"
//                     image={feature.image}
//                     alt={feature.title}
//                   />
//                   <CardContent sx={{ p: 3 }}>
//                     <Box
//                       sx={{
//                         width: 48,
//                         height: 48,
//                         borderRadius: "16px",
//                         background: feature.gradient,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         mb: 2,
//                         color: "white",
//                       }}
//                     >
//                       {React.cloneElement(feature.icon, { sx: { fontSize: 24 } })}
//                     </Box>
//                     <Typography variant="h6" fontWeight="700" gutterBottom>
//                       {feature.title}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {feature.description}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== HOW IT WORKS WITH IMAGES ========== */}
//       <Box sx={{ py: 12, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip
//               label="📋 Simple Setup"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.warning.main, 0.1),
//                 color: theme.palette.warning.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 mb: 2,
//                 fontSize: { xs: "2rem", md: "2.8rem" },
//               }}
//             >
//               Get Started in Minutes
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               No contracts. No hidden fees. Just better cleaning management.
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {steps.map((step, index) => (
//               <Grid item xs={12} md={3} key={index}>
//                 <Box sx={{ textAlign: "center" }}>
//                   <Box
//                     sx={{
//                       position: "relative",
//                       mb: 3,
//                       borderRadius: 3,
//                       overflow: "hidden",
//                       aspectRatio: "1/1",
//                     }}
//                   >
//                     <img
//                       src={step.image}
//                       alt={step.title}
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                     />
//                     <Box
//                       sx={{
//                         position: "absolute",
//                         top: 10,
//                         left: 10,
//                         background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
//                         color: "white",
//                         width: 40,
//                         height: 40,
//                         borderRadius: "12px",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         fontWeight: 800,
//                         fontSize: "1.2rem",
//                       }}
//                     >
//                       {step.number}
//                     </Box>
//                   </Box>
//                   <Typography variant="h6" fontWeight="700" gutterBottom>
//                     {step.title}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     {step.description}
//                   </Typography>
//                 </Box>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== TESTIMONIALS SECTION WITH IMAGES ========== */}
//       <Box sx={{ py: 12 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip
//               label="⭐ Trusted by Hosts"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.secondary.main, 0.1),
//                 color: theme.palette.secondary.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 fontSize: { xs: "2rem", md: "2.8rem" },
//               }}
//             >
//               What Hosts Are Saying
//             </Typography>
//           </Box>

//           <Box sx={{ position: "relative", maxWidth: 900, mx: "auto" }}>
//             <IconButton
//               onClick={handlePrevTestimonial}
//               sx={{
//                 position: "absolute",
//                 left: { xs: -20, md: -60 },
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 zIndex: 2,
//                 bgcolor: "white",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//                 "&:hover": { bgcolor: theme.palette.primary.main, color: "white" },
//               }}
//             >
//               <ChevronLeftIcon />
//             </IconButton>

//             <Box>
//               <Card sx={{ borderRadius: 4, overflow: "hidden" }}>
//                 <Grid container>
//                   <Grid item xs={12} md={5}>
//                     <Box
//                       sx={{
//                         height: "100%",
//                         minHeight: 300,
//                         backgroundImage: `url(${testimonials[testimonialIndex].image})`,
//                         backgroundSize: "cover",
//                         backgroundPosition: "center",
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} md={7}>
//                     <CardContent sx={{ p: 4 }}>
//                       <Rating value={testimonials[testimonialIndex].rating} readOnly sx={{ mb: 2 }} />
//                       <FormatQuoteIcon sx={{ fontSize: 40, color: alpha(theme.palette.primary.main, 0.2), mb: 2 }} />
//                       <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6, fontStyle: "italic" }}>
//                         "{testimonials[testimonialIndex].comment}"
//                       </Typography>
//                       <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                         <Avatar
//                           src={testimonials[testimonialIndex].avatar}
//                           sx={{ width: 56, height: 56 }}
//                         />
//                         <Box>
//                           <Typography variant="h6" fontWeight="700">
//                             {testimonials[testimonialIndex].name}
//                           </Typography>
//                           <Typography variant="body2" color="text.secondary">
//                             {testimonials[testimonialIndex].role} • {testimonials[testimonialIndex].properties}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </CardContent>
//                   </Grid>
//                 </Grid>
//               </Card>
//             </Box>

//             <IconButton
//               onClick={handleNextTestimonial}
//               sx={{
//                 position: "absolute",
//                 right: { xs: -20, md: -60 },
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 zIndex: 2,
//                 bgcolor: "white",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//                 "&:hover": { bgcolor: theme.palette.primary.main, color: "white" },
//               }}
//             >
//               <ChevronRightIcon />
//             </IconButton>
//           </Box>
//         </Container>
//       </Box>

//       {/* ========== FINAL CTA WITH BACKGROUND IMAGE ========== */}
//       <Box
//         sx={{
//           py: 12,
//           background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
//           position: "relative",
//           overflow: "hidden",
//         }}
//       >
//         <Container maxWidth="md">
//           <Box sx={{ textAlign: "center", position: "relative", zIndex: 2 }}>
//             <AutoAwesomeIcon sx={{ fontSize: 48, color: "#FFE66D", mb: 3 }} />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 mb: 3,
//                 fontSize: { xs: "2rem", md: "3rem" },
//                 color: "white",
//               }}
//             >
//               Ready to Stop Stressing?
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 mb: 4,
//                 color: alpha(theme.palette.common.white, 0.9),
//                 maxWidth: "500px",
//                 mx: "auto",
//               }}
//             >
//               Join thousands of hosts who've automated their turnovers and regained their peace of mind.
//             </Typography>
//             <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
//               <Button
//                 variant="contained"
//                 size="large"
//                 startIcon={<AutoAwesomeIcon />}
//                 sx={{
//                   px: 5,
//                   py: 2,
//                   fontSize: "1.1rem",
//                   bgcolor: "white",
//                   color: theme.palette.primary.main,
//                   borderRadius: "50px",
//                   fontWeight: 700,
//                   "&:hover": {
//                     bgcolor: alpha(theme.palette.common.white, 0.9),
//                     transform: "translateY(-2px)",
//                   },
//                 }}
//               >
//                 Start Free Trial
//               </Button>
//               <Button
//                 variant="outlined"
//                 size="large"
//                 sx={{
//                   px: 5,
//                   py: 2,
//                   fontSize: "1.1rem",
//                   borderColor: "white",
//                   color: "white",
//                   borderRadius: "50px",
//                   fontWeight: 600,
//                   "&:hover": {
//                     bgcolor: alpha(theme.palette.common.white, 0.1),
//                     transform: "translateY(-2px)",
//                   },
//                 }}
//               >
//                 Book a Demo
//               </Button>
//             </Stack>
//             <Typography variant="body2" sx={{ mt: 4, color: alpha(theme.palette.common.white, 0.7) }}>
//               No credit card required • Cancel anytime • 14-day free trial
//             </Typography>
//           </Box>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default Home;





// import React, { useState, useEffect } from "react";
// import {
//   Grid,
//   Typography,
//   Box,
//   Button,
//   Container,
//   Card,
//   CardContent,
//   useTheme,
//   Fade,
//   Chip,
//   Stack,
//   alpha,
//   IconButton,
//   Avatar,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Paper,
//   Rating,
//   useMediaQuery,
//   CardMedia,
// } from "@mui/material";
// import { keyframes } from "@emotion/react";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import StarIcon from "@mui/icons-material/Star";
// import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import ScheduleIcon from "@mui/icons-material/Schedule";
// import MessageIcon from "@mui/icons-material/Message";
// import DashboardIcon from "@mui/icons-material/Dashboard";
// import PaymentIcon from "@mui/icons-material/Payment";
// import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
// import WarningIcon from "@mui/icons-material/Warning";
// import PersonAddIcon from "@mui/icons-material/PersonAdd";
// import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
// import SecurityIcon from "@mui/icons-material/Security";
// import GroupsIcon from "@mui/icons-material/Groups";
// import VerifiedIcon from "@mui/icons-material/Verified";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import SupportAgentIcon from "@mui/icons-material/SupportAgent";
// import PlayCircleIcon from "@mui/icons-material/PlayCircle";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import PriceChangeIcon from "@mui/icons-material/PriceChange";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// import PercentIcon from "@mui/icons-material/Percent";

// // Animations
// const floatAnimation = keyframes`
//   0%, 100% { transform: translateY(0px); }
//   50% { transform: translateY(-15px); }
// `;

// const slideInLeft = keyframes`
//   from {
//     opacity: 0;
//     transform: translateX(-60px);
//   }
//   to {
//     opacity: 1;
//     transform: translateX(0);
//   }
// `;

// const slideInRight = keyframes`
//   from {
//     opacity: 0;
//     transform: translateX(60px);
//   }
//   to {
//     opacity: 1;
//     transform: translateX(0);
//   }
// `;

// const scaleIn = keyframes`
//   from {
//     opacity: 0;
//     transform: scale(0.9);
//   }
//   to {
//     opacity: 1;
//     transform: scale(1);
//   }
// `;

// const Home = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const [testimonialIndex, setTestimonialIndex] = useState(0);

//   // Hero section - NO BLUE BACKGROUND
//   const heroContent = {
//     title: "Already Have a Cleaner?",
//     highlight: "Perfect.",
//     description: "Keep your trusted team, automate everything else. The only platform that lets you bring your own cleaners while providing backup, automation, and peace of mind.",
//     chip: "🏆 For Professional Hosts",
//   };

//   // Pain points
//   const painPoints = [
//     { icon: <MessageIcon />, text: "Endless texting & coordination", color: "#FF6B6B" },
//     { icon: <ScheduleIcon />, text: "No-show nightmares", color: "#4ECDC4" },
//     { icon: <WarningIcon />, text: "No backup when sick", color: "#FFE66D" },
//     { icon: <PhotoCameraIcon />, text: "Quality inconsistency", color: "#FF6B6B" },
//   ];

//   // Features - INCLUDING HOST-CONTROLLED PRICING
//   const features = [
//     { 
//       icon: <ScheduleIcon />, 
//       title: "Smart Scheduling", 
//       description: "Syncs with Airbnb, Vrbo, and Booking.com. Auto-schedule cleanings after every checkout.",
//       gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       badge: "Auto"
//     },
//     { 
//       icon: <PriceChangeIcon />, 
//       title: "Set Your Own Pricing", 
//       description: "You control the cleaning fee. Set different rates per property, per season, or per cleaner. No hidden platform markups - keep your margins.",
//       gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
//       badge: "NEW",
//       highlight: "Host-Controlled"
//     },
//     { 
//       icon: <PhotoCameraIcon />, 
//       title: "Photo Verification", 
//       description: "Time-stamped before/after photos. Know exactly when your property is ready.",
//       gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
//       badge: "Pro"
//     },
//     { 
//       icon: <MessageIcon />, 
//       title: "In-App Messaging", 
//       description: "Chat with cleaners, share instructions, and resolve issues instantly.",
//       gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
//       badge: "Chat"
//     },
//     { 
//       icon: <DashboardIcon />, 
//       title: "Unified Dashboard", 
//       description: "Manage all properties from one beautiful interface. Real-time updates across all listings.",
//       gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
//       badge: "Central"
//     },
//     { 
//       icon: <PaymentIcon />, 
//       title: "Flexible Payouts", 
//       description: "Pay cleaners your way - instant, weekly, or monthly. Set preferred rates for each cleaner.",
//       gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
//       badge: "Flexible"
//     },
//     { 
//       icon: <SecurityIcon />, 
//       title: "Insured & Bonded", 
//       description: "$1M coverage on every booking. Backup cleaners always available when needed.",
//       gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       badge: "Safe"
//     },
//     { 
//       icon: <AttachMoneyIcon />, 
//       title: "Transparent Pricing", 
//       description: "No surprise fees. You set the guest cleaning fee. We take a small platform fee only when you book.",
//       gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
//       badge: "Clear"
//     },
//   ];

//   // Value propositions
//   const valueProps = [
//     {
//       icon: <PriceChangeIcon />,
//       title: "You Control the Price",
//       description: "Set cleaning fees that work for your business. Charge more for peak season, less for slow periods.",
//       stat: "100% control"
//     },
//     {
//       icon: <VerifiedIcon />,
//       title: "Keep Your Cleaner",
//       description: "Invite your existing team. They keep their rates, you keep your trusted relationship.",
//       stat: "No forced upgrades"
//     },
//     {
//       icon: <GroupsIcon />,
//       title: "Backup Coverage",
//       description: "When your cleaner can't make it, we find vetted backups at YOUR set price point.",
//       stat: "Zero turnovers missed"
//     },
//   ];

//   // Stats
//   const stats = [
//     { number: "10,000+", label: "Properties Managed", icon: <GroupsIcon /> },
//     { number: "99.9%", label: "On-Time Rate", icon: <VerifiedIcon /> },
//     { number: "50K+", label: "Cleanings Completed", icon: <TrendingUpIcon /> },
//     { number: "24/7", label: "Support Available", icon: <SupportAgentIcon /> },
//   ];

//   // How it works
//   const steps = [
//     { number: "01", icon: "🏠", title: "Add Your Properties", description: "List your Airbnb properties in seconds. Add details, access codes, and special instructions." },
//     { number: "02", icon: "👥", title: "Invite Your Cleaner", description: "Bring your existing team via text or email. Set their preferred rates." },
//     { number: "03", icon: "💰", title: "Set Your Pricing", description: "Choose cleaning fees per property. Charge what makes sense for your market." },
//     { number: "04", icon: "⚡", title: "Automate Turnovers", description: "Connect your calendar. We'll schedule cleanings automatically." },
//   ];

//   // Testimonials
//   const testimonials = [
//     {
//       name: "Sarah Johnson",
//       role: "Airbnb Superhost",
//       location: "Miami, FL",
//       rating: 5,
//       comment: "Being able to set my own cleaning fees was a game-changer. I keep my margins healthy while my cleaner gets paid fairly. Everyone wins.",
//       avatar: "SJ",
//       properties: "12 Properties"
//     },
//     {
//       name: "Michael Chen",
//       role: "Property Manager",
//       location: "Austin, TX",
//       rating: 5,
//       comment: "I manage 25 properties with different cleaner rates. FreshSweeper lets me set custom pricing per property. It's the flexibility I couldn't find anywhere else.",
//       avatar: "MC",
//       properties: "25 Properties"
//     },
//     {
//       name: "Emily Rodriguez",
//       role: "Vacation Rental Investor",
//       location: "San Diego, CA",
//       rating: 5,
//       comment: "During peak season, I charge more for cleaning. Slow season, less. The control over pricing has helped me optimize my revenue significantly.",
//       avatar: "ER",
//       properties: "8 Properties"
//     }
//   ];

//   const handleNextTestimonial = () => {
//     setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
//   };

//   const handlePrevTestimonial = () => {
//     setTestimonialIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
//   };

//   return (
//     <Box sx={{ overflow: "hidden", bgcolor: theme.palette.background.default }}>
      
//       {/* ========== HERO SECTION - NO BLUE BACKGROUND ========== */}
//       <Box
//         sx={{
//           position: "relative",
//           backgroundColor: "transparent",
//           color: theme.palette.text.primary,
//           overflow: "hidden",
//           pt: { xs: 8, md: 12 },
//           pb: { xs: 8, md: 10 },
//         }}
//       >
//         <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
//           <Grid container spacing={6} alignItems="center">
//             <Grid item xs={12} md={7}>
//               <Fade in timeout={800}>
//                 <Box sx={{ animation: `${slideInLeft} 0.8s ease-out` }}>
//                   <Chip
//                     label="✨ Trusted by 10,000+ Hosts"
//                     sx={{
//                       mb: 3,
//                       background: alpha(theme.palette.primary.main, 0.1),
//                       color: theme.palette.primary.main,
//                       fontWeight: 600,
//                       fontSize: "0.9rem",
//                     }}
//                   />

//                   <Typography
//                     variant="h1"
//                     sx={{
//                       fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4.5rem" },
//                       fontWeight: 800,
//                       lineHeight: 1.1,
//                       mb: 2,
//                       color: theme.palette.text.primary,
//                     }}
//                   >
//                     {heroContent.title}
//                     <Box component="span" sx={{ display: "block", color: theme.palette.primary.main }}>
//                       {heroContent.highlight}
//                     </Box>
//                   </Typography>

//                   <Typography
//                     variant="h6"
//                     sx={{
//                       mb: 4,
//                       fontSize: "1.2rem",
//                       lineHeight: 1.6,
//                       color: theme.palette.text.secondary,
//                       maxWidth: "90%",
//                     }}
//                   >
//                     {heroContent.description}
//                   </Typography>

//                   <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 5 }}>
//                     <Button
//                       variant="contained"
//                       size="large"
//                       startIcon={<AutoAwesomeIcon />}
//                       sx={{
//                         px: 5,
//                         py: 1.8,
//                         fontSize: "1.1rem",
//                         borderRadius: "50px",
//                         fontWeight: 700,
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       Start Free
//                     </Button>
//                     <Button
//                       variant="outlined"
//                       size="large"
//                       startIcon={<PlayCircleIcon />}
//                       sx={{
//                         px: 5,
//                         py: 1.8,
//                         fontSize: "1.1rem",
//                         borderRadius: "50px",
//                         fontWeight: 600,
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       Watch Demo
//                     </Button>
//                   </Stack>

//                   {/* Stats Row */}
//                   <Grid container spacing={2}>
//                     {stats.map((stat, index) => (
//                       <Grid item xs={6} sm={3} key={index}>
//                         <Box sx={{ textAlign: "center" }}>
//                           <Box
//                             sx={{
//                               width: 40,
//                               height: 40,
//                               borderRadius: "12px",
//                               background: alpha(theme.palette.primary.main, 0.1),
//                               display: "flex",
//                               alignItems: "center",
//                               justifyContent: "center",
//                               margin: "0 auto 8px",
//                               color: theme.palette.primary.main,
//                             }}
//                           >
//                             {stat.icon}
//                           </Box>
//                           <Typography variant="h5" fontWeight="800">
//                             {stat.number}
//                           </Typography>
//                           <Typography variant="caption" color="text.secondary">
//                             {stat.label}
//                           </Typography>
//                         </Box>
//                       </Grid>
//                     ))}
//                   </Grid>
//                 </Box>
//               </Fade>
//             </Grid>

//             <Grid item xs={12} md={5}>
//               <Fade in timeout={1000}>
//                 <Box sx={{ animation: `${slideInRight} 0.8s ease-out`, position: "relative" }}>
//                   <img
//                     src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=500&h=500&fit=crop"
//                     alt="Professional cleaner"
//                     style={{
//                       width: "100%",
//                       maxWidth: 400,
//                       height: "auto",
//                       borderRadius: "30px",
//                       boxShadow: "0 30px 50px rgba(0,0,0,0.1)",
//                       display: "block",
//                       margin: "0 auto",
//                     }}
//                   />
                  
//                   {/* Floating price tag badge */}
//                   <Paper
//                     elevation={0}
//                     sx={{
//                       position: "absolute",
//                       bottom: 30,
//                       right: 20,
//                       p: 1.5,
//                       borderRadius: 3,
//                       background: "white",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 1,
//                       boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
//                     }}
//                   >
//                     <PriceChangeIcon sx={{ color: theme.palette.success.main }} />
//                     <Typography variant="body2" fontWeight="600">You set the price</Typography>
//                   </Paper>
//                 </Box>
//               </Fade>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== VALUE PROPOSITION CARDS ========== */}
//       <Box sx={{ py: 6 }}>
//         <Container maxWidth="lg">
//           <Grid container spacing={3}>
//             {valueProps.map((prop, index) => (
//               <Grid item xs={12} md={4} key={index}>
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     p: 3,
//                     borderRadius: 4,
//                     background: "white",
//                     border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//                     textAlign: "center",
//                     height: "100%",
//                     transition: "all 0.3s ease",
//                     "&:hover": {
//                       transform: "translateY(-4px)",
//                       boxShadow: theme.shadows[4],
//                     },
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       width: 60,
//                       height: 60,
//                       borderRadius: "20px",
//                       background: alpha(theme.palette.primary.main, 0.1),
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       margin: "0 auto 16px",
//                       color: theme.palette.primary.main,
//                     }}
//                   >
//                     {React.cloneElement(prop.icon, { sx: { fontSize: 32 } })}
//                   </Box>
//                   <Typography variant="h6" fontWeight="700" gutterBottom>
//                     {prop.title}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
//                     {prop.description}
//                   </Typography>
//                   <Chip
//                     label={prop.stat}
//                     size="small"
//                     sx={{ bgcolor: alpha(theme.palette.success.main, 0.1), color: theme.palette.success.main }}
//                   />
//                 </Paper>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== PAIN POINTS SECTION ========== */}
//       <Box sx={{ py: 8, bgcolor: alpha(theme.palette.error.main, 0.02) }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 6 }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 fontSize: { xs: "2rem", md: "2.5rem" },
//                 mb: 2,
//               }}
//             >
//               Stop Dealing With
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary" }}>
//               The daily frustrations of managing rentals
//             </Typography>
//           </Box>

//           <Grid container spacing={3}>
//             {painPoints.map((point, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     p: 3,
//                     textAlign: "center",
//                     borderRadius: 3,
//                     bgcolor: "white",
//                     border: `1px solid ${alpha(point.color, 0.2)}`,
//                     transition: "all 0.3s ease",
//                     "&:hover": {
//                       transform: "translateY(-4px)",
//                       boxShadow: `0 10px 30px ${alpha(point.color, 0.1)}`,
//                     },
//                   }}
//                 >
//                   <Box sx={{ color: point.color, mb: 2 }}>
//                     {React.cloneElement(point.icon, { sx: { fontSize: 40 } })}
//                   </Box>
//                   <Typography variant="h6" fontWeight="600">
//                     {point.text}
//                   </Typography>
//                 </Paper>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== SOLUTION SECTION ========== */}
//       <Box sx={{ py: 10 }}>
//         <Container maxWidth="lg">
//           <Grid container spacing={6} alignItems="center">
//             <Grid item xs={12} md={6}>
//               <Box sx={{ animation: `${scaleIn} 0.6s ease-out` }}>
//                 <Chip
//                   label="💡 The Better Way"
//                   sx={{
//                     mb: 3,
//                     bgcolor: alpha(theme.palette.success.main, 0.1),
//                     color: theme.palette.success.main,
//                     fontWeight: 600,
//                   }}
//                 />
//                 <Typography
//                   variant="h2"
//                   sx={{
//                     fontWeight: 800,
//                     mb: 3,
//                     fontSize: { xs: "2rem", md: "2.5rem" },
//                   }}
//                 >
//                   Keep Your Cleaner.
//                   <Box component="span" sx={{ color: theme.palette.primary.main, display: "block" }}>
//                     Upgrade Everything Else.
//                   </Box>
//                 </Typography>
                
//                 <Stack spacing={2} sx={{ mb: 4 }}>
//                   {[
//                     "Invite your existing cleaners via text or email with their rates",
//                     "Set custom cleaning fees per property - you're in control",
//                     "Find vetted backup cleaners instantly at your price point",
//                     "Automate every turnover with calendar sync",
//                     "Get photo proof after every cleaning",
//                   ].map((text, index) => (
//                     <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                       <Box
//                         sx={{
//                           width: 28,
//                           height: 28,
//                           borderRadius: "8px",
//                           background: theme.palette.primary.main,
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <CheckCircleIcon sx={{ fontSize: 16, color: "white" }} />
//                       </Box>
//                       <Typography variant="body1">{text}</Typography>
//                     </Box>
//                   ))}
//                 </Stack>
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <Box
//                 sx={{
//                   background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.secondary.main, 0.02)} 100%)`,
//                   borderRadius: 4,
//                   p: 4,
//                   border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//                 }}
//               >
//                 <Typography variant="h6" fontWeight="700" gutterBottom>
//                   Example: You Control Everything
//                 </Typography>
//                 <Stack spacing={2}>
//                   <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`, pb: 1 }}>
//                     <Typography variant="body2">Studio Apartment</Typography>
//                     <Typography variant="body1" fontWeight="600">$45 cleaning fee</Typography>
//                   </Box>
//                   <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`, pb: 1 }}>
//                     <Typography variant="body2">2-Bedroom Beachfront</Typography>
//                     <Typography variant="body1" fontWeight="600">$85 cleaning fee</Typography>
//                   </Box>
//                   <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`, pb: 1 }}>
//                     <Typography variant="body2">Peak Season (Dec-Feb)</Typography>
//                     <Typography variant="body1" fontWeight="600">+$25 premium</Typography>
//                   </Box>
//                   <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                     <Typography variant="body2">Your cleaner's rate</Typography>
//                     <Typography variant="body1" fontWeight="600">$40 per clean</Typography>
//                   </Box>
//                 </Stack>
//                 <Box sx={{ mt: 3, p: 2, bgcolor: alpha(theme.palette.success.main, 0.05), borderRadius: 2 }}>
//                   <Typography variant="caption" color="success.main" fontWeight="600">
//                     ✓ You keep the difference. No hidden platform markups.
//                   </Typography>
//                 </Box>
//               </Box>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== FEATURES SECTION ========== */}
//       <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip
//               label="🎯 Powerful Features"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.primary.main, 0.1),
//                 color: theme.palette.primary.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 mb: 2,
//                 fontSize: { xs: "2rem", md: "2.5rem" },
//               }}
//             >
//               Everything You Need to Scale
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               Purpose-built for hosts who want control, automation, and peace of mind
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {features.map((feature, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Card
//                   sx={{
//                     height: "100%",
//                     borderRadius: 3,
//                     transition: "all 0.3s ease",
//                     position: "relative",
//                     "&:hover": {
//                       transform: "translateY(-4px)",
//                       boxShadow: theme.shadows[4],
//                     },
//                   }}
//                 >
//                   {feature.badge === "NEW" && (
//                     <Chip
//                       label="NEW"
//                       size="small"
//                       sx={{
//                         position: "absolute",
//                         top: -10,
//                         right: 16,
//                         bgcolor: theme.palette.error.main,
//                         color: "white",
//                         fontWeight: 700,
//                       }}
//                     />
//                   )}
//                   {feature.highlight && (
//                     <Chip
//                       label={feature.highlight}
//                       size="small"
//                       sx={{
//                         position: "absolute",
//                         top: -10,
//                         left: 16,
//                         bgcolor: theme.palette.success.main,
//                         color: "white",
//                         fontWeight: 700,
//                       }}
//                     />
//                   )}
//                   <CardContent sx={{ p: 3 }}>
//                     <Box
//                       sx={{
//                         width: 48,
//                         height: 48,
//                         borderRadius: "12px",
//                         background: feature.gradient,
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         mb: 2,
//                         color: "white",
//                       }}
//                     >
//                       {React.cloneElement(feature.icon, { sx: { fontSize: 24 } })}
//                     </Box>
//                     <Typography variant="h6" fontWeight="700" gutterBottom>
//                       {feature.title}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary">
//                       {feature.description}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== PRICING CONTROL HIGHLIGHT ========== */}
//       <Box sx={{ py: 8 }}>
//         <Container maxWidth="lg">
//           <Paper
//             elevation={0}
//             sx={{
//               p: { xs: 4, md: 6 },
//               borderRadius: 4,
//               background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.secondary.main, 0.02)} 100%)`,
//               border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//               textAlign: "center",
//             }}
//           >
//             <PriceChangeIcon sx={{ fontSize: 48, color: theme.palette.primary.main, mb: 2 }} />
//             <Typography variant="h4" fontWeight="800" gutterBottom>
//               You're in Control of Pricing
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto", mb: 3 }}>
//               Set cleaning fees that work for YOUR business. Adjust by property, season, or demand.
//             </Typography>
//             <Grid container spacing={3} sx={{ maxWidth: 800, mx: "auto" }}>
//               <Grid item xs={12} sm={4}>
//                 <Typography variant="h3" fontWeight="800" color="primary.main">$0</Typography>
//                 <Typography variant="body2">Platform markup on guest fees</Typography>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Typography variant="h3" fontWeight="800" color="primary.main">100%</Typography>
//                 <Typography variant="body2">Control over your pricing</Typography>
//               </Grid>
//               <Grid item xs={12} sm={4}>
//                 <Typography variant="h3" fontWeight="800" color="primary.main">5%</Typography>
//                 <Typography variant="body2">Platform fee only on bookings</Typography>
//               </Grid>
//             </Grid>
//           </Paper>
//         </Container>
//       </Box>

//       {/* ========== HOW IT WORKS ========== */}
//       <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 mb: 2,
//                 fontSize: { xs: "2rem", md: "2.5rem" },
//               }}
//             >
//               How It Works
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary" }}>
//               Get started in minutes, not days
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {steps.map((step, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Box sx={{ textAlign: "center" }}>
//                   <Box
//                     sx={{
//                       width: 70,
//                       height: 70,
//                       borderRadius: "20px",
//                       bgcolor: alpha(theme.palette.primary.main, 0.1),
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       fontSize: "1.8rem",
//                       mx: "auto",
//                       mb: 2,
//                       position: "relative",
//                     }}
//                   >
//                     <Typography
//                       variant="caption"
//                       sx={{
//                         position: "absolute",
//                         top: -8,
//                         right: -8,
//                         bgcolor: theme.palette.primary.main,
//                         color: "white",
//                         width: 24,
//                         height: 24,
//                         borderRadius: "50%",
//                         fontSize: "0.7rem",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                       }}
//                     >
//                       {step.number}
//                     </Typography>
//                     {step.icon}
//                   </Box>
//                   <Typography variant="h6" fontWeight="700" gutterBottom>
//                     {step.title}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary">
//                     {step.description}
//                   </Typography>
//                 </Box>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== TESTIMONIALS ========== */}
//       <Box sx={{ py: 10 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip
//               label="⭐ Trusted by Hosts"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.secondary.main, 0.1),
//                 color: theme.palette.secondary.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 fontSize: { xs: "2rem", md: "2.5rem" },
//               }}
//             >
//               What Hosts Are Saying
//             </Typography>
//           </Box>

//           <Box sx={{ position: "relative", maxWidth: 800, mx: "auto" }}>
//             <IconButton
//               onClick={handlePrevTestimonial}
//               sx={{
//                 position: "absolute",
//                 left: { xs: -20, md: -50 },
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 zIndex: 2,
//                 bgcolor: "white",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//                 "&:hover": { bgcolor: theme.palette.primary.main, color: "white" },
//               }}
//             >
//               <ChevronLeftIcon />
//             </IconButton>

//             <Card sx={{ p: 4, textAlign: "center", borderRadius: 4 }}>
//               <Rating value={testimonials[testimonialIndex].rating} readOnly sx={{ mb: 2, justifyContent: "center" }} />
//               <FormatQuoteIcon sx={{ fontSize: 48, color: alpha(theme.palette.primary.main, 0.2), mb: 2 }} />
//               <Typography variant="body1" sx={{ mb: 3, fontStyle: "italic", lineHeight: 1.6 }}>
//                 "{testimonials[testimonialIndex].comment}"
//               </Typography>
//               <Box>
//                 <Typography variant="h6" fontWeight="700">
//                   {testimonials[testimonialIndex].name}
//                 </Typography>
//                 <Typography variant="body2" color="text.secondary">
//                   {testimonials[testimonialIndex].role} • {testimonials[testimonialIndex].properties}
//                 </Typography>
//               </Box>
//             </Card>

//             <IconButton
//               onClick={handleNextTestimonial}
//               sx={{
//                 position: "absolute",
//                 right: { xs: -20, md: -50 },
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 zIndex: 2,
//                 bgcolor: "white",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//                 "&:hover": { bgcolor: theme.palette.primary.main, color: "white" },
//               }}
//             >
//               <ChevronRightIcon />
//             </IconButton>
//           </Box>
//         </Container>
//       </Box>

//       {/* ========== FINAL CTA ========== */}
//       <Box
//         sx={{
//           py: 10,
//           background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
//         }}
//       >
//         <Container maxWidth="md">
//           <Box sx={{ textAlign: "center", color: "white" }}>
//             <AutoAwesomeIcon sx={{ fontSize: 48, mb: 2, opacity: 0.9 }} />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 mb: 3,
//                 fontSize: { xs: "2rem", md: "2.5rem" },
//               }}
//             >
//               Ready to Take Control?
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 mb: 4,
//                 opacity: 0.9,
//                 maxWidth: "500px",
//                 mx: "auto",
//               }}
//             >
//               Join thousands of hosts who've automated their turnovers and kept their margins healthy.
//             </Typography>
//             <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
//               <Button
//                 variant="contained"
//                 size="large"
//                 startIcon={<AutoAwesomeIcon />}
//                 sx={{
//                   px: 5,
//                   py: 2,
//                   fontSize: "1.1rem",
//                   bgcolor: "white",
//                   color: theme.palette.primary.main,
//                   borderRadius: "50px",
//                   fontWeight: 700,
//                   "&:hover": {
//                     bgcolor: alpha(theme.palette.common.white, 0.9),
//                     transform: "translateY(-2px)",
//                   },
//                 }}
//               >
//                 Start Free Trial
//               </Button>
//               <Button
//                 variant="outlined"
//                 size="large"
//                 sx={{
//                   px: 5,
//                   py: 2,
//                   fontSize: "1.1rem",
//                   borderColor: "white",
//                   color: "white",
//                   borderRadius: "50px",
//                   fontWeight: 600,
//                   "&:hover": {
//                     bgcolor: alpha(theme.palette.common.white, 0.1),
//                     transform: "translateY(-2px)",
//                   },
//                 }}
//               >
//                 Book a Demo
//               </Button>
//             </Stack>
//             <Typography variant="body2" sx={{ mt: 4, opacity: 0.7 }}>
//               No credit card required • Cancel anytime • 14-day free trial
//             </Typography>
//           </Box>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default Home;




// import React, { useState, useEffect, useRef } from "react";
// import {
//   Grid,
//   Typography,
//   Box,
//   Button,
//   Container,
//   Card,
//   CardContent,
//   useTheme,
//   Fade,
//   Chip,
//   Stack,
//   alpha,
//   IconButton,
//   Avatar,
//   Paper,
//   Rating,
//   useMediaQuery,
//   CardMedia,
//   Divider,
//   Tooltip,
//   Zoom,
// } from "@mui/material";
// import { keyframes } from "@emotion/react";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import StarIcon from "@mui/icons-material/Star";
// import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import ScheduleIcon from "@mui/icons-material/Schedule";
// import MessageIcon from "@mui/icons-material/Message";
// import DashboardIcon from "@mui/icons-material/Dashboard";
// import PaymentIcon from "@mui/icons-material/Payment";
// import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
// import WarningIcon from "@mui/icons-material/Warning";
// import PersonAddIcon from "@mui/icons-material/PersonAdd";
// import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
// import SecurityIcon from "@mui/icons-material/Security";
// import GroupsIcon from "@mui/icons-material/Groups";
// import VerifiedIcon from "@mui/icons-material/Verified";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import SupportAgentIcon from "@mui/icons-material/SupportAgent";
// import PlayCircleIcon from "@mui/icons-material/PlayCircle";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import PriceChangeIcon from "@mui/icons-material/PriceChange";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// import SpeedIcon from "@mui/icons-material/Speed";
// import SyncAltIcon from "@mui/icons-material/SyncAlt";
// import BadgeIcon from "@mui/icons-material/Badge";
// import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";

// // Import local images (update these paths)
// // import heroMainImage from "../images/cleaner-professional.jpg";
// import heroMainImage from "../images/hero_image.jpg";
// // import heroBgImage from "../images/clean-bg.jpg";

// // Animations
// const floatAnimation = keyframes`
//   0%, 100% { transform: translateY(0px) rotate(0deg); }
//   50% { transform: translateY(-10px) rotate(1deg); }
// `;

// const floatBackgroundAnimation = keyframes`
//   0%, 100% { transform: translateY(0px) scale(1); }
//   50% { transform: translateY(-5px) scale(1.02); }
// `;

// const fadeInUp = keyframes`
//   from {
//     opacity: 0;
//     transform: translateY(30px);
//   }
//   to {
//     opacity: 1;
//     transform: translateY(0);
//   }
// `;

// const slideInLeft = keyframes`
//   from {
//     opacity: 0;
//     transform: translateX(-50px);
//   }
//   to {
//     opacity: 1;
//     transform: translateX(0);
//   }
// `;

// const slideInRight = keyframes`
//   from {
//     opacity: 0;
//     transform: translateX(50px);
//   }
//   to {
//     opacity: 1;
//     transform: translateX(0);
//   }
// `;

// const scaleIn = keyframes`
//   from {
//     opacity: 0;
//     transform: scale(0.9);
//   }
//   to {
//     opacity: 1;
//     transform: scale(1);
//   }
// `;

// const Home = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const [testimonialIndex, setTestimonialIndex] = useState(0);
//   const [activeFeature, setActiveFeature] = useState(0);

//   // Hero content
//   const heroContent = {
//     title: "Already Have a Cleaner?",
//     highlight: "Perfect.",
//     description: "Keep your trusted team, automate everything else. The only platform that lets you bring your own cleaners while providing backup, automation, and total pricing control.",
//     chip: "🏆 For Professional Hosts",
//     mainImage: heroMainImage,
//     backgroundImage: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=500&h=500&fit=crop",
//     cta1: "Start Free",
//     cta2: "Bring My Cleaner",
//   };

//   // Stats
//   const stats = [
//     { number: "10,000+", label: "Properties Managed" },
//     { number: "99.9%", label: "On-Time Rate" },
//     { number: "50K+", label: "Cleanings Completed" },
//     { number: "4.9★", label: "Host Rating" },
//   ];

//   // Features - WITH SET YOUR OWN PRICE HIGHLIGHTED
//   const features = [
//     { 
//       icon: <PriceChangeIcon />, 
//       title: "Set Your Own Price", 
//       description: "You control the cleaning fee. Set different rates per property, per season, or per cleaner. No hidden markups - keep your margins.",
//       gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
//       badge: "⭐ Host Favorite",
//       highlight: true,
//       image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop"
//     },
//     { 
//       icon: <ScheduleIcon />, 
//       title: "Smart Scheduling", 
//       description: "Syncs with Airbnb, Vrbo, and Booking.com. Auto-schedule cleanings after every checkout. No more manual coordination.",
//       gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       badge: "Auto",
//       image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=600&h=400&fit=crop"
//     },
//     { 
//       icon: <PhotoCameraIcon />, 
//       title: "Photo Verification", 
//       description: "Time-stamped before/after photos. Know exactly when your property is ready. Perfect for remote hosts.",
//       gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
//       badge: "Pro",
//       image: "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?w=600&h=400&fit=crop"
//     },
//     { 
//       icon: <MessageIcon />, 
//       title: "In-App Messaging", 
//       description: "Chat with cleaners, share instructions, and resolve issues instantly. Everything in one place.",
//       gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
//       badge: "Chat",
//       image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop"
//     },
//     { 
//       icon: <DashboardIcon />, 
//       title: "Unified Dashboard", 
//       description: "Manage all properties from one beautiful interface. Real-time updates across all listings.",
//       gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
//       badge: "Central",
//       image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop"
//     },
//     { 
//       icon: <PaymentIcon />, 
//       title: "Flexible Payouts", 
//       description: "Pay cleaners your way - instant, weekly, or monthly. Set preferred rates for each cleaner.",
//       gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
//       badge: "Flexible",
//       image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop"
//     },
//   ];

//   // Pain points - fuller copy
//   const painPoints = [
//     { 
//       icon: <MessageIcon />, 
//       title: "Endless Texting", 
//       description: "Spending hours coordinating with cleaners across multiple properties? There's a better way.",
//       color: "#FF6B6B",
//       stat: "15+ hours/week wasted"
//     },
//     { 
//       icon: <ScheduleIcon />, 
//       title: "No-Show Nightmares", 
//       description: "Last-minute cancellations leading to rushed turnovers and angry guests.",
//       color: "#4ECDC4",
//       stat: "23% of hosts report no-shows"
//     },
//     { 
//       icon: <WarningIcon />, 
//       title: "No Backup Plan", 
//       description: "When your cleaner gets sick, who handles the emergency cleaning?",
//       color: "#FFE66D",
//       stat: "3-5 bookings lost annually"
//     },
//     { 
//       icon: <PhotoCameraIcon />, 
//       title: "Quality Inconsistency", 
//       description: "Different standards every time. No way to verify cleaning quality remotely.",
//       color: "#FF6B6B",
//       stat: "4.2★ vs 4.9★ potential"
//     },
//   ];

//   // Value propositions
//   const valueProps = [
//     {
//       icon: <PriceChangeIcon />,
//       title: "Set Your Own Pricing",
//       description: "Charge $50 or $150 - you decide. Adjust by property, season, or demand. Keep 100% of the cleaning fee.",
//       stat: "Up to 40% more revenue",
//       color: "#43e97b"
//     },
//     {
//       icon: <VerifiedIcon />,
//       title: "Keep Your Cleaner",
//       description: "Invite your existing team. They keep their rates, you keep your trusted relationship.",
//       stat: "Zero disruption",
//       color: "#667eea"
//     },
//     {
//       icon: <GroupsIcon />,
//       title: "Automatic Backup",
//       description: "When your cleaner can't make it, we find vetted backups at YOUR set price point.",
//       stat: "100% turnover coverage",
//       color: "#fa709a"
//     },
//   ];

//   // How it works - fuller copy
//   const steps = [
//     { 
//       number: "01", 
//       icon: "🏠", 
//       title: "Add Your Properties", 
//       description: "List your Airbnb properties in seconds. Add details, access codes, and special instructions.",
//       detail: "Takes less than 2 minutes per property"
//     },
//     { 
//       number: "02", 
//       icon: "👥", 
//       title: "Invite Your Cleaner", 
//       description: "Bring your existing team via text or email. Set their preferred rates and working hours.",
//       detail: "They'll love the automation"
//     },
//     { 
//       number: "03", 
//       icon: "💰", 
//       title: "Set Your Pricing", 
//       description: "Choose cleaning fees per property. Charge more for peak season, less for slow periods.",
//       detail: "100% control over your margins"
//     },
//     { 
//       number: "04", 
//       icon: "⚡", 
//       title: "Automate Turnovers", 
//       description: "Connect your calendar. We'll schedule cleanings automatically after every checkout.",
//       detail: "Never miss a turnover again"
//     },
//   ];

//   // Pricing examples
//   const pricingExamples = [
//     { type: "Studio Apartment", baseFee: "$45", peakFee: "$55", cleanerRate: "$35", margin: "$10-20" },
//     { type: "2-Bedroom", baseFee: "$75", peakFee: "$95", cleanerRate: "$60", margin: "$15-35" },
//     { type: "3-Bedroom House", baseFee: "$110", peakFee: "$140", cleanerRate: "$85", margin: "$25-55" },
//     { type: "Luxury Villa", baseFee: "$150", peakFee: "$200", cleanerRate: "$120", margin: "$30-80" },
//   ];

//   // Testimonials - fuller copy
//   const testimonials = [
//     {
//       name: "Sarah Johnson",
//       role: "Airbnb Superhost",
//       location: "Miami, FL",
//       rating: 5,
//       comment: "Being able to set my own cleaning fees was a game-changer. During peak season, I charge $95 instead of $75. That's an extra $20 per booking across 8 properties. The math adds up fast!",
//       avatar: "SJ",
//       properties: "12 Properties",
//       image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=600&h=400&fit=crop"
//     },
//     {
//       name: "Michael Chen",
//       role: "Property Manager",
//       location: "Austin, TX",
//       rating: 5,
//       comment: "I manage 25 properties with different cleaner rates. FreshSweeper lets me set custom pricing per property. One studio costs $45 to clean, another luxury home costs $120. The flexibility is unmatched.",
//       avatar: "MC",
//       properties: "25 Properties",
//       image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=600&h=400&fit=crop"
//     },
//     {
//       name: "Emily Rodriguez",
//       role: "Vacation Rental Investor",
//       location: "San Diego, CA",
//       rating: 5,
//       comment: "The pricing control feature alone is worth it. I can adjust cleaning fees for holidays, local events, and peak season. My cleaners get paid fairly, and I keep healthy margins.",
//       avatar: "ER",
//       properties: "8 Properties",
//       image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop"
//     }
//   ];

//   const handleNextTestimonial = () => {
//     setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
//   };

//   const handlePrevTestimonial = () => {
//     setTestimonialIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
//   };

//   // Auto-rotate featured testimonial
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
//     }, 6000);
//     return () => clearInterval(interval);
//   }, [testimonials.length]);

//   return (
//     <Box sx={{ overflow: "hidden", bgcolor: theme.palette.background.default }}>
      
//       {/* ========== HERO SECTION - AS SPECIFIED ========== */}
//       <Box
//         sx={{
//           position: "relative",
//           backgroundColor: "transparent",
//           color: theme.palette.text.primary,
//           overflow: "hidden",
//           pt: { xs: 6, md: 8 },
//           pb: { xs: 6, md: 10 },
//         }}
//       >
//         <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
//           <Grid container spacing={6} alignItems="center">
//             {/* Left Content - Text */}
//             <Grid item xs={12} md={6}>
//               <Fade in timeout={800}>
//                 <Box sx={{ animation: `${fadeInUp} 0.6s ease-out` }}>
//                   <Chip
//                     label={heroContent.chip}
//                     sx={{
//                       mb: 3,
//                       background: alpha(theme.palette.primary.main, 0.1),
//                       color: theme.palette.primary.main,
//                       fontWeight: 600,
//                       fontSize: "0.85rem",
//                     }}
//                   />

//                   <Typography
//                     variant="h1"
//                     sx={{
//                       fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4rem" },
//                       fontWeight: 700,
//                       lineHeight: 1.1,
//                       mb: 2,
//                       color: theme.palette.text.primary,
//                     }}
//                   >
//                     {heroContent.title}
//                     <Box component="span" sx={{ display: "block", color: theme.palette.primary.main }}>
//                       {heroContent.highlight}
//                     </Box>
//                   </Typography>

//                   <Typography
//                     variant="h6"
//                     sx={{
//                       mb: 4,
//                       fontSize: "1.1rem",
//                       lineHeight: 1.6,
//                       color: theme.palette.text.secondary,
//                     }}
//                   >
//                     {heroContent.description}
//                   </Typography>

//                   <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 4 }}>
//                     <Button
//                       variant="contained"
//                       size="large"
//                       sx={{
//                         px: 4,
//                         py: 1.5,
//                         fontSize: "1rem",
//                         borderRadius: "8px",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       {heroContent.cta1}
//                     </Button>
//                     <Button
//                       variant="outlined"
//                       size="large"
//                       startIcon={<PersonAddIcon />}
//                       sx={{
//                         px: 4,
//                         py: 1.5,
//                         fontSize: "1rem",
//                         borderRadius: "8px",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       {heroContent.cta2}
//                     </Button>
//                   </Stack>

//                   {/* Stats */}
//                   <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
//                     {stats.map((stat, index) => (
//                       <Box key={index}>
//                         <Typography variant="h5" fontWeight="700" color={theme.palette.primary.main}>
//                           {stat.number}
//                         </Typography>
//                         <Typography variant="body2" color={theme.palette.text.secondary}>
//                           {stat.label}
//                         </Typography>
//                       </Box>
//                     ))}
//                   </Box>
//                 </Box>
//               </Fade>
//             </Grid>

//             {/* Right Content - Double Circle Images */}
//             <Grid item xs={12} md={6}>
//               <Fade in timeout={1000}>
//                 <Box
//                   sx={{
//                     position: "relative",
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     minHeight: { xs: 350, sm: 450, md: 500 },
//                   }}
//                 >
//                   {/* Background Circle - Grayscale Image */}
//                   <Box
//                     sx={{
//                       position: "absolute",
//                       width: { xs: 280, sm: 380, md: 450 },
//                       height: { xs: 280, sm: 380, md: 450 },
//                       borderRadius: "50%",
//                       overflow: "hidden",
//                       filter: "grayscale(100%)",
//                       opacity: 0.3,
//                       animation: `${floatBackgroundAnimation} 8s ease-in-out infinite`,
//                       left: { xs: "-30px", sm: "-40px", md: "100px" },
//                     }}
//                   >
//                     <img
//                       src={heroContent.backgroundImage}
//                       alt="Background"
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                     />
//                   </Box>

//                   {/* Foreground Circle - Main Image */}
//                   <Box
//                     sx={{
//                       position: "relative",
//                       width: { xs: 220, sm: 300, md: 360 },
//                       height: { xs: 220, sm: 300, md: 360 },
//                       borderRadius: "50%",
//                       overflow: "hidden",
//                       boxShadow: `0 20px 40px ${alpha(theme.palette.primary.main, 0.15)}`,
//                       animation: `${floatAnimation} 6s ease-in-out infinite`,
//                       zIndex: 2,
//                     }}
//                   >
//                     <img
//                       src={heroContent.mainImage}
//                       alt="Cleaner"
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                     />
//                   </Box>

//                   {/* Floating price tag badge */}
//                   <Zoom in timeout={800}>
//                     <Paper
//                       elevation={0}
//                       sx={{
//                         position: "absolute",
//                         bottom: 20,
//                         right: { xs: 0, md: 40 },
//                         p: 1.5,
//                         borderRadius: 3,
//                         background: "white",
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 1,
//                         boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
//                         zIndex: 3,
//                       }}
//                     >
//                       <PriceChangeIcon sx={{ color: theme.palette.success.main }} />
//                       <Typography variant="body2" fontWeight="600">You set the price</Typography>
//                     </Paper>
//                   </Zoom>
//                 </Box>
//               </Fade>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== VALUE PROPOSITION CARDS ========== */}
//       <Container maxWidth="lg" sx={{ mt: -4, mb: 8 }}>
//         <Grid container spacing={3}>
//           {valueProps.map((prop, index) => (
//             <Grid item xs={12} md={4} key={index}>
//               <Zoom in timeout={500 + index * 200}>
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     p: 3,
//                     borderRadius: 4,
//                     background: "white",
//                     border: `1px solid ${alpha(prop.color, 0.2)}`,
//                     textAlign: "center",
//                     height: "100%",
//                     transition: "all 0.3s ease",
//                     "&:hover": {
//                       transform: "translateY(-4px)",
//                       boxShadow: `0 20px 40px ${alpha(prop.color, 0.1)}`,
//                       borderColor: prop.color,
//                     },
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       width: 64,
//                       height: 64,
//                       borderRadius: "20px",
//                       background: alpha(prop.color, 0.1),
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       margin: "0 auto 16px",
//                       color: prop.color,
//                     }}
//                   >
//                     {React.cloneElement(prop.icon, { sx: { fontSize: 32 } })}
//                   </Box>
//                   <Typography variant="h6" fontWeight="800" gutterBottom>
//                     {prop.title}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//                     {prop.description}
//                   </Typography>
//                   <Chip
//                     label={prop.stat}
//                     size="small"
//                     sx={{ bgcolor: alpha(prop.color, 0.1), color: prop.color, fontWeight: 600 }}
//                   />
//                 </Paper>
//               </Zoom>
//             </Grid>
//           ))}
//         </Grid>
//       </Container>

//       {/* ========== PAIN POINTS SECTION ========== */}
//       <Box sx={{ py: 10, bgcolor: alpha(theme.palette.error.main, 0.02) }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip
//               label="😤 Common Frustrations"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.error.main, 0.1),
//                 color: theme.palette.error.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 fontSize: { xs: "2rem", md: "2.8rem" },
//                 mb: 2,
//               }}
//             >
//               Does This Sound Familiar?
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               The daily struggles of managing short-term rental cleanings
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {painPoints.map((point, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Fade in timeout={600 + index * 100}>
//                   <Paper
//                     elevation={0}
//                     sx={{
//                       p: 3,
//                       height: "100%",
//                       borderRadius: 4,
//                       bgcolor: "white",
//                       border: `1px solid ${alpha(point.color, 0.2)}`,
//                       transition: "all 0.3s ease",
//                       "&:hover": {
//                         transform: "translateY(-8px)",
//                         boxShadow: `0 20px 40px ${alpha(point.color, 0.1)}`,
//                       },
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         width: 56,
//                         height: 56,
//                         borderRadius: "16px",
//                         background: alpha(point.color, 0.1),
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         mb: 2,
//                         color: point.color,
//                       }}
//                     >
//                       {React.cloneElement(point.icon, { sx: { fontSize: 28 } })}
//                     </Box>
//                     <Typography variant="h6" fontWeight="700" gutterBottom>
//                       {point.title}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//                       {point.description}
//                     </Typography>
//                     <Chip
//                       label={point.stat}
//                       size="small"
//                       sx={{ bgcolor: alpha(point.color, 0.1), color: point.color }}
//                     />
//                   </Paper>
//                 </Fade>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== SOLUTION SECTION ========== */}
//       <Box sx={{ py: 12 }}>
//         <Container maxWidth="lg">
//           <Grid container spacing={6} alignItems="center">
//             <Grid item xs={12} md={6}>
//               <Box sx={{ animation: `${slideInLeft} 0.6s ease-out` }}>
//                 <Chip
//                   label="💡 The Better Way"
//                   sx={{
//                     mb: 3,
//                     bgcolor: alpha(theme.palette.success.main, 0.1),
//                     color: theme.palette.success.main,
//                     fontWeight: 600,
//                   }}
//                 />
//                 <Typography
//                   variant="h2"
//                   sx={{
//                     fontWeight: 800,
//                     mb: 3,
//                     fontSize: { xs: "2rem", md: "2.8rem" },
//                   }}
//                 >
//                   Keep Your Cleaner.
//                   <Box component="span" sx={{ color: theme.palette.primary.main, display: "block" }}>
//                     Upgrade Everything Else.
//                   </Box>
//                 </Typography>
                
//                 <Stack spacing={3} sx={{ mb: 4 }}>
//                   {[
//                     { text: "Invite your existing cleaners via text or email", icon: "📱" },
//                     { text: "Set custom cleaning fees per property - you're in control", icon: "💰" },
//                     { text: "Find vetted backup cleaners instantly at your price point", icon: "🔄" },
//                     { text: "Automate every turnover with calendar sync", icon: "⚡" },
//                     { text: "Get photo proof after every cleaning", icon: "📸" },
//                   ].map((item, index) => (
//                     <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                       <Box
//                         sx={{
//                           width: 32,
//                           height: 32,
//                           borderRadius: "10px",
//                           background: theme.palette.primary.main,
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           fontSize: "1rem",
//                         }}
//                       >
//                         {item.icon}
//                       </Box>
//                       <Typography variant="body1" fontWeight="500">{item.text}</Typography>
//                     </Box>
//                   ))}
//                 </Stack>

//                 <Button
//                   variant="contained"
//                   size="large"
//                   endIcon={<ArrowForwardIcon />}
//                   sx={{
//                     borderRadius: "50px",
//                     px: 4,
//                     py: 1.5,
//                     fontSize: "1rem",
//                     fontWeight: 600,
//                   }}
//                 >
//                   See How It Works
//                 </Button>
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <Box sx={{ animation: `${slideInRight} 0.6s ease-out` }}>
//                 <img
//                   src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=600&h=500&fit=crop"
//                   alt="Cleaner working"
//                   style={{
//                     width: "100%",
//                     borderRadius: "24px",
//                     boxShadow: "0 30px 50px rgba(0,0,0,0.1)",
//                   }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== PRICING CONTROL HIGHLIGHT SECTION ========== */}
//       <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 6 }}>
//             <Chip
//               label="💰 You're in Control"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.success.main, 0.1),
//                 color: theme.palette.success.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 mb: 2,
//                 fontSize: { xs: "2rem", md: "2.8rem" },
//               }}
//             >
//               Set Your Own Cleaning Fees
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               No forced pricing. No hidden markups. You decide what to charge guests.
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             <Grid item xs={12} md={5}>
//               <Box
//                 sx={{
//                   background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.secondary.main, 0.02)} 100%)`,
//                   borderRadius: 4,
//                   p: 4,
//                   height: "100%",
//                   border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//                 }}
//               >
//                 <PriceChangeIcon sx={{ fontSize: 48, color: theme.palette.success.main, mb: 2 }} />
//                 <Typography variant="h5" fontWeight="800" gutterBottom>
//                   Why pricing control matters
//                 </Typography>
//                 <Stack spacing={2} sx={{ mb: 3 }}>
//                   <Box sx={{ display: "flex", gap: 2 }}>
//                     <VerifiedIcon sx={{ color: theme.palette.success.main }} />
//                     <Typography variant="body2">Charge more during peak season, holidays, and local events</Typography>
//                   </Box>
//                   <Box sx={{ display: "flex", gap: 2 }}>
//                     <VerifiedIcon sx={{ color: theme.palette.success.main }} />
//                     <Typography variant="body2">Offer competitive rates for longer stays</Typography>
//                   </Box>
//                   <Box sx={{ display: "flex", gap: 2 }}>
//                     <VerifiedIcon sx={{ color: theme.palette.success.main }} />
//                     <Typography variant="body2">Keep your margins healthy while cleaners earn fairly</Typography>
//                   </Box>
//                   <Box sx={{ display: "flex", gap: 2 }}>
//                     <VerifiedIcon sx={{ color: theme.palette.success.main }} />
//                     <Typography variant="body2">No surprise fees - total transparency with guests</Typography>
//                   </Box>
//                 </Stack>
//                 <Divider sx={{ my: 3 }} />
//                 <Box sx={{ textAlign: "center" }}>
//                   <Typography variant="h3" fontWeight="800" color="primary.main">0%</Typography>
//                   <Typography variant="body2" color="text.secondary">Platform markup on cleaning fees</Typography>
//                   <Typography variant="caption">You keep everything above your cleaner's rate</Typography>
//                 </Box>
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={7}>
//               <Paper elevation={0} sx={{ borderRadius: 4, overflow: "hidden", border: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
//                 <Box sx={{ p: 3, bgcolor: alpha(theme.palette.primary.main, 0.02), borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
//                   <Typography variant="h6" fontWeight="700">Example Pricing Scenarios</Typography>
//                   <Typography variant="body2" color="text.secondary">See how much margin you can keep</Typography>
//                 </Box>
//                 <Box sx={{ overflowX: "auto" }}>
//                   <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                     <thead>
//                       <tr style={{ borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
//                         <th style={{ textAlign: "left", padding: "16px" }}>Property Type</th>
//                         <th style={{ textAlign: "left", padding: "16px" }}>Base Fee</th>
//                         <th style={{ textAlign: "left", padding: "16px" }}>Peak Season</th>
//                         <th style={{ textAlign: "left", padding: "16px" }}>Cleaner Rate</th>
//                         <th style={{ textAlign: "left", padding: "16px" }}>Your Margin</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {pricingExamples.map((example, idx) => (
//                         <tr key={idx} style={{ borderBottom: idx < pricingExamples.length - 1 ? `1px solid ${alpha(theme.palette.divider, 0.1)}` : "none" }}>
//                           <td style={{ padding: "16px", fontWeight: 600 }}>{example.type}</td>
//                           <td style={{ padding: "16px" }}>{example.baseFee}</td>
//                           <td style={{ padding: "16px", color: theme.palette.warning.main, fontWeight: 600 }}>{example.peakFee}</td>
//                           <td style={{ padding: "16px", color: theme.palette.text.secondary }}>{example.cleanerRate}</td>
//                           <td style={{ padding: "16px", color: theme.palette.success.main, fontWeight: 700 }}>+{example.margin}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </Box>
//                 <Box sx={{ p: 3, bgcolor: alpha(theme.palette.success.main, 0.05), textAlign: "center" }}>
//                   <Typography variant="caption" color="success.main" fontWeight="600">
//                     💡 With 12 properties, that's an extra $240-960 per week during peak season
//                   </Typography>
//                 </Box>
//               </Paper>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== FEATURES SECTION ========== */}
//       <Box sx={{ py: 12 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip
//               label="✨ Powerful Features"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.primary.main, 0.1),
//                 color: theme.palette.primary.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 mb: 2,
//                 fontSize: { xs: "2rem", md: "2.8rem" },
//               }}
//             >
//               Everything You Need to Scale
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               Purpose-built for hosts who want control, automation, and peace of mind
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {features.map((feature, index) => (
//               <Grid item xs={12} sm={6} md={4} key={index}>
//                 <Fade in timeout={500 + index * 100}>
//                   <Card
//                     sx={{
//                       height: "100%",
//                       borderRadius: 4,
//                       overflow: "hidden",
//                       transition: "all 0.3s ease",
//                       "&:hover": {
//                         transform: "translateY(-8px)",
//                         boxShadow: theme.shadows[8],
//                       },
//                       position: "relative",
//                     }}
//                   >
//                     {feature.highlight && (
//                       <Box
//                         sx={{
//                           position: "absolute",
//                           top: 16,
//                           right: 16,
//                           zIndex: 1,
//                         }}
//                       >
//                         <Chip
//                           label={feature.badge}
//                           size="small"
//                           sx={{
//                             bgcolor: theme.palette.success.main,
//                             color: "white",
//                             fontWeight: 700,
//                             animation: "pulse 2s infinite",
//                           }}
//                         />
//                       </Box>
//                     )}
//                     <CardMedia
//                       component="img"
//                       height="200"
//                       image={feature.image}
//                       alt={feature.title}
//                     />
//                     <CardContent sx={{ p: 3 }}>
//                       <Box
//                         sx={{
//                           width: 48,
//                           height: 48,
//                           borderRadius: "16px",
//                           background: feature.gradient,
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           mb: 2,
//                           color: "white",
//                         }}
//                       >
//                         {React.cloneElement(feature.icon, { sx: { fontSize: 24 } })}
//                       </Box>
//                       <Typography variant="h6" fontWeight="800" gutterBottom>
//                         {feature.title}
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary">
//                         {feature.description}
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                 </Fade>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== HOW IT WORKS ========== */}
//       <Box sx={{ py: 12, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip
//               label="📋 Simple Setup"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.warning.main, 0.1),
//                 color: theme.palette.warning.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 mb: 2,
//                 fontSize: { xs: "2rem", md: "2.8rem" },
//               }}
//             >
//               Get Started in Minutes
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               No contracts. No hidden fees. Just better cleaning management.
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {steps.map((step, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Zoom in timeout={400 + index * 100}>
//                   <Box sx={{ textAlign: "center" }}>
//                     <Box
//                       sx={{
//                         position: "relative",
//                         width: 80,
//                         height: 80,
//                         borderRadius: "24px",
//                         bgcolor: alpha(theme.palette.primary.main, 0.1),
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         fontSize: "2rem",
//                         mx: "auto",
//                         mb: 2,
//                       }}
//                     >
//                       <Typography
//                         variant="caption"
//                         sx={{
//                           position: "absolute",
//                           top: -8,
//                           right: -8,
//                           bgcolor: theme.palette.primary.main,
//                           color: "white",
//                           width: 28,
//                           height: 28,
//                           borderRadius: "50%",
//                           fontSize: "0.75rem",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           fontWeight: "bold",
//                         }}
//                       >
//                         {step.number}
//                       </Typography>
//                       {step.icon}
//                     </Box>
//                     <Typography variant="h6" fontWeight="800" gutterBottom>
//                       {step.title}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
//                       {step.description}
//                     </Typography>
//                     <Typography variant="caption" color="primary.main" fontWeight="600">
//                       {step.detail}
//                     </Typography>
//                   </Box>
//                 </Zoom>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== TESTIMONIALS SECTION ========== */}
//       <Box sx={{ py: 12 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip
//               label="⭐ Trusted by Hosts"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.secondary.main, 0.1),
//                 color: theme.palette.secondary.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 fontSize: { xs: "2rem", md: "2.8rem" },
//               }}
//             >
//               What Hosts Are Saying
//             </Typography>
//           </Box>

//           <Box sx={{ position: "relative", maxWidth: 1000, mx: "auto" }}>
//             <IconButton
//               onClick={handlePrevTestimonial}
//               sx={{
//                 position: "absolute",
//                 left: { xs: -20, md: -50 },
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 zIndex: 2,
//                 bgcolor: "white",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//                 "&:hover": { bgcolor: theme.palette.primary.main, color: "white" },
//               }}
//             >
//               <ChevronLeftIcon />
//             </IconButton>

//             <Box>
//               <Card sx={{ borderRadius: 4, overflow: "hidden" }}>
//                 <Grid container>
//                   <Grid item xs={12} md={5}>
//                     <Box
//                       sx={{
//                         height: "100%",
//                         minHeight: 350,
//                         backgroundImage: `url(${testimonials[testimonialIndex].image})`,
//                         backgroundSize: "cover",
//                         backgroundPosition: "center",
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} md={7}>
//                     <CardContent sx={{ p: 4 }}>
//                       <Rating value={testimonials[testimonialIndex].rating} readOnly sx={{ mb: 2 }} />
//                       <FormatQuoteIcon sx={{ fontSize: 40, color: alpha(theme.palette.primary.main, 0.2), mb: 2 }} />
//                       <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6, fontStyle: "italic" }}>
//                         "{testimonials[testimonialIndex].comment}"
//                       </Typography>
//                       <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                         <Avatar
//                           sx={{
//                             width: 56,
//                             height: 56,
//                             bgcolor: theme.palette.primary.main,
//                             fontWeight: "bold",
//                           }}
//                         >
//                           {testimonials[testimonialIndex].avatar}
//                         </Avatar>
//                         <Box>
//                           <Typography variant="h6" fontWeight="800">
//                             {testimonials[testimonialIndex].name}
//                           </Typography>
//                           <Typography variant="body2" color="text.secondary">
//                             {testimonials[testimonialIndex].role} • {testimonials[testimonialIndex].properties}
//                           </Typography>
//                           <Typography variant="caption" color="text.secondary">
//                             {testimonials[testimonialIndex].location}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </CardContent>
//                   </Grid>
//                 </Grid>
//               </Card>
//             </Box>

//             <IconButton
//               onClick={handleNextTestimonial}
//               sx={{
//                 position: "absolute",
//                 right: { xs: -20, md: -50 },
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 zIndex: 2,
//                 bgcolor: "white",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//                 "&:hover": { bgcolor: theme.palette.primary.main, color: "white" },
//               }}
//             >
//               <ChevronRightIcon />
//             </IconButton>
//           </Box>

//           <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 4 }}>
//             {testimonials.map((_, index) => (
//               <Box
//                 key={index}
//                 onClick={() => setTestimonialIndex(index)}
//                 sx={{
//                   width: 10,
//                   height: 10,
//                   borderRadius: "50%",
//                   cursor: "pointer",
//                   bgcolor: index === testimonialIndex ? theme.palette.primary.main : alpha(theme.palette.primary.main, 0.3),
//                   transition: "all 0.3s ease",
//                 }}
//               />
//             ))}
//           </Box>
//         </Container>
//       </Box>

//       {/* ========== FINAL CTA ========== */}
//       <Box
//         sx={{
//           py: 12,
//           background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
//           position: "relative",
//           overflow: "hidden",
//         }}
//       >
//         <Container maxWidth="md">
//           <Box sx={{ textAlign: "center", position: "relative", zIndex: 2 }}>
//             <AutoAwesomeIcon sx={{ fontSize: 56, mb: 3, color: "#FFE66D" }} />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 mb: 3,
//                 fontSize: { xs: "2rem", md: "3rem" },
//                 color: "white",
//               }}
//             >
//               Ready to Take Control?
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 mb: 4,
//                 color: alpha(theme.palette.common.white, 0.9),
//                 maxWidth: "500px",
//                 mx: "auto",
//               }}
//             >
//               Join thousands of hosts who've automated their turnovers, set their own prices, and regained their peace of mind.
//             </Typography>
//             <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
//               <Button
//                 variant="contained"
//                 size="large"
//                 startIcon={<AutoAwesomeIcon />}
//                 sx={{
//                   px: 5,
//                   py: 2,
//                   fontSize: "1.1rem",
//                   bgcolor: "white",
//                   color: theme.palette.primary.main,
//                   borderRadius: "50px",
//                   fontWeight: 800,
//                   "&:hover": {
//                     bgcolor: alpha(theme.palette.common.white, 0.9),
//                     transform: "translateY(-2px)",
//                   },
//                 }}
//               >
//                 Start Free Trial
//               </Button>
//               <Button
//                 variant="outlined"
//                 size="large"
//                 startIcon={<PlayCircleIcon />}
//                 sx={{
//                   px: 5,
//                   py: 2,
//                   fontSize: "1.1rem",
//                   borderColor: "white",
//                   color: "white",
//                   borderRadius: "50px",
//                   fontWeight: 600,
//                   "&:hover": {
//                     bgcolor: alpha(theme.palette.common.white, 0.1),
//                     transform: "translateY(-2px)",
//                   },
//                 }}
//               >
//                 Watch Demo
//               </Button>
//             </Stack>
//             <Typography variant="body2" sx={{ mt: 4, color: alpha(theme.palette.common.white, 0.7) }}>
//               No credit card required • Cancel anytime • 14-day free trial
//             </Typography>
//           </Box>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default Home;





// import React, { useState, useEffect, useRef } from "react";
// import {
//   Grid,
//   Typography,
//   Box,
//   Button,
//   Container,
//   Card,
//   CardContent,
//   useTheme,
//   Fade,
//   Chip,
//   Stack,
//   alpha,
//   IconButton,
//   Avatar,
//   Paper,
//   Rating,
//   useMediaQuery,
//   CardMedia,
//   Divider,
//   Tooltip,
//   Zoom,
//   Dialog,
//   DialogContent,
// } from "@mui/material";
// import { keyframes } from "@emotion/react";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import StarIcon from "@mui/icons-material/Star";
// import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// import ScheduleIcon from "@mui/icons-material/Schedule";
// import MessageIcon from "@mui/icons-material/Message";
// import DashboardIcon from "@mui/icons-material/Dashboard";
// import PaymentIcon from "@mui/icons-material/Payment";
// import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
// import WarningIcon from "@mui/icons-material/Warning";
// import PersonAddIcon from "@mui/icons-material/PersonAdd";
// import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
// import SecurityIcon from "@mui/icons-material/Security";
// import GroupsIcon from "@mui/icons-material/Groups";
// import VerifiedIcon from "@mui/icons-material/Verified";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import SupportAgentIcon from "@mui/icons-material/SupportAgent";
// import PlayCircleIcon from "@mui/icons-material/PlayCircle";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import PriceChangeIcon from "@mui/icons-material/PriceChange";
// import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// import SpeedIcon from "@mui/icons-material/Speed";
// import SyncAltIcon from "@mui/icons-material/SyncAlt";
// import BadgeIcon from "@mui/icons-material/Badge";
// import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
// import PlayArrowIcon from "@mui/icons-material/PlayArrow";
// import CloseIcon from "@mui/icons-material/Close";

// // Import local images
// import heroMainImage from "../images/hero_image.jpg";

// // Animations
// const floatAnimation = keyframes`
//   0%, 100% { transform: translateY(0px) rotate(0deg); }
//   50% { transform: translateY(-10px) rotate(1deg); }
// `;

// const floatBackgroundAnimation = keyframes`
//   0%, 100% { transform: translateY(0px) scale(1); }
//   50% { transform: translateY(-5px) scale(1.02); }
// `;

// const fadeInUp = keyframes`
//   from {
//     opacity: 0;
//     transform: translateY(30px);
//   }
//   to {
//     opacity: 1;
//     transform: translateY(0);
//   }
// `;

// const slideInLeft = keyframes`
//   from {
//     opacity: 0;
//     transform: translateX(-50px);
//   }
//   to {
//     opacity: 1;
//     transform: translateX(0);
//   }
// `;

// const slideInRight = keyframes`
//   from {
//     opacity: 0;
//     transform: translateX(50px);
//   }
//   to {
//     opacity: 1;
//     transform: translateX(0);
//   }
// `;

// const scaleIn = keyframes`
//   from {
//     opacity: 0;
//     transform: scale(0.9);
//   }
//   to {
//     opacity: 1;
//     transform: scale(1);
//   }
// `;

// const Home = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const [testimonialIndex, setTestimonialIndex] = useState(0);
//   const [activeFeature, setActiveFeature] = useState(0);
//   const [videoDialogOpen, setVideoDialogOpen] = useState(false);
//   const [currentVideo, setCurrentVideo] = useState(null);
//   const [mainVideo, setMainVideo] = useState(videoPlaylist[0]);
//   const [selectedVideoId, setSelectedVideoId] = useState(videoPlaylist[0].id);

//   // Hero content
//   const heroContent = {
//     title: "Already Have a Cleaner?",
//     highlight: "Perfect.",
//     description: "Keep your trusted team, automate everything else. The only platform that lets you bring your own cleaners while providing backup, automation, and total pricing control.",
//     chip: "🏆 For Professional Hosts",
//     mainImage: heroMainImage,
//     backgroundImage: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=500&h=500&fit=crop",
//     cta1: "Start Free",
//     cta2: "Bring My Cleaner",
//   };

//   // Stats
//   const stats = [
//     { number: "10,000+", label: "Properties Managed" },
//     { number: "99.9%", label: "On-Time Rate" },
//     { number: "50K+", label: "Cleanings Completed" },
//     { number: "4.9★", label: "Host Rating" },
//   ];

//   // Features
//   const features = [
//     { 
//       icon: <PriceChangeIcon />, 
//       title: "Set Your Own Price", 
//       description: "You control the cleaning fee. Set different rates per property, per season, or per cleaner. No hidden markups - keep your margins.",
//       gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
//       badge: "⭐ Host Favorite",
//       highlight: true,
//       image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop"
//     },
//     { 
//       icon: <ScheduleIcon />, 
//       title: "Smart Scheduling", 
//       description: "Syncs with Airbnb, Vrbo, and Booking.com. Auto-schedule cleanings after every checkout. No more manual coordination.",
//       gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       badge: "Auto",
//       image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=600&h=400&fit=crop"
//     },
//     { 
//       icon: <PhotoCameraIcon />, 
//       title: "Photo Verification", 
//       description: "Time-stamped before/after photos. Know exactly when your property is ready. Perfect for remote hosts.",
//       gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
//       badge: "Pro",
//       image: "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?w=600&h=400&fit=crop"
//     },
//     { 
//       icon: <MessageIcon />, 
//       title: "In-App Messaging", 
//       description: "Chat with cleaners, share instructions, and resolve issues instantly. Everything in one place.",
//       gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
//       badge: "Chat",
//       image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop"
//     },
//     { 
//       icon: <DashboardIcon />, 
//       title: "Unified Dashboard", 
//       description: "Manage all properties from one beautiful interface. Real-time updates across all listings.",
//       gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
//       badge: "Central",
//       image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop"
//     },
//     { 
//       icon: <PaymentIcon />, 
//       title: "Flexible Payouts", 
//       description: "Pay cleaners your way - instant, weekly, or monthly. Set preferred rates for each cleaner.",
//       gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
//       badge: "Flexible",
//       image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop"
//     },
//   ];

//   // Pain points
//   const painPoints = [
//     { 
//       icon: <MessageIcon />, 
//       title: "Endless Texting", 
//       description: "Spending hours coordinating with cleaners across multiple properties? There's a better way.",
//       color: "#FF6B6B",
//       stat: "15+ hours/week wasted"
//     },
//     { 
//       icon: <ScheduleIcon />, 
//       title: "No-Show Nightmares", 
//       description: "Last-minute cancellations leading to rushed turnovers and angry guests.",
//       color: "#4ECDC4",
//       stat: "23% of hosts report no-shows"
//     },
//     { 
//       icon: <WarningIcon />, 
//       title: "No Backup Plan", 
//       description: "When your cleaner gets sick, who handles the emergency cleaning?",
//       color: "#FFE66D",
//       stat: "3-5 bookings lost annually"
//     },
//     { 
//       icon: <PhotoCameraIcon />, 
//       title: "Quality Inconsistency", 
//       description: "Different standards every time. No way to verify cleaning quality remotely.",
//       color: "#FF6B6B",
//       stat: "4.2★ vs 4.9★ potential"
//     },
//   ];

//   // Value propositions
//   const valueProps = [
//     {
//       icon: <PriceChangeIcon />,
//       title: "Set Your Own Pricing",
//       description: "Charge $50 or $150 - you decide. Adjust by property, season, or demand. Keep 100% of the cleaning fee.",
//       stat: "Up to 40% more revenue",
//       color: "#43e97b"
//     },
//     {
//       icon: <VerifiedIcon />,
//       title: "Keep Your Cleaner",
//       description: "Invite your existing team. They keep their rates, you keep your trusted relationship.",
//       stat: "Zero disruption",
//       color: "#667eea"
//     },
//     {
//       icon: <GroupsIcon />,
//       title: "Automatic Backup",
//       description: "When your cleaner can't make it, we find vetted backups at YOUR set price point.",
//       stat: "100% turnover coverage",
//       color: "#fa709a"
//     },
//   ];

//   // How it works
//   const steps = [
//     { 
//       number: "01", 
//       icon: "🏠", 
//       title: "Add Your Properties", 
//       description: "List your Airbnb properties in seconds. Add details, access codes, and special instructions.",
//       detail: "Takes less than 2 minutes per property"
//     },
//     { 
//       number: "02", 
//       icon: "👥", 
//       title: "Invite Your Cleaner", 
//       description: "Bring your existing team via text or email. Set their preferred rates and working hours.",
//       detail: "They'll love the automation"
//     },
//     { 
//       number: "03", 
//       icon: "💰", 
//       title: "Set Your Pricing", 
//       description: "Choose cleaning fees per property. Charge more for peak season, less for slow periods.",
//       detail: "100% control over your margins"
//     },
//     { 
//       number: "04", 
//       icon: "⚡", 
//       title: "Automate Turnovers", 
//       description: "Connect your calendar. We'll schedule cleanings automatically after every checkout.",
//       detail: "Never miss a turnover again"
//     },
//   ];

//   // Pricing examples
//   const pricingExamples = [
//     { type: "Studio Apartment", baseFee: "$45", peakFee: "$55", cleanerRate: "$35", margin: "$10-20" },
//     { type: "2-Bedroom", baseFee: "$75", peakFee: "$95", cleanerRate: "$60", margin: "$15-35" },
//     { type: "3-Bedroom House", baseFee: "$110", peakFee: "$140", cleanerRate: "$85", margin: "$25-55" },
//     { type: "Luxury Villa", baseFee: "$150", peakFee: "$200", cleanerRate: "$120", margin: "$30-80" },
//   ];

//   // Testimonials
//   const testimonials = [
//     {
//       name: "Sarah Johnson",
//       role: "Airbnb Superhost",
//       location: "Miami, FL",
//       rating: 5,
//       comment: "Being able to set my own cleaning fees was a game-changer. During peak season, I charge $95 instead of $75. That's an extra $20 per booking across 8 properties. The math adds up fast!",
//       avatar: "SJ",
//       properties: "12 Properties",
//       image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=600&h=400&fit=crop"
//     },
//     {
//       name: "Michael Chen",
//       role: "Property Manager",
//       location: "Austin, TX",
//       rating: 5,
//       comment: "I manage 25 properties with different cleaner rates. FreshSweeper lets me set custom pricing per property. One studio costs $45 to clean, another luxury home costs $120. The flexibility is unmatched.",
//       avatar: "MC",
//       properties: "25 Properties",
//       image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=600&h=400&fit=crop"
//     },
//     {
//       name: "Emily Rodriguez",
//       role: "Vacation Rental Investor",
//       location: "San Diego, CA",
//       rating: 5,
//       comment: "The pricing control feature alone is worth it. I can adjust cleaning fees for holidays, local events, and peak season. My cleaners get paid fairly, and I keep healthy margins.",
//       avatar: "ER",
//       properties: "8 Properties",
//       image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop"
//     }
//   ];

//   // Video playlist data
//   const videoPlaylist = [
//     {
//       id: 1,
//       title: "How FreshSweeper Automates Your Turnovers",
//       duration: "3:45",
//       thumbnail: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&h=450&fit=crop",
//       videoUrl: "https://www.youtube.com/embed/RUUqBgAS3HA",
//       description: "Watch this quick demo to see how FreshSweeper saves hosts 10+ hours per week"
//     },
//     {
//       id: 2,
//       title: "Setting Up Your First Property",
//       duration: "2:15",
//       thumbnail: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=200&h=120&fit=crop",
//       videoUrl: "https://www.youtube.com/embed/3RtPRJBuBhs",
//       description: "Add properties and configure settings in minutes"
//     },
//     {
//       id: 3,
//       title: "Inviting Your Cleaner",
//       duration: "1:45",
//       thumbnail: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=200&h=120&fit=crop",
//       videoUrl: "https://www.youtube.com/embed/3RtPRJBuBhs",
//       description: "Bring your existing team in seconds"
//     },
//     {
//       id: 4,
//       title: "Automated Scheduling Demo",
//       duration: "3:20",
//       thumbnail: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=200&h=120&fit=crop",
//       videoUrl: "https://www.youtube.com/embed/RUUqBgAS3HA",
//       description: "See how auto-scheduling works"
//     },
//     {
//       id: 5,
//       title: "Photo Verification Explained",
//       duration: "2:30",
//       thumbnail: "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?w=200&h=120&fit=crop",
//       videoUrl: "https://www.youtube.com/embed/RUUqBgAS3HA",
//       description: "Never wonder about cleaning quality"
//     },
//   ];

//   const handleNextTestimonial = () => {
//     setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
//   };

//   const handlePrevTestimonial = () => {
//     setTestimonialIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
//   };

//   const handleVideoClick = (video) => {
//     setCurrentVideo(video);
//     setVideoDialogOpen(true);
//   };

//   // Auto-rotate featured testimonial
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
//     }, 6000);
//     return () => clearInterval(interval);
//   }, [testimonials.length]);

//   return (
//     <Box sx={{ overflow: "hidden", bgcolor: theme.palette.background.default }}>
      
//       {/* ========== HERO SECTION ========== */}
//       <Box
//         sx={{
//           position: "relative",
//           backgroundColor: "transparent",
//           color: theme.palette.text.primary,
//           overflow: "hidden",
//           pt: { xs: 6, md: 8 },
//           pb: { xs: 6, md: 10 },
//         }}
//       >
//         <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
//           <Grid container spacing={6} alignItems="center">
//             {/* Left Content - Text */}
//             <Grid item xs={12} md={6}>
//               <Fade in timeout={800}>
//                 <Box sx={{ animation: `${fadeInUp} 0.6s ease-out` }}>
//                   <Chip
//                     label={heroContent.chip}
//                     sx={{
//                       mb: 3,
//                       background: alpha(theme.palette.primary.main, 0.1),
//                       color: theme.palette.primary.main,
//                       fontWeight: 600,
//                       fontSize: "0.85rem",
//                     }}
//                   />

//                   <Typography
//                     variant="h1"
//                     sx={{
//                       fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4rem" },
//                       fontWeight: 700,
//                       lineHeight: 1.1,
//                       mb: 2,
//                       color: theme.palette.text.primary,
//                     }}
//                   >
//                     {heroContent.title}
//                     <Box component="span" sx={{ display: "block", color: theme.palette.primary.main }}>
//                       {heroContent.highlight}
//                     </Box>
//                   </Typography>

//                   <Typography
//                     variant="h6"
//                     sx={{
//                       mb: 4,
//                       fontSize: "1.1rem",
//                       lineHeight: 1.6,
//                       color: theme.palette.text.secondary,
//                     }}
//                   >
//                     {heroContent.description}
//                   </Typography>

//                   <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 4 }}>
//                     <Button
//                       variant="contained"
//                       size="large"
//                       sx={{
//                         px: 4,
//                         py: 1.5,
//                         fontSize: "1rem",
//                         borderRadius: "8px",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       {heroContent.cta1}
//                     </Button>
//                     <Button
//                       variant="outlined"
//                       size="large"
//                       startIcon={<PersonAddIcon />}
//                       sx={{
//                         px: 4,
//                         py: 1.5,
//                         fontSize: "1rem",
//                         borderRadius: "8px",
//                         "&:hover": {
//                           transform: "translateY(-2px)",
//                         },
//                         transition: "all 0.3s ease",
//                       }}
//                     >
//                       {heroContent.cta2}
//                     </Button>
//                   </Stack>

//                   {/* Stats */}
//                   <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
//                     {stats.map((stat, index) => (
//                       <Box key={index}>
//                         <Typography variant="h5" fontWeight="700" color={theme.palette.primary.main}>
//                           {stat.number}
//                         </Typography>
//                         <Typography variant="body2" color={theme.palette.text.secondary}>
//                           {stat.label}
//                         </Typography>
//                       </Box>
//                     ))}
//                   </Box>
//                 </Box>
//               </Fade>
//             </Grid>

//             {/* Right Content - Double Circle Images */}
//             <Grid item xs={12} md={6}>
//               <Fade in timeout={1000}>
//                 <Box
//                   sx={{
//                     position: "relative",
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     minHeight: { xs: 350, sm: 450, md: 500 },
//                   }}
//                 >
//                   {/* Background Circle - Grayscale Image */}
//                   <Box
//                     sx={{
//                       position: "absolute",
//                       width: { xs: 280, sm: 380, md: 450 },
//                       height: { xs: 280, sm: 380, md: 450 },
//                       borderRadius: "50%",
//                       overflow: "hidden",
//                       filter: "grayscale(100%)",
//                       opacity: 0.3,
//                       animation: `${floatBackgroundAnimation} 8s ease-in-out infinite`,
//                       left: { xs: "-30px", sm: "-40px", md: "100px" },
//                     }}
//                   >
//                     <img
//                       src={heroContent.backgroundImage}
//                       alt="Background"
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                     />
//                   </Box>

//                   {/* Foreground Circle - Main Image */}
//                   <Box
//                     sx={{
//                       position: "relative",
//                       width: { xs: 220, sm: 300, md: 360 },
//                       height: { xs: 220, sm: 300, md: 360 },
//                       borderRadius: "50%",
//                       overflow: "hidden",
//                       boxShadow: `0 20px 40px ${alpha(theme.palette.primary.main, 0.15)}`,
//                       animation: `${floatAnimation} 6s ease-in-out infinite`,
//                       zIndex: 2,
//                     }}
//                   >
//                     <img
//                       src={heroContent.mainImage}
//                       alt="Cleaner"
//                       style={{
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "cover",
//                       }}
//                     />
//                   </Box>

//                   {/* Floating price tag badge */}
//                   <Zoom in timeout={800}>
//                     <Paper
//                       elevation={0}
//                       sx={{
//                         position: "absolute",
//                         bottom: 20,
//                         right: { xs: 0, md: 40 },
//                         p: 1.5,
//                         borderRadius: 3,
//                         background: "white",
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 1,
//                         boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
//                         zIndex: 3,
//                       }}
//                     >
//                       <PriceChangeIcon sx={{ color: theme.palette.success.main }} />
//                       <Typography variant="body2" fontWeight="600">You set the price</Typography>
//                     </Paper>
//                   </Zoom>
//                 </Box>
//               </Fade>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== VIDEO TUTORIAL SECTION ========== */}
//       {/* ========== VIDEO TUTORIAL SECTION ========== */}
//       <Box sx={{ py: 8, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 6 }}>
//             <Chip
//               label="🎬 Video Tutorials"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.primary.main, 0.1),
//                 color: theme.palette.primary.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 mb: 2,
//                 fontSize: { xs: "2rem", md: "2.5rem" },
//               }}
//             >
//               Watch How It Works
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}
//             >
//               See why thousands of hosts trust FreshSweeper for their turnovers
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {/* Main Feature Video - Inline Player */}
//             <Grid item xs={12} md={8}>
//               <Paper
//                 sx={{
//                   borderRadius: 4,
//                   overflow: "hidden",
//                   boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
//                   bgcolor: "#000",
//                 }}
//               >
//                 <Box sx={{ position: "relative", paddingBottom: "56.25%", height: 0 }}>
//                   <iframe
//                     src={`${mainVideo.videoUrl}?autoplay=1&rel=0&modestbranding=1`}
//                     title={mainVideo.title}
//                     frameBorder="0"
//                     allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                     allowFullScreen
//                     style={{
//                       position: "absolute",
//                       top: 0,
//                       left: 0,
//                       width: "100%",
//                       height: "100%",
//                     }}
//                   />
//                 </Box>
//               </Paper>
//               <Typography variant="h6" fontWeight="700" sx={{ mt: 2, mb: 1 }}>
//                 {mainVideo.title}
//               </Typography>
//               <Typography variant="body2" color="text.secondary">
//                 {mainVideo.description}
//               </Typography>
//             </Grid>

//             {/* Video Playlist */}
//             <Grid item xs={12} md={4}>
//               <Typography variant="subtitle1" fontWeight="700" sx={{ mb: 2 }}>
//                 More Videos
//               </Typography>
//               <Stack spacing={2}>
//                 {videoPlaylist.map((video) => (
//                   <Paper
//                     key={video.id}
//                     sx={{
//                       display: "flex",
//                       gap: 2,
//                       p: 1.5,
//                       borderRadius: 3,
//                       transition: "all 0.3s ease",
//                       cursor: "pointer",
//                       border: selectedVideoId === video.id ? `2px solid ${theme.palette.primary.main}` : "1px solid transparent",
//                       bgcolor: selectedVideoId === video.id ? alpha(theme.palette.primary.main, 0.05) : "transparent",
//                       "&:hover": {
//                         bgcolor: alpha(theme.palette.primary.main, 0.05),
//                         transform: "translateX(4px)",
//                       },
//                     }}
//                     onClick={() => {
//                       setMainVideo(video);
//                       setSelectedVideoId(video.id);
//                     }}
//                   >
//                     <Box sx={{ position: "relative", width: 120, flexShrink: 0 }}>
//                       <Box
//                         component="img"
//                         src={video.thumbnail}
//                         alt={video.title}
//                         sx={{ width: "100%", borderRadius: 2 }}
//                       />
//                       <Box
//                         sx={{
//                           position: "absolute",
//                           top: "50%",
//                           left: "50%",
//                           transform: "translate(-50%, -50%)",
//                           width: 32,
//                           height: 32,
//                           borderRadius: "50%",
//                           bgcolor: "rgba(0,0,0,0.6)",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         <PlayArrowIcon sx={{ fontSize: 16, color: "white" }} />
//                       </Box>
//                       <Box
//                         sx={{
//                           position: "absolute",
//                           bottom: 4,
//                           right: 4,
//                           bgcolor: "rgba(0,0,0,0.7)",
//                           color: "white",
//                           px: 0.5,
//                           py: 0.25,
//                           borderRadius: 1,
//                           fontSize: "0.6rem",
//                         }}
//                       >
//                         {video.duration}
//                       </Box>
//                     </Box>
//                     <Box sx={{ flex: 1 }}>
//                       <Typography variant="subtitle2" fontWeight="700" gutterBottom>
//                         {video.title}
//                       </Typography>
//                       <Typography variant="caption" color="text.secondary">
//                         {video.description}
//                       </Typography>
//                     </Box>
//                   </Paper>
//                 ))}
//               </Stack>
//             </Grid>
//           </Grid>

//           {/* View All Videos Button */}
//           <Box sx={{ textAlign: "center", mt: 6 }}>
//             <Button
//               variant="outlined"
//               size="large"
//               endIcon={<ArrowForwardIcon />}
//               sx={{
//                 borderRadius: "50px",
//                 px: 4,
//                 py: 1.2,
//                 fontSize: "0.95rem",
//                 fontWeight: 600,
//               }}
//             >
//               View All Videos
//             </Button>
//           </Box>
//         </Container>
//       </Box>

//       {/* ========== VALUE PROPOSITION CARDS ========== */}
//       <Container maxWidth="lg" sx={{ mt: -4, mb: 8 }}>
//         <Grid container spacing={3}>
//           {valueProps.map((prop, index) => (
//             <Grid item xs={12} md={4} key={index}>
//               <Zoom in timeout={500 + index * 200}>
//                 <Paper
//                   elevation={0}
//                   sx={{
//                     p: 3,
//                     borderRadius: 4,
//                     background: "white",
//                     border: `1px solid ${alpha(prop.color, 0.2)}`,
//                     textAlign: "center",
//                     height: "100%",
//                     transition: "all 0.3s ease",
//                     "&:hover": {
//                       transform: "translateY(-4px)",
//                       boxShadow: `0 20px 40px ${alpha(prop.color, 0.1)}`,
//                       borderColor: prop.color,
//                     },
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       width: 64,
//                       height: 64,
//                       borderRadius: "20px",
//                       background: alpha(prop.color, 0.1),
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                       margin: "0 auto 16px",
//                       color: prop.color,
//                     }}
//                   >
//                     {React.cloneElement(prop.icon, { sx: { fontSize: 32 } })}
//                   </Box>
//                   <Typography variant="h6" fontWeight="800" gutterBottom>
//                     {prop.title}
//                   </Typography>
//                   <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//                     {prop.description}
//                   </Typography>
//                   <Chip
//                     label={prop.stat}
//                     size="small"
//                     sx={{ bgcolor: alpha(prop.color, 0.1), color: prop.color, fontWeight: 600 }}
//                   />
//                 </Paper>
//               </Zoom>
//             </Grid>
//           ))}
//         </Grid>
//       </Container>

//       {/* ========== PAIN POINTS SECTION ========== */}
//       <Box sx={{ py: 10, bgcolor: alpha(theme.palette.error.main, 0.02) }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip
//               label="😤 Common Frustrations"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.error.main, 0.1),
//                 color: theme.palette.error.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 fontSize: { xs: "2rem", md: "2.8rem" },
//                 mb: 2,
//               }}
//             >
//               Does This Sound Familiar?
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               The daily struggles of managing short-term rental cleanings
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {painPoints.map((point, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Fade in timeout={600 + index * 100}>
//                   <Paper
//                     elevation={0}
//                     sx={{
//                       p: 3,
//                       height: "100%",
//                       borderRadius: 4,
//                       bgcolor: "white",
//                       border: `1px solid ${alpha(point.color, 0.2)}`,
//                       transition: "all 0.3s ease",
//                       "&:hover": {
//                         transform: "translateY(-8px)",
//                         boxShadow: `0 20px 40px ${alpha(point.color, 0.1)}`,
//                       },
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         width: 56,
//                         height: 56,
//                         borderRadius: "16px",
//                         background: alpha(point.color, 0.1),
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         mb: 2,
//                         color: point.color,
//                       }}
//                     >
//                       {React.cloneElement(point.icon, { sx: { fontSize: 28 } })}
//                     </Box>
//                     <Typography variant="h6" fontWeight="700" gutterBottom>
//                       {point.title}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
//                       {point.description}
//                     </Typography>
//                     <Chip
//                       label={point.stat}
//                       size="small"
//                       sx={{ bgcolor: alpha(point.color, 0.1), color: point.color }}
//                     />
//                   </Paper>
//                 </Fade>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== SOLUTION SECTION ========== */}
//       <Box sx={{ py: 12 }}>
//         <Container maxWidth="lg">
//           <Grid container spacing={6} alignItems="center">
//             <Grid item xs={12} md={6}>
//               <Box sx={{ animation: `${slideInLeft} 0.6s ease-out` }}>
//                 <Chip
//                   label="💡 The Better Way"
//                   sx={{
//                     mb: 3,
//                     bgcolor: alpha(theme.palette.success.main, 0.1),
//                     color: theme.palette.success.main,
//                     fontWeight: 600,
//                   }}
//                 />
//                 <Typography
//                   variant="h2"
//                   sx={{
//                     fontWeight: 800,
//                     mb: 3,
//                     fontSize: { xs: "2rem", md: "2.8rem" },
//                   }}
//                 >
//                   Keep Your Cleaner.
//                   <Box component="span" sx={{ color: theme.palette.primary.main, display: "block" }}>
//                     Upgrade Everything Else.
//                   </Box>
//                 </Typography>
                
//                 <Stack spacing={3} sx={{ mb: 4 }}>
//                   {[
//                     { text: "Invite your existing cleaners via text or email", icon: "📱" },
//                     { text: "Set custom cleaning fees per property - you're in control", icon: "💰" },
//                     { text: "Find vetted backup cleaners instantly at your price point", icon: "🔄" },
//                     { text: "Automate every turnover with calendar sync", icon: "⚡" },
//                     { text: "Get photo proof after every cleaning", icon: "📸" },
//                   ].map((item, index) => (
//                     <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                       <Box
//                         sx={{
//                           width: 32,
//                           height: 32,
//                           borderRadius: "10px",
//                           background: theme.palette.primary.main,
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           fontSize: "1rem",
//                         }}
//                       >
//                         {item.icon}
//                       </Box>
//                       <Typography variant="body1" fontWeight="500">{item.text}</Typography>
//                     </Box>
//                   ))}
//                 </Stack>

//                 <Button
//                   variant="contained"
//                   size="large"
//                   endIcon={<ArrowForwardIcon />}
//                   sx={{
//                     borderRadius: "50px",
//                     px: 4,
//                     py: 1.5,
//                     fontSize: "1rem",
//                     fontWeight: 600,
//                   }}
//                 >
//                   See How It Works
//                 </Button>
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <Box sx={{ animation: `${slideInRight} 0.6s ease-out` }}>
//                 <img
//                   src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=600&h=500&fit=crop"
//                   alt="Cleaner working"
//                   style={{
//                     width: "100%",
//                     borderRadius: "24px",
//                     boxShadow: "0 30px 50px rgba(0,0,0,0.1)",
//                   }}
//                 />
//               </Box>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== PRICING CONTROL HIGHLIGHT SECTION ========== */}
//       <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 6 }}>
//             <Chip
//               label="💰 You're in Control"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.success.main, 0.1),
//                 color: theme.palette.success.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 mb: 2,
//                 fontSize: { xs: "2rem", md: "2.8rem" },
//               }}
//             >
//               Set Your Own Cleaning Fees
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               No forced pricing. No hidden markups. You decide what to charge guests.
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             <Grid item xs={12} md={5}>
//               <Box
//                 sx={{
//                   background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.secondary.main, 0.02)} 100%)`,
//                   borderRadius: 4,
//                   p: 4,
//                   height: "100%",
//                   border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//                 }}
//               >
//                 <PriceChangeIcon sx={{ fontSize: 48, color: theme.palette.success.main, mb: 2 }} />
//                 <Typography variant="h5" fontWeight="800" gutterBottom>
//                   Why pricing control matters
//                 </Typography>
//                 <Stack spacing={2} sx={{ mb: 3 }}>
//                   <Box sx={{ display: "flex", gap: 2 }}>
//                     <VerifiedIcon sx={{ color: theme.palette.success.main }} />
//                     <Typography variant="body2">Charge more during peak season, holidays, and local events</Typography>
//                   </Box>
//                   <Box sx={{ display: "flex", gap: 2 }}>
//                     <VerifiedIcon sx={{ color: theme.palette.success.main }} />
//                     <Typography variant="body2">Offer competitive rates for longer stays</Typography>
//                   </Box>
//                   <Box sx={{ display: "flex", gap: 2 }}>
//                     <VerifiedIcon sx={{ color: theme.palette.success.main }} />
//                     <Typography variant="body2">Keep your margins healthy while cleaners earn fairly</Typography>
//                   </Box>
//                   <Box sx={{ display: "flex", gap: 2 }}>
//                     <VerifiedIcon sx={{ color: theme.palette.success.main }} />
//                     <Typography variant="body2">No surprise fees - total transparency with guests</Typography>
//                   </Box>
//                 </Stack>
//                 <Divider sx={{ my: 3 }} />
//                 <Box sx={{ textAlign: "center" }}>
//                   <Typography variant="h3" fontWeight="800" color="primary.main">0%</Typography>
//                   <Typography variant="body2" color="text.secondary">Platform markup on cleaning fees</Typography>
//                   <Typography variant="caption">You keep everything above your cleaner's rate</Typography>
//                 </Box>
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={7}>
//               <Paper elevation={0} sx={{ borderRadius: 4, overflow: "hidden", border: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
//                 <Box sx={{ p: 3, bgcolor: alpha(theme.palette.primary.main, 0.02), borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
//                   <Typography variant="h6" fontWeight="700">Example Pricing Scenarios</Typography>
//                   <Typography variant="body2" color="text.secondary">See how much margin you can keep</Typography>
//                 </Box>
//                 <Box sx={{ overflowX: "auto" }}>
//                   <table style={{ width: "100%", borderCollapse: "collapse" }}>
//                     <thead>
//                       <tr style={{ borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
//                         <th style={{ textAlign: "left", padding: "16px" }}>Property Type</th>
//                         <th style={{ textAlign: "left", padding: "16px" }}>Base Fee</th>
//                         <th style={{ textAlign: "left", padding: "16px" }}>Peak Season</th>
//                         <th style={{ textAlign: "left", padding: "16px" }}>Cleaner Rate</th>
//                         <th style={{ textAlign: "left", padding: "16px" }}>Your Margin</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {pricingExamples.map((example, idx) => (
//                         <tr key={idx} style={{ borderBottom: idx < pricingExamples.length - 1 ? `1px solid ${alpha(theme.palette.divider, 0.1)}` : "none" }}>
//                           <td style={{ padding: "16px", fontWeight: 600 }}>{example.type}</td>
//                           <td style={{ padding: "16px" }}>{example.baseFee}</td>
//                           <td style={{ padding: "16px", color: theme.palette.warning.main, fontWeight: 600 }}>{example.peakFee}</td>
//                           <td style={{ padding: "16px", color: theme.palette.text.secondary }}>{example.cleanerRate}</td>
//                           <td style={{ padding: "16px", color: theme.palette.success.main, fontWeight: 700 }}>+{example.margin}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </Box>
//                 <Box sx={{ p: 3, bgcolor: alpha(theme.palette.success.main, 0.05), textAlign: "center" }}>
//                   <Typography variant="caption" color="success.main" fontWeight="600">
//                     💡 With 12 properties, that's an extra $240-960 per week during peak season
//                   </Typography>
//                 </Box>
//               </Paper>
//             </Grid>
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== FEATURES SECTION ========== */}
//       <Box sx={{ py: 12 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip
//               label="✨ Powerful Features"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.primary.main, 0.1),
//                 color: theme.palette.primary.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 mb: 2,
//                 fontSize: { xs: "2rem", md: "2.8rem" },
//               }}
//             >
//               Everything You Need to Scale
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               Purpose-built for hosts who want control, automation, and peace of mind
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {features.map((feature, index) => (
//               <Grid item xs={12} sm={6} md={4} key={index}>
//                 <Fade in timeout={500 + index * 100}>
//                   <Card
//                     sx={{
//                       height: "100%",
//                       borderRadius: 4,
//                       overflow: "hidden",
//                       transition: "all 0.3s ease",
//                       "&:hover": {
//                         transform: "translateY(-8px)",
//                         boxShadow: theme.shadows[8],
//                       },
//                       position: "relative",
//                     }}
//                   >
//                     {feature.highlight && (
//                       <Box
//                         sx={{
//                           position: "absolute",
//                           top: 16,
//                           right: 16,
//                           zIndex: 1,
//                         }}
//                       >
//                         <Chip
//                           label={feature.badge}
//                           size="small"
//                           sx={{
//                             bgcolor: theme.palette.success.main,
//                             color: "white",
//                             fontWeight: 700,
//                             animation: "pulse 2s infinite",
//                           }}
//                         />
//                       </Box>
//                     )}
//                     <CardMedia
//                       component="img"
//                       height="200"
//                       image={feature.image}
//                       alt={feature.title}
//                     />
//                     <CardContent sx={{ p: 3 }}>
//                       <Box
//                         sx={{
//                           width: 48,
//                           height: 48,
//                           borderRadius: "16px",
//                           background: feature.gradient,
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           mb: 2,
//                           color: "white",
//                         }}
//                       >
//                         {React.cloneElement(feature.icon, { sx: { fontSize: 24 } })}
//                       </Box>
//                       <Typography variant="h6" fontWeight="800" gutterBottom>
//                         {feature.title}
//                       </Typography>
//                       <Typography variant="body2" color="text.secondary">
//                         {feature.description}
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                 </Fade>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== HOW IT WORKS ========== */}
//       <Box sx={{ py: 12, bgcolor: theme.palette.background.paper }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip
//               label="📋 Simple Setup"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.warning.main, 0.1),
//                 color: theme.palette.warning.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 mb: 2,
//                 fontSize: { xs: "2rem", md: "2.8rem" },
//               }}
//             >
//               Get Started in Minutes
//             </Typography>
//             <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
//               No contracts. No hidden fees. Just better cleaning management.
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {steps.map((step, index) => (
//               <Grid item xs={12} sm={6} md={3} key={index}>
//                 <Zoom in timeout={400 + index * 100}>
//                   <Box sx={{ textAlign: "center" }}>
//                     <Box
//                       sx={{
//                         position: "relative",
//                         width: 80,
//                         height: 80,
//                         borderRadius: "24px",
//                         bgcolor: alpha(theme.palette.primary.main, 0.1),
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         fontSize: "2rem",
//                         mx: "auto",
//                         mb: 2,
//                       }}
//                     >
//                       <Typography
//                         variant="caption"
//                         sx={{
//                           position: "absolute",
//                           top: -8,
//                           right: -8,
//                           bgcolor: theme.palette.primary.main,
//                           color: "white",
//                           width: 28,
//                           height: 28,
//                           borderRadius: "50%",
//                           fontSize: "0.75rem",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           fontWeight: "bold",
//                         }}
//                       >
//                         {step.number}
//                       </Typography>
//                       {step.icon}
//                     </Box>
//                     <Typography variant="h6" fontWeight="800" gutterBottom>
//                       {step.title}
//                     </Typography>
//                     <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
//                       {step.description}
//                     </Typography>
//                     <Typography variant="caption" color="primary.main" fontWeight="600">
//                       {step.detail}
//                     </Typography>
//                   </Box>
//                 </Zoom>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* ========== TESTIMONIALS SECTION ========== */}
//       <Box sx={{ py: 12 }}>
//         <Container maxWidth="lg">
//           <Box sx={{ textAlign: "center", mb: 8 }}>
//             <Chip
//               label="⭐ Trusted by Hosts"
//               sx={{
//                 mb: 2,
//                 bgcolor: alpha(theme.palette.secondary.main, 0.1),
//                 color: theme.palette.secondary.main,
//                 fontWeight: 600,
//               }}
//             />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 fontSize: { xs: "2rem", md: "2.8rem" },
//               }}
//             >
//               What Hosts Are Saying
//             </Typography>
//           </Box>

//           <Box sx={{ position: "relative", maxWidth: 1000, mx: "auto" }}>
//             <IconButton
//               onClick={handlePrevTestimonial}
//               sx={{
//                 position: "absolute",
//                 left: { xs: -20, md: -50 },
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 zIndex: 2,
//                 bgcolor: "white",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//                 "&:hover": { bgcolor: theme.palette.primary.main, color: "white" },
//               }}
//             >
//               <ChevronLeftIcon />
//             </IconButton>

//             <Box>
//               <Card sx={{ borderRadius: 4, overflow: "hidden" }}>
//                 <Grid container>
//                   <Grid item xs={12} md={5}>
//                     <Box
//                       sx={{
//                         height: "100%",
//                         minHeight: 350,
//                         backgroundImage: `url(${testimonials[testimonialIndex].image})`,
//                         backgroundSize: "cover",
//                         backgroundPosition: "center",
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} md={7}>
//                     <CardContent sx={{ p: 4 }}>
//                       <Rating value={testimonials[testimonialIndex].rating} readOnly sx={{ mb: 2 }} />
//                       <FormatQuoteIcon sx={{ fontSize: 40, color: alpha(theme.palette.primary.main, 0.2), mb: 2 }} />
//                       <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6, fontStyle: "italic" }}>
//                         "{testimonials[testimonialIndex].comment}"
//                       </Typography>
//                       <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                         <Avatar
//                           sx={{
//                             width: 56,
//                             height: 56,
//                             bgcolor: theme.palette.primary.main,
//                             fontWeight: "bold",
//                           }}
//                         >
//                           {testimonials[testimonialIndex].avatar}
//                         </Avatar>
//                         <Box>
//                           <Typography variant="h6" fontWeight="800">
//                             {testimonials[testimonialIndex].name}
//                           </Typography>
//                           <Typography variant="body2" color="text.secondary">
//                             {testimonials[testimonialIndex].role} • {testimonials[testimonialIndex].properties}
//                           </Typography>
//                           <Typography variant="caption" color="text.secondary">
//                             {testimonials[testimonialIndex].location}
//                           </Typography>
//                         </Box>
//                       </Box>
//                     </CardContent>
//                   </Grid>
//                 </Grid>
//               </Card>
//             </Box>

//             <IconButton
//               onClick={handleNextTestimonial}
//               sx={{
//                 position: "absolute",
//                 right: { xs: -20, md: -50 },
//                 top: "50%",
//                 transform: "translateY(-50%)",
//                 zIndex: 2,
//                 bgcolor: "white",
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//                 "&:hover": { bgcolor: theme.palette.primary.main, color: "white" },
//               }}
//             >
//               <ChevronRightIcon />
//             </IconButton>
//           </Box>

//           <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 4 }}>
//             {testimonials.map((_, index) => (
//               <Box
//                 key={index}
//                 onClick={() => setTestimonialIndex(index)}
//                 sx={{
//                   width: 10,
//                   height: 10,
//                   borderRadius: "50%",
//                   cursor: "pointer",
//                   bgcolor: index === testimonialIndex ? theme.palette.primary.main : alpha(theme.palette.primary.main, 0.3),
//                   transition: "all 0.3s ease",
//                 }}
//               />
//             ))}
//           </Box>
//         </Container>
//       </Box>

//       {/* ========== FINAL CTA ========== */}
//       <Box
//         sx={{
//           py: 12,
//           background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
//           position: "relative",
//           overflow: "hidden",
//         }}
//       >
//         <Container maxWidth="md">
//           <Box sx={{ textAlign: "center", position: "relative", zIndex: 2 }}>
//             <AutoAwesomeIcon sx={{ fontSize: 56, mb: 3, color: "#FFE66D" }} />
//             <Typography
//               variant="h2"
//               sx={{
//                 fontWeight: 800,
//                 mb: 3,
//                 fontSize: { xs: "2rem", md: "3rem" },
//                 color: "white",
//               }}
//             >
//               Ready to Take Control?
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 mb: 4,
//                 color: alpha(theme.palette.common.white, 0.9),
//                 maxWidth: "500px",
//                 mx: "auto",
//               }}
//             >
//               Join thousands of hosts who've automated their turnovers, set their own prices, and regained their peace of mind.
//             </Typography>
//             <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
//               <Button
//                 variant="contained"
//                 size="large"
//                 startIcon={<AutoAwesomeIcon />}
//                 sx={{
//                   px: 5,
//                   py: 2,
//                   fontSize: "1.1rem",
//                   bgcolor: "white",
//                   color: theme.palette.primary.main,
//                   borderRadius: "50px",
//                   fontWeight: 800,
//                   "&:hover": {
//                     bgcolor: alpha(theme.palette.common.white, 0.9),
//                     transform: "translateY(-2px)",
//                   },
//                 }}
//               >
//                 Start Free Trial
//               </Button>
//               <Button
//                 variant="outlined"
//                 size="large"
//                 startIcon={<PlayCircleIcon />}
//                 sx={{
//                   px: 5,
//                   py: 2,
//                   fontSize: "1.1rem",
//                   borderColor: "white",
//                   color: "white",
//                   borderRadius: "50px",
//                   fontWeight: 600,
//                   "&:hover": {
//                     bgcolor: alpha(theme.palette.common.white, 0.1),
//                     transform: "translateY(-2px)",
//                   },
//                 }}
//               >
//                 Watch Demo
//               </Button>
//             </Stack>
//             <Typography variant="body2" sx={{ mt: 4, color: alpha(theme.palette.common.white, 0.7) }}>
//               No credit card required • Cancel anytime • 14-day free trial
//             </Typography>
//           </Box>
//         </Container>
//       </Box>

//       {/* Video Dialog Modal */}
//       <Dialog
//         open={videoDialogOpen}
//         onClose={() => setVideoDialogOpen(false)}
//         maxWidth="md"
//         fullWidth
//         PaperProps={{
//           sx: {
//             borderRadius: 3,
//             bgcolor: "black",
//             maxWidth: "900px",
//           },
//         }}
//       >
//         <DialogContent sx={{ p: 0, position: "relative" }}>
//           <IconButton
//             onClick={() => setVideoDialogOpen(false)}
//             sx={{
//               position: "absolute",
//               top: 8,
//               right: 8,
//               zIndex: 1,
//               bgcolor: "rgba(0,0,0,0.5)",
//               color: "white",
//               "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//           <Box sx={{ position: "relative", paddingBottom: "56.25%", height: 0 }}>
//             {currentVideo && (
//               <iframe
//                 src={currentVideo.videoUrl}
//                 frameBorder="0"
//                 allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                 allowFullScreen
//                 style={{
//                   position: "absolute",
//                   top: 0,
//                   left: 0,
//                   width: "100%",
//                   height: "100%",
//                 }}
//                 title={currentVideo.title}
//               />
//             )}
//           </Box>
//         </DialogContent>
//       </Dialog>
//     </Box>
//   );
// };

// export default Home;







import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  Typography,
  Box,
  Button,
  Container,
  Card,
  CardContent,
  useTheme,
  Fade,
  Chip,
  Stack,
  alpha,
  IconButton,
  Avatar,
  Paper,
  Rating,
  useMediaQuery,
  CardMedia,
  Divider,
  Tooltip,
  Zoom,
} from "@mui/material";
import { keyframes } from "@emotion/react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import StarIcon from "@mui/icons-material/Star";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ScheduleIcon from "@mui/icons-material/Schedule";
import MessageIcon from "@mui/icons-material/Message";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PaymentIcon from "@mui/icons-material/Payment";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import WarningIcon from "@mui/icons-material/Warning";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import SecurityIcon from "@mui/icons-material/Security";
import GroupsIcon from "@mui/icons-material/Groups";
import VerifiedIcon from "@mui/icons-material/Verified";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import SpeedIcon from "@mui/icons-material/Speed";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import BadgeIcon from "@mui/icons-material/Badge";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import SEO from "./SEO";

// Import local images
import heroMainImage from "../images/hero_image.jpg";

// Animations
const floatAnimation = keyframes`
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-10px) rotate(1deg); }
`;

const floatBackgroundAnimation = keyframes`
  0%, 100% { transform: translateY(0px) scale(1); }
  50% { transform: translateY(-5px) scale(1.02); }
`;

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideInLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const slideInRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const scaleIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const Home = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [testimonialIndex, setTestimonialIndex] = useState(0);
  const [activeFeature, setActiveFeature] = useState(0);
  const [videoDialogOpen, setVideoDialogOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(null);

  <SEO 
      title="Home" 
      description="Freshsweeper helps Airbnb hosts automate turnovers, keep their cleaners, and control pricing. Start free." 
      canonical="https://freshsweeper.com/"
    />

  // Hero content
  const heroContent = {
    title: "Already Have a Cleaner?",
    highlight: "Perfect.",
    description: "Keep your trusted team, automate everything else. The only platform that lets you bring your own cleaners while providing backup, automation, and total pricing control.",
    chip: "🏆 For Professional Hosts",
    mainImage: heroMainImage,
    backgroundImage: "https://images.unsplash.com/photo-1583847268964-b28dc8f51f92?w=500&h=500&fit=crop",
    cta1: "Start Free",
    cta2: "Bring My Cleaner",
  };

  // Stats
  const stats = [
    { number: "10,000+", label: "Properties Managed" },
    { number: "99.9%", label: "On-Time Rate" },
    { number: "50K+", label: "Cleanings Completed" },
    { number: "4.9★", label: "Host Rating" },
  ];

  // Features
  const features = [
    { 
      icon: <PriceChangeIcon />, 
      title: "Set Your Own Price", 
      description: "You control the cleaning fee. Set different rates per property, per season, or per cleaner. No hidden markups - keep your margins.",
      gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
      badge: "⭐ Host Favorite",
      highlight: true,
      image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=600&h=400&fit=crop"
    },
    { 
      icon: <ScheduleIcon />, 
      title: "Smart Scheduling", 
      description: "Syncs with Airbnb, Vrbo, and Booking.com. Auto-schedule cleanings after every checkout. No more manual coordination.",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      badge: "Auto",
      image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=600&h=400&fit=crop"
    },
    { 
      icon: <PhotoCameraIcon />, 
      title: "Photo Verification", 
      description: "Time-stamped before/after photos. Know exactly when your property is ready. Perfect for remote hosts.",
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      badge: "Pro",
      image: "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?w=600&h=400&fit=crop"
    },
    { 
      icon: <MessageIcon />, 
      title: "In-App Messaging", 
      description: "Chat with cleaners, share instructions, and resolve issues instantly. Everything in one place.",
      gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
      badge: "Chat",
      image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=600&h=400&fit=crop"
    },
    { 
      icon: <DashboardIcon />, 
      title: "Unified Dashboard", 
      description: "Manage all properties from one beautiful interface. Real-time updates across all listings.",
      gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      badge: "Central",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop"
    },
    { 
      icon: <PaymentIcon />, 
      title: "Flexible Payouts", 
      description: "Pay cleaners your way - instant, weekly, or monthly. Set preferred rates for each cleaner.",
      gradient: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
      badge: "Flexible",
      image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=600&h=400&fit=crop"
    },
  ];

  // Pain points
  const painPoints = [
    { 
      icon: <MessageIcon />, 
      title: "Endless Texting", 
      description: "Spending hours coordinating with cleaners across multiple properties? There's a better way.",
      color: "#FF6B6B",
      stat: "15+ hours/week wasted"
    },
    { 
      icon: <ScheduleIcon />, 
      title: "No-Show Nightmares", 
      description: "Last-minute cancellations leading to rushed turnovers and angry guests.",
      color: "#4ECDC4",
      stat: "23% of hosts report no-shows"
    },
    { 
      icon: <WarningIcon />, 
      title: "No Backup Plan", 
      description: "When your cleaner gets sick, who handles the emergency cleaning?",
      color: "#FFE66D",
      stat: "3-5 bookings lost annually"
    },
    { 
      icon: <PhotoCameraIcon />, 
      title: "Quality Inconsistency", 
      description: "Different standards every time. No way to verify cleaning quality remotely.",
      color: "#FF6B6B",
      stat: "4.2★ vs 4.9★ potential"
    },
  ];

  // Value propositions
  const valueProps = [
    {
      icon: <PriceChangeIcon />,
      title: "Set Your Own Pricing",
      description: "Charge $50 or $150 - you decide. Adjust by property, season, or demand. Keep 100% of the cleaning fee.",
      stat: "Up to 40% more revenue",
      color: "#43e97b"
    },
    {
      icon: <VerifiedIcon />,
      title: "Keep Your Cleaner",
      description: "Invite your existing team. They keep their rates, you keep your trusted relationship.",
      stat: "Zero disruption",
      color: "#667eea"
    },
    {
      icon: <GroupsIcon />,
      title: "Automatic Backup",
      description: "When your cleaner can't make it, we find vetted backups at YOUR set price point.",
      stat: "100% turnover coverage",
      color: "#fa709a"
    },
  ];

  // How it works
  const steps = [
    { 
      number: "01", 
      icon: "🏠", 
      title: "Add Your Properties", 
      description: "List your Airbnb properties in seconds. Add details, access codes, and special instructions.",
      detail: "Takes less than 2 minutes per property"
    },
    { 
      number: "02", 
      icon: "👥", 
      title: "Invite Your Cleaner", 
      description: "Bring your existing team via text or email. Set their preferred rates and working hours.",
      detail: "They'll love the automation"
    },
    { 
      number: "03", 
      icon: "💰", 
      title: "Set Your Pricing", 
      description: "Choose cleaning fees per property. Charge more for peak season, less for slow periods.",
      detail: "100% control over your margins"
    },
    { 
      number: "04", 
      icon: "⚡", 
      title: "Automate Turnovers", 
      description: "Connect your calendar. We'll schedule cleanings automatically after every checkout.",
      detail: "Never miss a turnover again"
    },
  ];

  // Pricing examples
  const pricingExamples = [
    { type: "Studio Apartment", baseFee: "$45", peakFee: "$55", cleanerRate: "$35", margin: "$10-20" },
    { type: "2-Bedroom", baseFee: "$75", peakFee: "$95", cleanerRate: "$60", margin: "$15-35" },
    { type: "3-Bedroom House", baseFee: "$110", peakFee: "$140", cleanerRate: "$85", margin: "$25-55" },
    { type: "Luxury Villa", baseFee: "$150", peakFee: "$200", cleanerRate: "$120", margin: "$30-80" },
  ];

  // Testimonials
  const testimonials = [
    {
      name: "Sarah Johnson",
      role: "Airbnb Superhost",
      location: "Miami, FL",
      rating: 5,
      comment: "Being able to set my own cleaning fees was a game-changer. During peak season, I charge $95 instead of $75. That's an extra $20 per booking across 8 properties. The math adds up fast!",
      avatar: "SJ",
      properties: "12 Properties",
      image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=600&h=400&fit=crop"
    },
    {
      name: "Michael Chen",
      role: "Property Manager",
      location: "Austin, TX",
      rating: 5,
      comment: "I manage 25 properties with different cleaner rates. FreshSweeper lets me set custom pricing per property. One studio costs $45 to clean, another luxury home costs $120. The flexibility is unmatched.",
      avatar: "MC",
      properties: "25 Properties",
      image: "https://images.unsplash.com/photo-1557804506-669a67965ba0?w=600&h=400&fit=crop"
    },
    {
      name: "Emily Rodriguez",
      role: "Vacation Rental Investor",
      location: "San Diego, CA",
      rating: 5,
      comment: "The pricing control feature alone is worth it.",
      avatar: "ER",
      properties: "8 Properties",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop"
    }
  ];

  
  
  // Helper function to get YouTube thumbnail
const getYouTubeThumbnail = (videoUrl) => {
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?#]+)/,
    /youtube\.com\/shorts\/([^&?#]+)/
  ];
  
  for (const pattern of patterns) {
    const match = videoUrl.match(pattern);
    if (match && match[1]) {
      // Try maxresdefault first, fallback to hqdefault
      return `https://img.youtube.com/vi/${match[1]}/maxresdefault.jpg`;
    }
  }
  // Fallback to a placeholder if no YouTube URL
  return "https://placehold.co/800x450/3b82f6/white?text=Video";
};

// Video playlist data - DEFINE THIS BEFORE using it in useState
const videoPlaylist = [
  {
    id: 1,
    title: "How FreshSweeper Automates Your Turnovers",
    duration: "3:45",
    videoUrl: "https://www.youtube.com/embed/YCIwICINdZ4",
    thumbnail: getYouTubeThumbnail("https://www.youtube.com/embed/YCIwICINdZ4"),
    description: "Watch this quick demo to see how FreshSweeper saves hosts 10+ hours per week"
  },
  {
    id: 2,
    title: "Setting Up Your First Property",
    duration: "2:15",
    videoUrl: "https://www.youtube.com/embed/prD1UkPPeqA",
    thumbnail: getYouTubeThumbnail("https://www.youtube.com/embed/prD1UkPPeqA"),
    description: "Add properties and configure settings in minutes"
  },
  {
    id: 3,
    title: "Inviting Your Cleaner",
    duration: "1:45",
    videoUrl: "https://www.youtube.com/embed/IcLTKFTR0Vk",
    thumbnail: getYouTubeThumbnail("https://www.youtube.com/embed/IcLTKFTR0Vk"),
    description: "Bring your existing team in seconds"
  },
  {
    id: 4,
    title: "Automated Scheduling Demo",
    duration: "3:20",
    videoUrl: "https://www.youtube.com/embed/oxAw7mL7kiM",
    thumbnail: getYouTubeThumbnail("https://www.youtube.com/embed/oxAw7mL7kiM"),
    description: "See how auto-scheduling works"
  },
  {
    id: 5,
    title: "Control Your Price",
    duration: "3:20",
    videoUrl: "https://www.youtube.com/embed/3v5IJ9NsGgk",
    thumbnail: getYouTubeThumbnail("https://www.youtube.com/embed/3v5IJ9NsGgk"),
    description: "See how auto-scheduling works"
  },
];

  // NOW define state that depends on videoPlaylist
  const [mainVideo, setMainVideo] = useState(videoPlaylist[0]);
  const [selectedVideoId, setSelectedVideoId] = useState(videoPlaylist[0].id);

  const handleNextTestimonial = () => {
    setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
  };

  const handlePrevTestimonial = () => {
    setTestimonialIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const handleVideoSelect = (video) => {
    setMainVideo(video);
    setSelectedVideoId(video.id);
  };

  // Auto-rotate featured testimonial
  useEffect(() => {
    const interval = setInterval(() => {
      setTestimonialIndex((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <Box sx={{ overflow: "hidden", bgcolor: theme.palette.background.default }}>
      
      {/* ========== HERO SECTION ========== */}
      <Box
        sx={{
          position: "relative",
          backgroundColor: "transparent",
          color: theme.palette.text.primary,
          overflow: "hidden",
          pt: { xs: 6, md: 8 },
          pb: { xs: 6, md: 10 },
        }}
      >
        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
          <Grid container spacing={6} alignItems="center">
            {/* Left Content - Text */}
            <Grid item xs={12} md={6}>
              <Fade in timeout={800}>
                <Box sx={{ animation: `${fadeInUp} 0.6s ease-out` }}>
                  <Chip
                    label={heroContent.chip}
                    sx={{
                      mb: 3,
                      background: alpha(theme.palette.primary.main, 0.1),
                      color: theme.palette.primary.main,
                      fontWeight: 600,
                      fontSize: "0.85rem",
                    }}
                  />

                  <Typography
                    variant="h1"
                    sx={{
                      fontSize: { xs: "2.5rem", md: "3.5rem", lg: "4rem" },
                      fontWeight: 700,
                      lineHeight: 1.1,
                      mb: 2,
                      color: theme.palette.text.primary,
                    }}
                  >
                    {heroContent.title}
                    <Box component="span" sx={{ display: "block", color: theme.palette.primary.main }}>
                      {heroContent.highlight}
                    </Box>
                  </Typography>

                  <Typography
                    variant="h6"
                    sx={{
                      mb: 4,
                      fontSize: "1.1rem",
                      lineHeight: 1.6,
                      color: theme.palette.text.secondary,
                    }}
                  >
                    {heroContent.description}
                  </Typography>

                  <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ mb: 4 }}>
                    <Button
                      variant="contained"
                      size="large"
                      sx={{
                        px: 4,
                        py: 1.5,
                        fontSize: "1rem",
                        borderRadius: "8px",
                        "&:hover": {
                          transform: "translateY(-2px)",
                        },
                        transition: "all 0.3s ease",
                      }}
                    >
                      {heroContent.cta1}
                    </Button>
                    <Button
                      variant="outlined"
                      size="large"
                      startIcon={<PersonAddIcon />}
                      sx={{
                        px: 4,
                        py: 1.5,
                        fontSize: "1rem",
                        borderRadius: "8px",
                        "&:hover": {
                          transform: "translateY(-2px)",
                        },
                        transition: "all 0.3s ease",
                      }}
                    >
                      {heroContent.cta2}
                    </Button>
                  </Stack>

                  {/* Stats */}
                  <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
                    {stats.map((stat, index) => (
                      <Box key={index}>
                        <Typography variant="h5" fontWeight="700" color={theme.palette.primary.main}>
                          {stat.number}
                        </Typography>
                        <Typography variant="body2" color={theme.palette.text.secondary}>
                          {stat.label}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Fade>
            </Grid>

            {/* Right Content - Double Circle Images */}
            <Grid item xs={12} md={6}>
              <Fade in timeout={1000}>
                <Box
                  sx={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: { xs: 350, sm: 450, md: 500 },
                  }}
                >
                  {/* Background Circle - Grayscale Image */}
                  <Box
                    sx={{
                      position: "absolute",
                      width: { xs: 280, sm: 380, md: 450 },
                      height: { xs: 280, sm: 380, md: 450 },
                      borderRadius: "50%",
                      overflow: "hidden",
                      filter: "grayscale(100%)",
                      opacity: 0.3,
                      animation: `${floatBackgroundAnimation} 8s ease-in-out infinite`,
                      left: { xs: "-30px", sm: "-40px", md: "100px" },
                    }}
                  >
                    <img
                      src={heroContent.backgroundImage}
                      alt="Background"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>

                  {/* Foreground Circle - Main Image */}
                  <Box
                    sx={{
                      position: "relative",
                      width: { xs: 220, sm: 300, md: 360 },
                      height: { xs: 220, sm: 300, md: 360 },
                      borderRadius: "50%",
                      overflow: "hidden",
                      boxShadow: `0 20px 40px ${alpha(theme.palette.primary.main, 0.15)}`,
                      animation: `${floatAnimation} 6s ease-in-out infinite`,
                      zIndex: 2,
                    }}
                  >
                    <img
                      src={heroContent.mainImage}
                      alt="Cleaner"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>

                  {/* Floating price tag badge */}
                  <Zoom in timeout={800}>
                    <Paper
                      elevation={0}
                      sx={{
                        position: "absolute",
                        bottom: 20,
                        right: { xs: 0, md: 40 },
                        p: 1.5,
                        borderRadius: 3,
                        background: "white",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                        zIndex: 3,
                      }}
                    >
                      <PriceChangeIcon sx={{ color: theme.palette.success.main }} />
                      <Typography variant="body2" fontWeight="600">You set the price</Typography>
                    </Paper>
                  </Zoom>
                </Box>
              </Fade>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* ========== VIDEO TUTORIAL SECTION - INLINE PLAYER ========== */}
      <Box sx={{ py: 8, bgcolor: theme.palette.background.paper }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 6 }}>
            <Chip
              label="🎬 Video Tutorials"
              sx={{
                mb: 2,
                bgcolor: alpha(theme.palette.primary.main, 0.1),
                color: theme.palette.primary.main,
                fontWeight: 600,
              }}
            />
            <Typography
              variant="h2"
              sx={{
                fontWeight: 800,
                mb: 2,
                fontSize: { xs: "2rem", md: "2.5rem" },
              }}
            >
              Watch How It Works
            </Typography>
            <Typography
              variant="h6"
              sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}
            >
              See why thousands of hosts trust FreshSweeper for their turnovers
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {/* Main Feature Video - Inline Player */}
            <Grid item xs={12} md={8}>
              <Paper
                sx={{
                  borderRadius: 4,
                  overflow: "hidden",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                  bgcolor: "#000",
                }}
              >
                <Box sx={{ position: "relative", paddingBottom: "56.25%", height: 0 }}>
                  <iframe
                    src={`${mainVideo.videoUrl}?autoplay=1&rel=0&modestbranding=1`}
                    title={mainVideo.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Box>
              </Paper>
              <Typography variant="h6" fontWeight="700" sx={{ mt: 2, mb: 1 }}>
                {mainVideo.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {mainVideo.description}
              </Typography>
            </Grid>

            {/* Video Playlist */}
            <Grid item xs={12} md={4}>
              <Typography variant="subtitle1" fontWeight="700" sx={{ mb: 2 }}>
                More Videos
              </Typography>
              <Stack spacing={2}>
                {videoPlaylist.map((video) => (
                  <Paper
                    key={video.id}
                    sx={{
                      display: "flex",
                      gap: 2,
                      p: 1.5,
                      borderRadius: 3,
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      border: selectedVideoId === video.id ? `2px solid ${theme.palette.primary.main}` : "1px solid transparent",
                      bgcolor: selectedVideoId === video.id ? alpha(theme.palette.primary.main, 0.05) : "transparent",
                      "&:hover": {
                        bgcolor: alpha(theme.palette.primary.main, 0.05),
                        transform: "translateX(4px)",
                      },
                    }}
                    onClick={() => handleVideoSelect(video)}
                  >
                    <Box sx={{ position: "relative", width: 120, flexShrink: 0 }}>
                      <Box
                        component="img"
                        src={video.thumbnail}
                        alt={video.title}
                        sx={{ width: "100%", borderRadius: 2 }}
                      />
                      <Box
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          width: 32,
                          height: 32,
                          borderRadius: "50%",
                          bgcolor: "rgba(0,0,0,0.6)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <PlayArrowIcon sx={{ fontSize: 16, color: "white" }} />
                      </Box>
                      <Box
                        sx={{
                          position: "absolute",
                          bottom: 4,
                          right: 4,
                          bgcolor: "rgba(0,0,0,0.7)",
                          color: "white",
                          px: 0.5,
                          py: 0.25,
                          borderRadius: 1,
                          fontSize: "0.6rem",
                        }}
                      >
                        {video.duration}
                      </Box>
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="subtitle2" fontWeight="700">
                        {video.title}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {video.description?.split(" ").slice(0, 5).join(" ")}
                      </Typography>
                    </Box>
                  </Paper>
                ))}
              </Stack>
            </Grid>
          </Grid>

          {/* View All Videos Button */}
          <Box sx={{ textAlign: "center", mt: 6 }}>
            <Button
              variant="outlined"
              size="large"
              endIcon={<ArrowForwardIcon />}
              sx={{
                borderRadius: "50px",
                px: 4,
                py: 1.2,
                fontSize: "0.95rem",
                fontWeight: 600,
              }}
            >
              View All Videos
            </Button>
          </Box>
        </Container>
      </Box>

      {/* ========== VALUE PROPOSITION CARDS ========== */}
      <Container maxWidth="lg" sx={{ mt: -4, mb: 8 }}>
        <Grid container spacing={3}>
          {valueProps.map((prop, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Zoom in timeout={500 + index * 200}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    background: "white",
                    border: `1px solid ${alpha(prop.color, 0.2)}`,
                    textAlign: "center",
                    height: "100%",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: `0 20px 40px ${alpha(prop.color, 0.1)}`,
                      borderColor: prop.color,
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: "20px",
                      background: alpha(prop.color, 0.1),
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                      color: prop.color,
                    }}
                  >
                    {React.cloneElement(prop.icon, { sx: { fontSize: 32 } })}
                  </Box>
                  <Typography variant="h6" fontWeight="800" gutterBottom>
                    {prop.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {prop.description}
                  </Typography>
                  <Chip
                    label={prop.stat}
                    size="small"
                    sx={{ bgcolor: alpha(prop.color, 0.1), color: prop.color, fontWeight: 600 }}
                  />
                </Paper>
              </Zoom>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* ========== PAIN POINTS SECTION ========== */}
      <Box sx={{ py: 10, bgcolor: alpha(theme.palette.error.main, 0.02) }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Chip
              label="😤 Common Frustrations"
              sx={{
                mb: 2,
                bgcolor: alpha(theme.palette.error.main, 0.1),
                color: theme.palette.error.main,
                fontWeight: 600,
              }}
            />
            <Typography
              variant="h2"
              sx={{
                fontWeight: 800,
                fontSize: { xs: "2rem", md: "2.8rem" },
                mb: 2,
              }}
            >
              Does This Sound Familiar?
            </Typography>
            <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
              The daily struggles of managing short-term rental cleanings
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {painPoints.map((point, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Fade in timeout={600 + index * 100}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3,
                      height: "100%",
                      borderRadius: 4,
                      bgcolor: "white",
                      border: `1px solid ${alpha(point.color, 0.2)}`,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-8px)",
                        boxShadow: `0 20px 40px ${alpha(point.color, 0.1)}`,
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: 56,
                        height: 56,
                        borderRadius: "16px",
                        background: alpha(point.color, 0.1),
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 2,
                        color: point.color,
                      }}
                    >
                      {React.cloneElement(point.icon, { sx: { fontSize: 28 } })}
                    </Box>
                    <Typography variant="h6" fontWeight="700" gutterBottom>
                      {point.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                      {point.description}
                    </Typography>
                    <Chip
                      label={point.stat}
                      size="small"
                      sx={{ bgcolor: alpha(point.color, 0.1), color: point.color }}
                    />
                  </Paper>
                </Fade>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* ========== SOLUTION SECTION ==========
      <Box sx={{ py: 12 }}>
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box sx={{ animation: `${slideInLeft} 0.6s ease-out` }}>
                <Chip
                  label="💡 The Better Way"
                  sx={{
                    mb: 3,
                    bgcolor: alpha(theme.palette.success.main, 0.1),
                    color: theme.palette.success.main,
                    fontWeight: 600,
                  }}
                />
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 800,
                    mb: 3,
                    fontSize: { xs: "2rem", md: "2.8rem" },
                  }}
                >
                  Keep Your Cleaner.
                  <Box component="span" sx={{ color: theme.palette.primary.main, display: "block" }}>
                    Upgrade Everything Else.
                  </Box>
                </Typography>
                
                <Stack spacing={3} sx={{ mb: 4 }}>
                  {[
                    { text: "Invite your existing cleaners via text or email", icon: "📱" },
                    { text: "Set custom cleaning fees per property - you're in control", icon: "💰" },
                    { text: "Find vetted backup cleaners instantly at your price point", icon: "🔄" },
                    { text: "Automate every turnover with calendar sync", icon: "⚡" },
                    { text: "Get photo proof after every cleaning", icon: "📸" },
                  ].map((item, index) => (
                    <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Box
                        sx={{
                          width: 32,
                          height: 32,
                          borderRadius: "10px",
                          background: theme.palette.primary.main,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "1rem",
                        }}
                      >
                        {item.icon}
                      </Box>
                      <Typography variant="body1" fontWeight="500">{item.text}</Typography>
                    </Box>
                  ))}
                </Stack>

                <Button
                  variant="contained"
                  size="large"
                  endIcon={<ArrowForwardIcon />}
                  sx={{
                    borderRadius: "50px",
                    px: 4,
                    py: 1.5,
                    fontSize: "1rem",
                    fontWeight: 600,
                  }}
                >
                  See How It Works
                </Button>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ animation: `${slideInRight} 0.6s ease-out` }}>
                <img
                  src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=600&h=500&fit=crop"
                  alt="Cleaner working"
                  style={{
                    width: "100%",
                    borderRadius: "24px",
                    boxShadow: "0 30px 50px rgba(0,0,0,0.1)",
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box> */}


      {/* ========== SOLUTION SECTION - REDESIGNED ========== */}
      <Box sx={{ 
        py: 12, 
        bgcolor: alpha(theme.palette.primary.main, 0.02),
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '1px',
          background: `linear-gradient(90deg, transparent, ${theme.palette.primary.main}, transparent)`,
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: '1px',
          background: `linear-gradient(90deg, transparent, ${theme.palette.primary.main}, transparent)`,
        }
      }}>
        {/* Animated background elements */}
        <Box sx={{ position: 'absolute', top: '10%', left: '5%', opacity: 0.03, fontSize: '200px', transform: 'rotate(15deg)' }}>
          <CleaningServicesIcon sx={{ fontSize: 200 }} />
        </Box>
        <Box sx={{ position: 'absolute', bottom: '10%', right: '5%', opacity: 0.03, fontSize: '200px', transform: 'rotate(-15deg)' }}>
          <AutoAwesomeIcon sx={{ fontSize: 200 }} />
        </Box>
        
        <Container maxWidth="xl">
          <Grid container spacing={8} alignItems="center">
            {/* Left Column - Content */}
            <Grid item xs={12} md={6}>
              <Fade in timeout={800}>
                <Box>
                  <Chip
                    label="💡 The Better Way"
                    sx={{
                      mb: 3,
                      bgcolor: alpha(theme.palette.success.main, 0.15),
                      color: theme.palette.success.main,
                      fontWeight: 700,
                      fontSize: '0.85rem',
                      px: 1,
                      backdropFilter: 'blur(10px)',
                    }}
                  />
                  
                  <Typography
                    variant="h2"
                    sx={{
                      fontWeight: 800,
                      mb: 2,
                      fontSize: { xs: "2rem", md: "2.8rem", lg: "3.2rem" },
                      lineHeight: 1.2,
                      background: `linear-gradient(135deg, ${theme.palette.text.primary}, ${theme.palette.primary.main})`,
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      color: 'transparent',
                    }}
                  >
                    Keep Your Cleaner.
                    <Box component="span" sx={{ 
                      display: "block", 
                      color: theme.palette.primary.main,
                      background: 'none',
                      WebkitBackgroundClip: 'unset',
                    }}>
                      Upgrade Everything Else.
                    </Box>
                  </Typography>
                  
                  <Typography
                    variant="body1"
                    sx={{
                      mb: 4,
                      color: theme.palette.text.secondary,
                      fontSize: '1.1rem',
                      lineHeight: 1.6,
                      maxWidth: '90%',
                    }}
                  >
                    The only platform that lets you bring your own cleaners while automating everything else. 
                    Keep your trusted relationships and upgrade to modern, stress-free management.
                  </Typography>
                  
                  <Stack spacing={2.5} sx={{ mb: 5 }}>
                    {[
                      { 
                        icon: <PersonAddIcon />, 
                        text: "Invite your existing cleaners via text or email", 
                        color: "#10b981",
                        delay: 0
                      },
                      { 
                        icon: <PriceChangeIcon />, 
                        text: "Set custom cleaning fees per property - you're in control", 
                        color: "#f59e0b",
                        delay: 100
                      },
                      { 
                        icon: <GroupsIcon />, 
                        text: "Find vetted backup cleaners instantly at your price point", 
                        color: "#8b5cf6",
                        delay: 200
                      },
                      { 
                        icon: <ScheduleIcon />, 
                        text: "Automate every turnover with calendar sync", 
                        color: "#3b82f6",
                        delay: 300
                      },
                      { 
                        icon: <PhotoCameraIcon />, 
                        text: "Get photo proof after every cleaning", 
                        color: "#ef4444",
                        delay: 400
                      },
                    ].map((item, index) => (
                      <Zoom in timeout={500 + item.delay} key={index}>
                        <Box sx={{ 
                          display: "flex", 
                          alignItems: "center", 
                          gap: 2,
                          p: 1.5,
                          borderRadius: 3,
                          transition: 'all 0.3s ease',
                          cursor: 'pointer',
                          '&:hover': {
                            transform: 'translateX(8px)',
                            bgcolor: alpha(item.color, 0.05),
                          },
                        }}>
                          <Box
                            sx={{
                              width: 44,
                              height: 44,
                              borderRadius: "14px",
                              background: alpha(item.color, 0.12),
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: item.color,
                              transition: 'all 0.3s ease',
                              '&:hover': {
                                transform: 'scale(1.05)',
                                background: alpha(item.color, 0.2),
                              },
                            }}
                          >
                            {React.cloneElement(item.icon, { sx: { fontSize: 24 } })}
                          </Box>
                          <Typography variant="body1" fontWeight="500" sx={{ flex: 1 }}>
                            {item.text}
                          </Typography>
                          <ArrowForwardIcon sx={{ color: item.color, fontSize: 18, opacity: 0.5 }} />
                        </Box>
                      </Zoom>
                    ))}
                  </Stack>

                  <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    <Button
                      variant="contained"
                      size="large"
                      endIcon={<ArrowForwardIcon />}
                      sx={{
                        borderRadius: "50px",
                        px: 5,
                        py: 1.5,
                        fontSize: "1rem",
                        fontWeight: 700,
                        background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`,
                        boxShadow: `0 4px 15px ${alpha(theme.palette.primary.main, 0.3)}`,
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-2px)',
                          boxShadow: `0 8px 25px ${alpha(theme.palette.primary.main, 0.4)}`,
                        },
                      }}
                    >
                      See How It Works
                    </Button>
                    <Button
                      variant="outlined"
                      size="large"
                      startIcon={<PlayCircleIcon />}
                      sx={{
                        borderRadius: "50px",
                        px: 4,
                        py: 1.5,
                        fontSize: "1rem",
                        fontWeight: 600,
                        borderColor: alpha(theme.palette.primary.main, 0.3),
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          transform: 'translateY(-2px)',
                          borderColor: theme.palette.primary.main,
                          bgcolor: alpha(theme.palette.primary.main, 0.05),
                        },
                      }}
                    >
                      Watch Demo Video
                    </Button>
                  </Box>
                </Box>
              </Fade>
            </Grid>

            {/* Right Column - Animated Image Card */}
            <Grid item xs={12} md={6}>
              <Fade in timeout={1000}>
                <Box sx={{ 
                  animation: `${slideInRight} 0.6s ease-out`,
                  position: 'relative',
                }}>
                  {/* Decorative floating elements */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: -20,
                      right: -20,
                      width: 100,
                      height: 100,
                      borderRadius: '50%',
                      background: `radial-gradient(circle, ${alpha(theme.palette.primary.main, 0.1)}, transparent)`,
                      animation: `${floatAnimation} 4s ease-in-out infinite`,
                    }}
                  />
                  <Box
                    sx={{
                      position: 'absolute',
                      bottom: -30,
                      left: -30,
                      width: 150,
                      height: 150,
                      borderRadius: '50%',
                      background: `radial-gradient(circle, ${alpha(theme.palette.secondary.main, 0.08)}, transparent)`,
                      animation: `${floatAnimation} 5s ease-in-out infinite reverse`,
                    }}
                  />
                  
                  <Paper
                    elevation={0}
                    sx={{
                      position: 'relative',
                      borderRadius: 4,
                      overflow: 'hidden',
                      background: `linear-gradient(135deg, ${theme.palette.background.paper}, ${alpha(theme.palette.primary.main, 0.02)})`,
                      border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: `0 20px 40px ${alpha(theme.palette.primary.main, 0.15)}`,
                      },
                    }}
                  >
                    <Box sx={{ position: 'relative' }}>
                      <img
                        src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=600&h=500&fit=crop"
                        alt="Professional cleaner"
                        style={{
                          width: "100%",
                          height: "auto",
                          display: "block",
                        }}
                      />
                      {/* Overlay gradient */}
                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          right: 0,
                          height: '50%',
                          background: `linear-gradient(to top, ${alpha(theme.palette.background.paper, 0.95)}, transparent)`,
                        }}
                      />
                    </Box>
                    
                    {/* Stats overlay */}
                    <Box
                      sx={{
                        position: 'absolute',
                        bottom: 20,
                        left: 20,
                        right: 20,
                        display: 'flex',
                        gap: 2,
                        flexWrap: 'wrap',
                      }}
                    >
                      <Paper
                        elevation={0}
                        sx={{
                          px: 2,
                          py: 1,
                          borderRadius: 3,
                          bgcolor: 'rgba(255,255,255,0.95)',
                          backdropFilter: 'blur(10px)',
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                        }}
                      >
                        <VerifiedIcon sx={{ color: theme.palette.success.main, fontSize: 18 }} />
                        <Typography variant="caption" fontWeight="600">100% Satisfaction</Typography>
                      </Paper>
                      <Paper
                        elevation={0}
                        sx={{
                          px: 2,
                          py: 1,
                          borderRadius: 3,
                          bgcolor: 'rgba(255,255,255,0.95)',
                          backdropFilter: 'blur(10px)',
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                        }}
                      >
                        <SupportAgentIcon sx={{ color: theme.palette.primary.main, fontSize: 18 }} />
                        <Typography variant="caption" fontWeight="600">24/7 Support</Typography>
                      </Paper>
                    </Box>
                  </Paper>

                  {/* Floating testimonial badge */}
                  <Zoom in timeout={1200}>
                    <Paper
                      elevation={0}
                      sx={{
                        position: 'absolute',
                        bottom: 40,
                        right: -20,
                        p: 2,
                        borderRadius: 3,
                        bgcolor: 'white',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        maxWidth: 220,
                        animation: `${floatAnimation} 3s ease-in-out infinite`,
                      }}
                    >
                      <Avatar sx={{ bgcolor: theme.palette.primary.main, width: 40, height: 40 }}>
                        <StarIcon />
                      </Avatar>
                      <Box>
                        <Typography variant="body2" fontWeight="700" color="text.primary">
                          Trusted by 10,000+ Hosts
                        </Typography>
                        <Rating value={5} readOnly size="small" sx={{ fontSize: 14 }} />
                      </Box>
                    </Paper>
                  </Zoom>
                </Box>
              </Fade>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* ========== PRICING CONTROL HIGHLIGHT SECTION ========== */}
      {/* <Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 6 }}>
            <Chip
              label="💰 You're in Control"
              sx={{
                mb: 2,
                bgcolor: alpha(theme.palette.success.main, 0.1),
                color: theme.palette.success.main,
                fontWeight: 600,
              }}
            />
            <Typography
              variant="h2"
              sx={{
                fontWeight: 800,
                mb: 2,
                fontSize: { xs: "2rem", md: "2.8rem" },
              }}
            >
              Set Your Own Cleaning Fees
            </Typography>
            <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
              No forced pricing. No hidden markups. You decide what to charge guests.
            </Typography>
          </Box>

          <Grid container spacing={4}>
            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.secondary.main, 0.02)} 100%)`,
                  borderRadius: 4,
                  p: 4,
                  height: "100%",
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                }}
              >
                <PriceChangeIcon sx={{ fontSize: 48, color: theme.palette.success.main, mb: 2 }} />
                <Typography variant="h5" fontWeight="800" gutterBottom>
                  Why pricing control matters
                </Typography>
                <Stack spacing={2} sx={{ mb: 3 }}>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <VerifiedIcon sx={{ color: theme.palette.success.main }} />
                    <Typography variant="body2">Charge more during peak season, holidays, and local events</Typography>
                  </Box>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <VerifiedIcon sx={{ color: theme.palette.success.main }} />
                    <Typography variant="body2">Offer competitive rates for longer stays</Typography>
                  </Box>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <VerifiedIcon sx={{ color: theme.palette.success.main }} />
                    <Typography variant="body2">Keep your margins healthy while cleaners earn fairly</Typography>
                  </Box>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <VerifiedIcon sx={{ color: theme.palette.success.main }} />
                    <Typography variant="body2">No surprise fees - total transparency with guests</Typography>
                  </Box>
                </Stack>
                <Divider sx={{ my: 3 }} />
                <Box sx={{ textAlign: "center" }}>
                  <Typography variant="h3" fontWeight="800" color="primary.main">0%</Typography>
                  <Typography variant="body2" color="text.secondary">Platform markup on cleaning fees</Typography>
                  <Typography variant="caption">You keep everything above your cleaner's rate</Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={7}>
              <Paper elevation={0} sx={{ borderRadius: 4, overflow: "hidden", border: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
                <Box sx={{ p: 3, bgcolor: alpha(theme.palette.primary.main, 0.02), borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
                  <Typography variant="h6" fontWeight="700">Example Pricing Scenarios</Typography>
                  <Typography variant="body2" color="text.secondary">See how much margin you can keep</Typography>
                </Box>
                <Box sx={{ overflowX: "auto" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
                        <th style={{ textAlign: "left", padding: "16px" }}>Property Type</th>
                        <th style={{ textAlign: "left", padding: "16px" }}>Base Fee</th>
                        <th style={{ textAlign: "left", padding: "16px" }}>Peak Season</th>
                        <th style={{ textAlign: "left", padding: "16px" }}>Cleaner Rate</th>
                        <th style={{ textAlign: "left", padding: "16px" }}>Your Margin</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pricingExamples.map((example, idx) => (
                        <tr key={idx} style={{ borderBottom: idx < pricingExamples.length - 1 ? `1px solid ${alpha(theme.palette.divider, 0.1)}` : "none" }}>
                          <td style={{ padding: "16px", fontWeight: 600 }}>{example.type}</td>
                          <td style={{ padding: "16px" }}>{example.baseFee}</td>
                          <td style={{ padding: "16px", color: theme.palette.warning.main, fontWeight: 600 }}>{example.peakFee}</td>
                          <td style={{ padding: "16px", color: theme.palette.text.secondary }}>{example.cleanerRate}</td>
                          <td style={{ padding: "16px", color: theme.palette.success.main, fontWeight: 700 }}>+{example.margin}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Box>
                <Box sx={{ p: 3, bgcolor: alpha(theme.palette.success.main, 0.05), textAlign: "center" }}>
                  <Typography variant="caption" color="success.main" fontWeight="600">
                    💡 With 12 properties, that's an extra $240-960 per week during peak season
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box> */}

<Box sx={{ py: 10, bgcolor: theme.palette.background.paper }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 6 }}>
            <Chip
              label="💰 You're in Control"
              sx={{
                mb: 2,
                bgcolor: alpha(theme.palette.success.main, 0.1),
                color: theme.palette.success.main,
                fontWeight: 600,
              }}
            />
            <Typography
              variant="h2"
              sx={{
                fontWeight: 800,
                mb: 2,
                fontSize: { xs: "2rem", md: "2.8rem" },
              }}
            >
              Set Your Own Cleaning Fees
            </Typography>
            <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
              You decide exactly what to pay your cleaners. No hidden markups, no forced pricing.
            </Typography>
          </Box>

          <Grid container spacing={4}>
            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)} 0%, ${alpha(theme.palette.secondary.main, 0.02)} 100%)`,
                  borderRadius: 4,
                  p: 4,
                  height: "100%",
                  border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
                }}
              >
                <PriceChangeIcon sx={{ fontSize: 48, color: theme.palette.success.main, mb: 2 }} />
                <Typography variant="h5" fontWeight="800" gutterBottom>
                  Why pricing control matters
                </Typography>
                <Stack spacing={2} sx={{ mb: 3 }}>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <VerifiedIcon sx={{ color: theme.palette.success.main }} />
                    <Typography variant="body2">
                      Offer higher rates during peak season to secure your preferred cleaner
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <VerifiedIcon sx={{ color: theme.palette.success.main }} />
                    <Typography variant="body2">
                      Adjust pricing per property – studios cost less, luxury villas deserve more
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <VerifiedIcon sx={{ color: theme.palette.success.main }} />
                    <Typography variant="body2">
                      Attract top‑rated cleaners by offering competitive rates
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <VerifiedIcon sx={{ color: theme.palette.success.main }} />
                    <Typography variant="body2">
                      No minimum fees – you decide what's fair for your budget
                    </Typography>
                  </Box>
                </Stack>
                <Divider sx={{ my: 3 }} />
                <Box sx={{ textAlign: "center" }}>
                  <Typography variant="h3" fontWeight="800" color="primary.main">0%</Typography>
                  <Typography variant="body2" color="text.secondary">Platform markup on cleaner payments</Typography>
                  <Typography variant="caption">We never add hidden fees – 100% of your set fee goes to the cleaner</Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={7}>
              <Paper elevation={0} sx={{ borderRadius: 4, overflow: "hidden", border: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
                <Box sx={{ p: 3, bgcolor: alpha(theme.palette.primary.main, 0.02), borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
                  <Typography variant="h6" fontWeight="700">Example Pricing Scenarios</Typography>
                  <Typography variant="body2" color="text.secondary">Choose the right rate to attract the best cleaners</Typography>
                </Box>
                <Box sx={{ overflowX: "auto" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
                        <th style={{ textAlign: "left", padding: "16px" }}>Property Type</th>
                        <th style={{ textAlign: "left", padding: "16px" }}>Standard Offer</th>
                        <th style={{ textAlign: "left", padding: "16px" }}>Peak Season Offer</th>
                        <th style={{ textAlign: "left", padding: "16px" }}>Market Average</th>
                        <th style={{ textAlign: "left", padding: "16px" }}>Attracts Cleaners?</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ padding: "16px", fontWeight: 600 }}>Studio Apartment</td>
                        <td style={{ padding: "16px" }}>$35</td>
                        <td style={{ padding: "16px", color: theme.palette.warning.main, fontWeight: 600 }}>$45</td>
                        <td style={{ padding: "16px" }}>$40</td>
                        <td style={{ padding: "16px", color: theme.palette.success.main, fontWeight: 700 }}>✅ Yes</td>
                      </tr>
                      <tr>
                        <td style={{ padding: "16px", fontWeight: 600 }}>2‑Bedroom</td>
                        <td style={{ padding: "16px" }}>$55</td>
                        <td style={{ padding: "16px", color: theme.palette.warning.main, fontWeight: 600 }}>$70</td>
                        <td style={{ padding: "16px" }}>$60</td>
                        <td style={{ padding: "16px", color: theme.palette.success.main, fontWeight: 700 }}>✅ Yes</td>
                      </tr>
                      <tr>
                        <td style={{ padding: "16px", fontWeight: 600 }}>3‑Bedroom House</td>
                        <td style={{ padding: "16px" }}>$80</td>
                        <td style={{ padding: "16px", color: theme.palette.warning.main, fontWeight: 600 }}>$100</td>
                        <td style={{ padding: "16px" }}>$85</td>
                        <td style={{ padding: "16px", color: theme.palette.success.main, fontWeight: 700 }}>✅ Very likely</td>
                      </tr>
                      <tr>
                        <td style={{ padding: "16px", fontWeight: 600 }}>Luxury Villa</td>
                        <td style={{ padding: "16px" }}>$110</td>
                        <td style={{ padding: "16px", color: theme.palette.warning.main, fontWeight: 600 }}>$140</td>
                        <td style={{ padding: "16px" }}>$120</td>
                        <td style={{ padding: "16px", color: theme.palette.success.main, fontWeight: 700 }}>✅ Yes</td>
                      </tr>
                    </tbody>
                  </table>
                </Box>
                <Box sx={{ p: 3, bgcolor: alpha(theme.palette.success.main, 0.05), textAlign: "center" }}>
                  <Typography variant="caption" color="success.main" fontWeight="600">
                    💡 Offering just $5–10 above market average doubles your chance of getting a top‑rated cleaner
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* ========== FEATURES SECTION ========== */}
      <Box sx={{ py: 12 }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Chip
              label="✨ Powerful Features"
              sx={{
                mb: 2,
                bgcolor: alpha(theme.palette.primary.main, 0.1),
                color: theme.palette.primary.main,
                fontWeight: 600,
              }}
            />
            <Typography
              variant="h2"
              sx={{
                fontWeight: 800,
                mb: 2,
                fontSize: { xs: "2rem", md: "2.8rem" },
              }}
            >
              Everything You Need to Scale
            </Typography>
            <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
              Purpose-built for hosts who want control, automation, and peace of mind
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {features.map((feature, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Fade in timeout={500 + index * 100}>
                  <Card
                    sx={{
                      height: "100%",
                      borderRadius: 4,
                      overflow: "hidden",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-8px)",
                        boxShadow: theme.shadows[8],
                      },
                      position: "relative",
                    }}
                  >
                    {feature.highlight && (
                      <Box
                        sx={{
                          position: "absolute",
                          top: 16,
                          right: 16,
                          zIndex: 1,
                        }}
                      >
                        <Chip
                          label={feature.badge}
                          size="small"
                          sx={{
                            bgcolor: theme.palette.success.main,
                            color: "white",
                            fontWeight: 700,
                            animation: "pulse 2s infinite",
                          }}
                        />
                      </Box>
                    )}
                    <CardMedia
                      component="img"
                      height="200"
                      image={feature.image}
                      alt={feature.title}
                    />
                    <CardContent sx={{ p: 3 }}>
                      <Box
                        sx={{
                          width: 48,
                          height: 48,
                          borderRadius: "16px",
                          background: feature.gradient,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mb: 2,
                          color: "white",
                        }}
                      >
                        {React.cloneElement(feature.icon, { sx: { fontSize: 24 } })}
                      </Box>
                      <Typography variant="h6" fontWeight="800" gutterBottom>
                        {feature.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {feature.description}
                      </Typography>
                    </CardContent>
                  </Card>
                </Fade>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* ========== HOW IT WORKS ========== */}
      <Box sx={{ py: 12, bgcolor: theme.palette.background.paper }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Chip
              label="📋 Simple Setup"
              sx={{
                mb: 2,
                bgcolor: alpha(theme.palette.warning.main, 0.1),
                color: theme.palette.warning.main,
                fontWeight: 600,
              }}
            />
            <Typography
              variant="h2"
              sx={{
                fontWeight: 800,
                mb: 2,
                fontSize: { xs: "2rem", md: "2.8rem" },
              }}
            >
              Get Started in Minutes
            </Typography>
            <Typography variant="h6" sx={{ color: "text.secondary", maxWidth: "600px", mx: "auto" }}>
              No contracts. No hidden fees. Just better cleaning management.
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {steps.map((step, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Zoom in timeout={400 + index * 100}>
                  <Box sx={{ textAlign: "center" }}>
                    <Box
                      sx={{
                        position: "relative",
                        width: 80,
                        height: 80,
                        borderRadius: "24px",
                        bgcolor: alpha(theme.palette.primary.main, 0.1),
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "2rem",
                        mx: "auto",
                        mb: 2,
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          bgcolor: theme.palette.primary.main,
                          color: "white",
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          fontSize: "0.75rem",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "bold",
                        }}
                      >
                        {step.number}
                      </Typography>
                      {step.icon}
                    </Box>
                    <Typography variant="h6" fontWeight="800" gutterBottom>
                      {step.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                      {step.description}
                    </Typography>
                    <Typography variant="caption" color="primary.main" fontWeight="600">
                      {step.detail}
                    </Typography>
                  </Box>
                </Zoom>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* ========== TESTIMONIALS SECTION ========== */}
      <Box sx={{ py: 12 }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 8 }}>
            <Chip
              label="⭐ Trusted by Hosts"
              sx={{
                mb: 2,
                bgcolor: alpha(theme.palette.secondary.main, 0.1),
                color: theme.palette.secondary.main,
                fontWeight: 600,
              }}
            />
            <Typography
              variant="h2"
              sx={{
                fontWeight: 800,
                fontSize: { xs: "2rem", md: "2.8rem" },
              }}
            >
              What Hosts Are Saying
            </Typography>
          </Box>

          <Box sx={{ position: "relative", maxWidth: 1000, mx: "auto" }}>
            <IconButton
              onClick={handlePrevTestimonial}
              sx={{
                position: "absolute",
                left: { xs: -20, md: -50 },
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 2,
                bgcolor: "white",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                "&:hover": { bgcolor: theme.palette.primary.main, color: "white" },
              }}
            >
              <ChevronLeftIcon />
            </IconButton>

            <Box>
              <Card sx={{ borderRadius: 4, overflow: "hidden" }}>
                <Grid container>
                  <Grid item xs={12} md={5}>
                    <Box
                      sx={{
                        height: "100%",
                        minHeight: 350,
                        backgroundImage: `url(${testimonials[testimonialIndex].image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <CardContent sx={{ p: 4 }}>
                      <Rating value={testimonials[testimonialIndex].rating} readOnly sx={{ mb: 2 }} />
                      <FormatQuoteIcon sx={{ fontSize: 40, color: alpha(theme.palette.primary.main, 0.2), mb: 2 }} />
                      <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6, fontStyle: "italic" }}>
                        "{testimonials[testimonialIndex].comment}"
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <Avatar
                          sx={{
                            width: 56,
                            height: 56,
                            bgcolor: theme.palette.primary.main,
                            fontWeight: "bold",
                          }}
                        >
                          {testimonials[testimonialIndex].avatar}
                        </Avatar>
                        <Box>
                          <Typography variant="h6" fontWeight="800">
                            {testimonials[testimonialIndex].name}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {testimonials[testimonialIndex].role} • {testimonials[testimonialIndex].properties}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {testimonials[testimonialIndex].location}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Grid>
                </Grid>
              </Card>
            </Box>

            <IconButton
              onClick={handleNextTestimonial}
              sx={{
                position: "absolute",
                right: { xs: -20, md: -50 },
                top: "50%",
                transform: "translateY(-50%)",
                zIndex: 2,
                bgcolor: "white",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                "&:hover": { bgcolor: theme.palette.primary.main, color: "white" },
              }}
            >
              <ChevronRightIcon />
            </IconButton>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 4 }}>
            {testimonials.map((_, index) => (
              <Box
                key={index}
                onClick={() => setTestimonialIndex(index)}
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  cursor: "pointer",
                  bgcolor: index === testimonialIndex ? theme.palette.primary.main : alpha(theme.palette.primary.main, 0.3),
                  transition: "all 0.3s ease",
                }}
              />
            ))}
          </Box>
        </Container>
      </Box>

      {/* ========== FINAL CTA ========== */}
      <Box
        sx={{
          py: 12,
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Container maxWidth="md">
          <Box sx={{ textAlign: "center", position: "relative", zIndex: 2 }}>
            <AutoAwesomeIcon sx={{ fontSize: 56, mb: 3, color: "#FFE66D" }} />
            <Typography
              variant="h2"
              sx={{
                fontWeight: 800,
                mb: 3,
                fontSize: { xs: "2rem", md: "3rem" },
                color: "white",
              }}
            >
              Ready to Take Control?
            </Typography>
            <Typography
              variant="h6"
              sx={{
                mb: 4,
                color: alpha(theme.palette.common.white, 0.9),
                maxWidth: "500px",
                mx: "auto",
              }}
            >
              Join thousands of hosts who've automated their turnovers, set their own prices, and regained their peace of mind.
            </Typography>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center">
              <Button
                variant="contained"
                size="large"
                startIcon={<AutoAwesomeIcon />}
                sx={{
                  px: 5,
                  py: 2,
                  fontSize: "1.1rem",
                  bgcolor: "white",
                  color: theme.palette.primary.main,
                  borderRadius: "50px",
                  fontWeight: 800,
                  "&:hover": {
                    bgcolor: alpha(theme.palette.common.white, 0.9),
                    transform: "translateY(-2px)",
                  },
                }}
              >
                Start Free Trial
              </Button>
              <Button
                variant="outlined"
                size="large"
                startIcon={<PlayCircleIcon />}
                sx={{
                  px: 5,
                  py: 2,
                  fontSize: "1.1rem",
                  borderColor: "white",
                  color: "white",
                  borderRadius: "50px",
                  fontWeight: 600,
                  "&:hover": {
                    bgcolor: alpha(theme.palette.common.white, 0.1),
                    transform: "translateY(-2px)",
                  },
                }}
              >
                Watch Demo
              </Button>
            </Stack>
            <Typography variant="body2" sx={{ mt: 4, color: alpha(theme.palette.common.white, 0.7) }}>
              No credit card required • Cancel anytime • 14-day free trial
            </Typography>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Home;